import {
  Badge,
  Link,
  ListItem,
  OrderedList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import LocalizedStrings from "react-localization";
import { TutorialModalLink } from "../components/TutorialModalTrigger";

// import {/*GoVerified, */GoUnverified} from 'react-icons/go';
import { mailAddressSuffix } from "../common/constants";
// const BLOCKCHAIN_NAME_CAMEL = 'Avalanche';
const BLOCKCHAIN_NAME_CAMEL = "ICP";

// const BLOCKCHAIN_NAME_LOWERCASED = 'ethereum';
const MAINNET_NAME = "Mainnet";
const TESTNET_NAME = "Fuji";
const DEFAULT_NET_NAME = TESTNET_NAME;
const COIN_SYMBOL = "AVAX"; // ETH
// https://Sepoliafaucet.com
const FAUCET_URL = "https://faucet.avax.network/";
const browserName = (function (agent) {
  switch (true) {
    case agent.indexOf("edge") > -1:
      return "MS Edge";
    case agent.indexOf("edg/") > -1:
      return "Edge (chromium based)";
    case agent.indexOf("opr") > -1 && !!window.opr:
      return "Opera";
    case agent.indexOf("chrome") > -1 && !!window.chrome:
      return "Chrome";
    case agent.indexOf("trident") > -1:
      return "MS IE";
    case agent.indexOf("firefox") > -1:
      return "Mozilla Firefox";
    case agent.indexOf("safari") > -1:
      return "Safari";
    default:
      return "other";
  }
})(window.navigator.userAgent.toLowerCase());
if (!window.localizedStrings) {
  const localizedStrings = new LocalizedStrings({
    en: {
      appName: "PlexiMail",
      error: {
        rpc: {
          "-32002":
            "Your request is queued behind a pending one for your wallet, which may be hidden beneath other windows. Recover your wallet app and clear the pending entries first.",
        },
        client: {
          miss_param: "Missing data parameter",
          miss_signature: "Missing signature parameter",
          invalid_signature: "Invalid signature",
          not_in_blockchain: " not found in blockchain",
          name_empty: "Name must not be empty",
          email_empty: "Invalid PlexiMail address",
          contact_already_existed: "Contact entry already exists",
          invalid_signal_message: "SysError (Invalid Signal message)",
          invalid_message_type: "SysError (Invalid message type)",
          prekey_message_not_found: "SysError (PreKey message Not Found)",
          enc_data_undefined: "SysError (Encryption data not found)",
          enc_data_null: "SysError (Encryption data not found)",
          unsupported_data_type_1: "data type ",
          unsupported_data_type_2: " is unsupported",
          plaintext_null: "SysError (Encryption data must not be null)",
          failed_clear_cache: "SysError (Failed to clear the cache)",
          lost_conn: "Connection lost",
          ws_not_ready: "SysError (Web socket not ready)",
          att_not_bob: "SysError (attachment is not of Blob type)",
          enckey_bundle_not_found: "SysError (EncryptionKey Bundle not found)",
          enckey_for_att_not_found_1: "SysError (EncryptionKey for attachment ",
          enckey_for_att_not_found_2: " not found)",
          enckey_for_msg_not_found_1: 'SysError (Encryption Key for message "',
          enckey_for_msg_not_found_2: '" not found)',
          metamask_not_installed: "MetaMask not installed",
          wallet_not_found: "Wallet not found",
          idkey_not_found: "SysError (Identity key-pair not found)",
          devid_lost: "Device ID not found",
          regid_lost: "Registration ID not found",
          idkey_lost: "Identity key-pair not found",
          msg_is_null: "Message must not be empty",
          unsupported_msg_type: "Unsupported message type",
          file_not_found: "File not found ",
          timeout_retry: "Error or timeout: click to retry or exit for now.",
          idkey_not_identical: "Identity Keys not matching",
          account_not_in_blockchain: "Account not found on blockchain",
          need_a_subscription: "You need to subscribe to PlexiSign to continue using it",
          attachment_size_exceeded: 'Attachment size exceeds the 100MB limit',
        },
      },
      common: {
        message: {
          prepare_env: "Checking environment...",
          supply_prekeys: "Supply prekeys...",
          generate_keys:
            "Generating Identity Key, registration id, and prekeys...",
          save_prekey: "Storing PreKey bundle into cloud...",
          save_idkey: "Saving Identity Key into smart contract...",
          wait_tx_receipt: "Wait for transaction receipt...",
          save_signal: "Saving signal protocol store...",
          completed: "Completed!",
          wallet_is_backup:
            "Your self-managed account has been generated and your PlexiMail identities created.",
          wallet_safe_smart_contract:
            "Your wallet is securely stored in your private storage. Its corresponding PlexiMail Identity is registered on the ICP blockchain for self-managed and anonymous auditability. Remember to safeguard your double locks. Explore Settings to choose additional security and audit options.",
          checking_balance: `Checking ${COIN_SYMBOL} account balance...`,
          wait_funds: "pending on the external funding actions ...",
          incorrect_password: "PIN Code is incorrect",
          init_web3_storage: "Initializing Storage...",
          backup_wallet: "Backup your wallet ...",
          sync_folders: "Syncing folders...",
          create_wallet: "Creating wallet...",
          recover_wallet: "Recovering wallet...",
          acquire_storage: "Acquiring storage...",
          config_storage: "Configuring storage...",
          initial_signal: "Initializing signal environment...",
          completed_initialization: "Initialization completed, saving data.",
          retrieve_folder: "Retrieving folders...",
          recover_signal: "Recovering signal...",
          completed_recovery: "Recovery successful, saving data.",
          sign_in_with_ii: "Signing in with Internet Identity..."

        },
        learn_more: "Learn more",
        retry: "Retry"
      },
      tips: {
        tip0: "Your identity has been verified by ICP who is a partner with PlexiSign in initiating, processing, completing and managing your digital signature workflows.",
        tip1: 'The "All" folder contains all digital contract workflows and processes you’ve initiated in any state from initiated to completed. Anything you’ve archived will only appear in the "Secure Archiving" folder.',
        tip2: "The \"Initiated\" folder contains all digital contract workflows and processes that you’ve initiated but have not progressed to or beyond the Signing Round stage.",
        tip3: "The \"Signing Round\" folder contains all digital contract workflows and processes you’ve initiated and progressed to the Signing Round stage. Any other in-progress workflows (not yet moved to the Signing Round) will appear in the \"Initiated\", \"Completed\", or \"Secure Archiving\" folders — depending on their current status or whether you’ve archived them.",
        tip4: "“The \"Completed\" folder contains all digital contract workflows and processes that you’ve initiated and that have been completed. Any others that are in process will appear in either the \"Initiated\", \"Signing Round\", or \"Secure Archiving\" folders depending on their current state or if you’ve archived things.",
        tip5: "The \"Secure Archiving\" folder contains all digital contract workflows and processes you’ve manually archived. These items (which can be in any state at the time of archiving) will be removed from their original folder. Any in-progress workflows/processes that haven’t been archived will appear in the \"Initiated\", \"Signing Round\", or \"Completed\" folders — based on their current status.",
        tip6: "Launches a new digital signature workflow by bringing up the email client - ready to be populated and configured.",
        tip7: "The Advanced option enables you to manage your security settings.",
        tip8: "The Main dropdown menu enables the user to manage \"My Account\" and the \"Global Settings\" when using PlexiSign. My Account includes viewing or managing your PlexiSign address(es), your Contacts you’ve been working with and your security settings. Global settings include managing your access and data.",
        tip9: "In the Settings you can manage your data or update your PIN code for use when locking your screen.",
        tip10: "Exit will log you out of PlexiSign completely requiring you to provide your identity and passkey (stored on your computer) the next time you restart PlexiSign. Your \"Identity\" is the multi-digit number you created and were asked to save during your setup.",
        tip11: "Lock Your Screen will return your screen to the locked state without exiting your session. You can enter PlexiSign from this state by unlocking your screen with your 6 digit PIN code.",
        tip12: "Enterprise Dashboard",
        tip13: "Contacts helps you search through and find any of the email addresses you’ve used when initiating and managing digital signature workflows and processes.",
        tip14: "Help",
        tip15: "Profile",
        get_credits: "Get $15 Credits"
      },
      app: {
        mode: {
          unverified: "Unverified",
          verified: "Verified by ICP",
        },
        privacy_level: {
          standard: "Standard Privacy",
          high: "High Privacy",
        },
        message: {
          ready: "Ready!",
          new_message: "New incoming messages!",
          prepare_signal: "Preparing signal environment...",
          check_prekeys: "Checking prekeys. Please wait...",
          generate_prekeys: "Generating prekeys. Please wait...",
          save_prekeys: "Saving prekeys. Please wait...",
          load_contact: "Loading contacts. Please wait...",
          load_messages: "Loading PlexiMails. Please wait...",
        },
        dialog: {
          contract_intro: {
            title: "Signature Round",
            content1: "Ready to initiate the Signature Round to execute the agreement:",
            content2: "This wizard simplifies initiating the signature round for your agreement with all participants. As the moderator, you can use the provided example cover letter to guide them through the signing process. Additionally, you can leverage the \"Templates\" button at the end to save, select, or create your own cover letter from your collections. The cover letter is customizable! Personalize it by filling in or removing the bracketed placeholders (e.g., {{Client Name}}) or merge fields as appropriate.",
            content3: "Here's what you'll need to do:",
            content4: `<strong>Provide Participant Information: </strong>Since
                    everyone involved is currently unidentified, please enter the
                    necessary contact details for each participant. This will
                    include some Personally Identifiable Information (PII) like
                    names and email addresses.`,
            content5: `<strong>2-Factor Authentication (Optional): </strong>For added
                    security, PlexiSign can assist with sending 2FA codes to
                    participants' mobile phones or email addresses if you choose
                    to enable it.`,
            content6: `<strong>Attach all contract materials individually </strong> using the "Attach" button for their final review and signature.`,
            content7: "Benefits of Participant Information:",
            content8: `<strong>Faster Signing Process: </strong>Having accurate
                    contact information ensures everyone receives the signing
                    notification promptly.`,
            content9: `<strong>Enhanced Security: </strong>By providing contact
                    details, you can verify the identity of each participant
                    before signing, reducing the risk of fraudulent actions.`,
            content10: `Let's Get Started!`,
            next: "Next",
            cancel: "Cancel"
            
          },
          private_key: {
            lighthouse_for_storing_pleximail: "Lighthouse for Storing PlexiMail",
            lighthouse_for_backup_pleximail: "Lighthouse for Backup PlexiMail",
          },
          delete_account: { 
            title: "Delete My PlexiMail Account",
            description: "All data produced by this account will be permanently erased from the canisters.",
            cancel: "Cancel",
            delete: "Delete",
            deleting: "Deleting...",
            please_try_again_later: "Please try again later.",
            failed_to_delete: "Failed to delete account"
          },
          search: {
            title: "Search Messages",
            tips: "Search helps you find the messages you’ve sent using keyword matching rather than navigating through your folders manually.",
            search: "Search",
            noResults: "No Results",
            noBackup: "No Backup",
            keyword_length_100: 'Keyword must not exceed 100 characters.',
            scope: "Scope: ",
            from: "From: ",
            to: "To",
            subject: "Subject: ",
            all: "all: ",
            from1: "From",
            select_date_and_time: "Select Date and Time",
            searching: "Searching...",
          },
          ask_pwd: {
            title: "Passcode is required",
            description:
              "The message is encrypted and requires a passcode to unlock, which will be sent to you via SMS or another secure delivery path per prior arrangement. If you possess the passcode, click the button below to unlock the message.",
            passcode_label: "Please enter passcode here",
            passcode_placeholder: "xxxx xxxx xxxx xxxx",
            next: "Next",
            cancel: "Cancel",
          },
          faucet: {
            title: "Activate Self-Managed Account",
            message: {
              back: "Please fill your wallet with sufficient cryptos before resuming this configuration process.",
            },
            content: {
              paragraph1:
                "You have successfully created a PlexiMail wallet for maintaining your PlexiMail identity and acquired your Web3 storage. Now you need to register a secured set of contact parameters through the PlexiMail Smart Contract for your partners to reach you when allowed. Additionally, all your asynchronous messaging context will be encapsulated in a configuration database, also stored in your Web3 storage and doubly locked. To enable this self-managed PlexiMail account, you will be asked to:",
              paragraph2: {
                item0: "Fund your wallet with cryptos if you opt to register with PlexiMail Smart Contract to maximize protection.",
                item1: "Provide the double locks to protect your configuration."
              },
              paragraph3: `Note: PlexiMail is free only in the sense that this PlexiMail software is freely offered for non-commercial use, but the incurred consumables, like electricity, computing power, traditional disk storage, RAM, printer, ink, Internet connectivity, etc., are not. As a Web3 dApp running on ${BLOCKCHAIN_NAME_CAMEL} blockchain, it consumes "${BLOCKCHAIN_NAME_CAMEL} gas" for running the smart contract, which is the charge by the ${BLOCKCHAIN_NAME_CAMEL} for your consumption of its computational resources. The initial smart contract run costs gas and a nominal charge of $.0001 per sent email is assessed to thwart DDOS when deemed necessary.`,
            },
            button: {
              get_coins: "Enter Smart Contract",
              buy_with_ecash:
                "Activate the contract with anonymized Plexi Tokens",
              redeem_promo_code: "Activate the contract with Promo Code",
              buy: "Activate the contract through a crypto exchange",
              get: "Activate",
              email: "Activate by sending a request",
              show_wallet: "Show Wallet",
            },
          },
          kickout: {
            title: "App has been reset",
            message:
              "Since you have already signed in on another device, the data on this device has been cleared.",
            quit: "Quit",
          },
          af_faucet: {
            title: "Apply for Test Coins",
            description:
              "Enter email address to see if you qualify for the promotional PlexiMail start-up test coins:",
            description2:
              "A confirmation email will be sent to the mailbox entered to validate your email address.",
            email: "Email Address",
            email_placeholder: "Please enter email here",
            cancel: "Cancel",
            request: "Request",
            menu_item: "Get Test Coins with Email",
            note: "* Alternatively, you can get test coins yourself directly from",
          },
          exit_setup: {
            title: "Are you sure you want to exit the configuration wizard ?",
            message: "This wizard will start over if you exit.",
            cancel: "Cancel",
            exit: "Exit",
          },
          promo_code: {
            title: "Redeem a Promo Code",
            description: `Enter your one-time Promo Code (optional) to try out with external resources from a shared pool, like ${COIN_SYMBOL} cryptos for testnet and an API Token for Web3 cloud storage, without configuring them in yourself. Some restrictions apply.`,
            cancel: "Cancel",
            redeem: "Redeem",
            waiting: "Waiting for Transaction Receipt ...",
            redeeming: "Redeeming Promo Code ...",
            rejected: "Transaction is rejected",
            redeemed: "Promo Code has been redeemed.",
          },
          address_verify_popup: {
            verified: {
              title: "Verified by ICP",
              message:
                "The recipient has been verified to own the PlexiMail address registered through the PlexiMail Smart Contract.",
              sender_message:
                "The sender has been verified to own the PlexiMail address registered through the PlexiMail Smart Contract.",
              self_message:
                'Your PlexiMail Address is currently in the "Verified by ICP" status. No additional authentication is required, and you can enjoy the advantages of registering with the PlexiMail Smart Contract.',
            },
            unverified: {
              title: "Unverified",
              message:
                "The ownership of the recipient's address is not verifiable through the PlexiMail Smart Contract. ",
              sender_message:
                "The ownership of the sender's address is not verifiable through the PlexiMail Smart Contract. ",
              self_message:
                'Your PlexiMail Address is currently in the "Unverified" status, placing additional burden on your partners to authenticate you with the advantages provided by registering with the PlexiMail Smart Contract.',
            },
            warning: {
              trigger: "Skip Smart Contract",
              confirmation: "I understand the risk",
              title: "Skip Smart Contract",
              message:
                "You can store your Identity Key on the blockchain to significantly reduce the risk of identity theft, although it comes with the associated cost around $1 of registering through the smart contract on Avalanche. You can always create multiple accounts and choose a separate option for each account based on its assessed level of risk. ",
            },
          },
          activate_account: {
            trigger: "Register with Smart Contract",
            get_start: {
              title: "Register",
              description: "You haven't been verified to own the PlexiMail address by registering with the PlexiMail Smart Contract.",
              description_upgrade: "You haven't been verified to own the PlexiMail address by registering with the PlexiMail Smart Contract on the Mainnet.",
              button: {
                cancel: "Cancel",
                next: "Register",
                upgrade: "Upgrade",
              },
            },
            select_network: {
              title: "Select Blockchain",
              description:
                "PlexiMail adopts the self-executing smart contract to register and protect the PlexiMail addresses/identities. Once registered, the authenticity of a PlexiMail identity becomes auditable without a central authority and inalterable without owning the private key.",
              mainnet: "Mainnet",
              mainnet_note:
                "* Pay AVAX crypto to register your PlexiMail addresses on the Avalanche Mainnet.",
              testnet: "Testnet",
              testnet_note:
                "* Conduct a test run on the Fuji Testnet without incurring AVAX charges. Your PlexiMail addresses are not fully protected in this case. You may upgrade your run to the Mainnet later.",
              button: {
                back: "Back",
                next: "Next",
              },
            },
            check_balance: {
              title: "Fund the Registration",
              message: {
                back: "Please ensure that your wallet is filled with sufficient cryptocurrencies before resuming this configuration process.",
                no_enough_eth: `Not enough ${COIN_SYMBOL} in your wallet to register your identity with the Smart Contract. Click "Buy ${COIN_SYMBOL}" to refill your wallet.`,
                ready:
                  'Click "Next" to publish your PlexiMail address with PlexiMail Smart Contract.',
              },
              description: {
                line1: "For your partners to reach you when allowed and for trustless auditability, you need to register a secured set of contact parameters through the PlexiMail Smart Contract.",
                line2: "It costs transaction fees in cryptos to register with the Smart Contract in order to maximize the protection of your PlexiMail identities."
              },
              button: {
                back: "Back",
                previous: "Previous",
                next: "Next",
                check: "Check Balance",
              },
              menu: {
                trigger: `Buy ${COIN_SYMBOL}`,
                items: {
                  token: `Buy ${COIN_SYMBOL} with Plexi tokens`,
                  exchange: `Buy ${COIN_SYMBOL} with Exchange`,
                  email: "Request Test Coin through Email",
                },
              },
            },
            save_idkey: {
              title: "Save Identity Key through Smart Contract",
              description: {
                line1: "We adopt the Signal Protocol to protect your end-to-end communication sessions. Your PlexiMail addresses are bound to the private keys in your wallet at this step, which spawns a full spectrum of session keys and other security parameters as per situations.",
                line2: `You may need to sign the confirmation transaction pop-up with keys from your ${BLOCKCHAIN_NAME_CAMEL} wallet.`
              },
              button: {
                previous: "Previous",
                next: "Next",
              },
            },
            wait_receipt: {
              title: "Waiting For Transaction Receipt",
              description: `Your PlexiMail address and session data are safeguarded on the ${BLOCKCHAIN_NAME_CAMEL} Blockchain through a Smart Contract. Please wait until this process completes.`,
              high_privacy_warning: `
                    Clicking "Done" will refresh the web page. Since the
                    application is currently running at a high privacy level,
                    you can only return to this account through "Recovery" after
                    the web page has been reloaded.`,
              button: {
                previous: "Previous",
                next: "Done",
              },
              message: {
                checking: "Checking transaction receipt... ",
                failed:
                  "Failed to get the transaction receipt. Please try again later.",
                confirmed: "Transaction has been confirmed",
              },
            },
          },
          indexeddb: {
            tor: {
              title: "Tor browser is not yet supported",
              description: `PlexiMail cannot run in Tor Browser because it doesn't support
                  indexeddb by default. If you want the get the private that tor
                  browser brings, it is recommended to visit PlexiMail in `,
              brave: "Brave"
            },
            normal: {
              title: "Current browser is not yet support",
              description: `PlexiMail cannot run in current browser because it doesn't
                  support indexeddb. It is recommended to visit PlexiMail in `,
              chrome: "Chrome"
            },
          },
          privacy_level: {
            title: "Privacy Level",
            description:
              "Usability and privacy often involve a trade-off, as higher privacy measures can result in a less user-friendly experience. We offer two privacy levels to accommodate different preferences:",
            tor_warning: 'Tor browser only supports "High" Level of privacy',
            normal_warning:
              'The current browser only supports the "High" Level of privacy.',
            level: {
              standard: {
                title: "Standard",
                description:
                  "The data generated by PlexiMail will be encrypted and stored in the browser's built-in database, persisting until the user exits.",
              },
              high: {
                title: "High",
                description:
                  "The data generated by PlexiMail will only exist in memory at runtime.",
              },
            },
            error: {
              cancelled: "Cancelled",
            },
            button: {
              cancel: "Cancel",
              confirm: "Confirm",
            },
          },
        },
      },
      home: {
        help: "Help",
        // slide.1.paragraph.1
        tab: {
          "individual": "Individual",
          "business": "Business",
        },
        promotion: {
          title: "Digital Signature Workflow Using Web Email",
          content: {
            paragraph1: " - Secure",
            paragraph2: " - Professional",
            paragraph3: " - Affordable",
            paragraph4: " - Open-Source and Forever Free **",
          },
        },
        signIn: {
          title_1: "The",
          zero: "Zero",
          title_2: "Trace Email",
          description_1:
            "Distributed, Permissionless, Traceless and Invisible. ",
          description_2: `You can only reach your partners on the same network. The default is "${DEFAULT_NET_NAME}", a test network displayed on the upper right corner. You may change your network to "${MAINNET_NAME}", the primary public ${BLOCKCHAIN_NAME_CAMEL} blockchain network, or any other test network listed.`,
          description_3:
            "Log in or register for a new PlexiMail Identity. This secure, anonymized technology safeguards your PlexiMail addresses and private keys on the transparent and secure ICP blockchain. It further minimizes data trails by cloaking all metadata, reinforcing strong anonymity for private communication.  ",
          description_3_continue:
            "Generating a new PlexiMail account/address or importing from another wallet involves multiple steps. Kindly answer prompts patiently until completion.  ",
          note: {
            text: "** Press the \"Enter\" below only if you agree with the ",
            link: "PlexiMail Terms & Privacy Policy"
          },
          note_continue: {
            text: `** Press the "Continue" below only if you agree with the`,
            link: "PlexiMail Terms & Privacy Policy"
          },
          button: "Enter with Internet Identity",
          one_click_resume: "1-Click Resume",
          try_live_demo: `Try Live Demo (${TESTNET_NAME})`,
          reset: "Start Over",
          resume: "Resume with Internet Identity",
          continue: "Continue with Internet Identity",
          incomplete_setup_detected:
            "Your previous configuration session did not complete. Recover it or start afresh?",
          switch_wallet: "Switch Account",
        },
        business: {
          title_1: "The",
          zero: "Zero",
          title_2: "Trace Business",
          description_1:
            "Simple, encrypted solutions to protect your business.",
          description_2:
            "Advanced protection for your company’s emails, calendars, passwords, network, and more with our suite of secure business apps.",
          
          note: {
            text: "** Press the \"Enter\" below only if you agree with the ",
            link: "PlexiMail Terms & Privacy Policy"
          },
          note_continue: {
            text: `** Press the "Continue" below only if you agree with the`,
            link: "PlexiMail Terms & Privacy Policy"
          }
        },
        unlock: {
          title: "Unlock with Password",
          title_pin: "Unlock with PIN Code",
          unlocking: "Unlocking...",
          idle_timeout: "To unlock your cached session after an idle timeout",
          button: {
            unlock: "Unlock",
            forgot: "Forgot PIN or Reset?",
            switch_wallet: "Switch Account",
          },
        },
        dialog: {
          reset: {
            title: "Forgot the PIN",
            content: {
              paragraph1:
                "Your previous email context maintained locally is only recoverable with the correct PIN.",
              paragraph2:
                'Press "Reset" to clear local cache in order to re-enter with your Crypton keys. A new entry allows PIN code reset.',
            },
            button: {
              cancel: "Cancel",
              reset: "Reset",
            },
            message: {},
          },
          unsupported: {
            title: browserName + " is not yet supported",
            content: {
              paragraph1: "Only the following browsers are supported now:",
              paragraph2: "Brave (Recommended)",
              paragraph3: "Chrome",
              paragraph4: "Edge",
              paragraph5: "Firefox",
            },
            button: {},
          },
          notReady: {
            title: "PlexiMail requires MetaMask and Web3Storage",
            content: {
              paragraph1:
                "You are about to enter into PlexiMail, the most advanced secure email dApp, enabled by the advent of Blockchain technology. You must first install a cryptocurrency wallet (MetaMask) and make available certain amount of cloud storage (Web3Storage).",
              paragraph2:
                "NOTE: Both MetaMask and Web3.Storage are well-trusted open source Web3 services. We hesitate to integrate them into our PlexiMail baseline to avoid muddying the water of their trustworthiness. They are also an ideal introduction to the brave new world of Web3 dApps. Please return here to try your free PlexiMail after the successful completion of their installation.",
              paragraph3:
                "You can skip this tutorial if you are an experienced web3 practitioner, otherwise we advise that you read through it.",
            },
            button: {
              skip: "Skip Tutorial",
              read: "Read Tutorial",
            },
          },
          walletNotFound: {
            title: "MetaMask Wallet not Found",
            content: {
              paragraph1: `PlexiMail addresses are converted from your public keys associated with your ${BLOCKCHAIN_NAME_CAMEL} accounts, jointly managed with the MetaMask wallet. You need to fund those accounts with cryptocurrencies, as the email logic conducted through the PlexiMail Smart Contract incur charges in ${COIN_SYMBOL} tokens. All transactions through the Smart Contract require your confirmation ("Confirm" or "Sign") in the MetaMask app. You and your partners may select one of the test networks to practice, by expanding the default network displayed on the upper-right corner of the MetaMask and enabling "Show/hide test networks". We suggest ${TESTNET_NAME} for testing. Go to ${FAUCET_URL} to request for test coins. `,
            },
            button: {
              read: {
                title: "Read Tutorial",
              },
              install: {
                title: "Install MetaMask",
                confirm: {
                  title: "Install MetaMask",
                  content:
                    "Please refresh this webpage to proceed to the next step after MetaMask installation",
                  button: "Install MetaMask",
                },
              },
            },
          },
          confirm: {
            checkbox: {
              title:
                "I'm about to pause and switch to an external application temporarily. I can come back to resume this configuration process.",
            },
            cancel: "Cancel",
          },
          tutorial: {
            slide1: {
              title: "PlexiMail",
              subtitle: "A Web3 Secure eMail dApp",
              content: {
                paragraph1_1:
                  "PlexiMail is a Web3 dApp (decentralized App). This is only one of the Web3 applications we offer. Please visit ",
                paragraph1_2: " for our Counterseal mobile app, or ",
                paragraph1_3: " for the general background about us.",
                paragraph2:
                  'A longer and more detailed write-up can be found by clicking on the "?" box in the lower right-hand corner of the screen.',
              },
              button: {},
            },
            slide2: {
              title: `If you are not paying, you're the product.`,
              content: {
                paragraph1:
                  "Web2 refers to the version of the Internet most of us know today, dominated by companies that provide services for free in exchange for our personal data. The terms of the exchange are typically shrouded in arcane language to satisfy the minimal legal requirements. Our personal data are collected through sophisticated surveillance technology that knows no bounds and leaves no trace. All popular free services, such as Facebook, Twitter, Google, Outlook, WeChat, Telegram, etc. are top  examples of Web2 applications deeply rooted in Surveillance Capitalism. It is a \"cattle farm\" model designed for smooth onboarding and subsequent exploitation of the unsuspecting. We are being unwittingly turned into products right before our eyes.",
              },
              button: {},
            },
            slide3: {
              title: "Surveillance Capitalism",
              content: {
                paragraph1:
                  "Web3 grows out of the chilling realization of our being herded around like cattles for the financial gains of those Web2 big techs. No amount of privacy regulations will save us from their predatory practices. There is no alternative but to revolt against this repressing \"cattle farm\" environment underlying the Internet at large. We need a fresh start. This is how the Web3 framework came about, fueled by Blockchain technology and tokenized cloud storage. ",
              },
              button: {},
            },
            slide4: {
              title: "No More Free Feeds",
              content: {
                paragraph1:
                  "One thing for certain, to \"live dangerously\" and independently off the grid of Web2 implies that individuals must get more involved. At minimum, we have to correct our distorted concept of privacy and security purportedly offered by service providers, which requires us to educate ourselves what the security protection is truly about. We are then confronted with the resource issues - How and where can we get our data storage, processing power and service platforms? It turns out that help is actually around the corner.",
              },
              button: {},
            },
            slide5: {
              title: "Self Sufficiency Under Web3",
              content: {
                table: "removed",
                paragraph1: `Weaned off those free services, the items in red above become your responsibility. You must create and protect your digital identities in order to enter the Smart Contract on the ${BLOCKCHAIN_NAME_CAMEL} blockchain. Your IDs are derived from your blockchain addresses in your <strong>MetaMask Wallet</strong>, further protected by a password as the second factor of security. You own your private cloud storage allocated to you by <strong>Web3Storage</strong>, a tokenized storage service offered by Filecoin.`,
              },
              button: {},
            },
            slide6: {
              title: "ePostcard and Metadata",
              content: {
                paragraph1:
                  "Under Web3, you are in charge of your own identity. This is important, because traditional emails are like ePostcards, where the identities of all parties are out in the open. This is problematic, particularly because email communications often involve sensitive, private matters. Further, metadata in your emails expose you to exploitation by dark actors.",
              },
              button: {},
            },
            slide7: {
              title: "Anonymity and Privacy",
              content: {
                paragraph1: `PlexiMail translates your ${BLOCKCHAIN_NAME_CAMEL} addresses into PlexiMail addresses with "${mailAddressSuffix()}" as the domain name, protected by their private keys securely stored in the <strong>MetaMask Wallet</strong> held only by the owner that they represent. The identities of sender/recipients are thus anonymized and not relatable to any PII (Personally Identifiable Information). Functionally, they are secured by self-issued/managed digital assets (key pair in the wallet) like SSL certificates. These somewhat unwieldy PlexiMail addresses can be better managed by adding them to your existing or new ‘Contacts’. Note that those "Contacts" are maintained locally in the owner's environment and not copied into the mail content.`,
                paragraph2:
                  "NOTE: Even the wallet addresses can be anonymized. We will be offering such a service.",
              },
              button: {},
            },
            slide8: {
              title: "Guaranteed Anonymity",
              content: {
                paragraph1:
                  "This is how an end-to-end encrypted session is established by traversing the PlexiMail <strong>Smart Contract</strong>, trust-minimized <strong>Registry & Notification Forwarder</strong> and individualized <strong>cloud Web3Storage</strong>. The gory details are on the next page.",
              },
              button: {},
            },
            slide9: {
              title: "Guaranteed Anonymity",
              content: {
                paragraph1: `1. Alice and Bob both register their addresses from their wallets and server selection from multiple candidate servers,  through PlexiMail smart contract on ${BLOCKCHAIN_NAME_CAMEL} blockchain.`,
                paragraph2:
                  "2. Alice selects and preps the pre-key store onto the selected registry server.",
                paragraph3:
                  "3. Alice/Bob privately exchange their PlexiMail addresses \"out of band\" in preparation for the person-to-person TOFU (Trust On First Use) process later, which ties their identities with their respective stealth addresses.",
                paragraph4: `4. Prior to Bob’s sending a Mail to Alice for the first time, he retrieves all relevant data regarding Alice from the ${BLOCKCHAIN_NAME_CAMEL} data store and the Registry. He then asynchronously negotiates an end-to-end Signal encryption session with Alice, who need not to be online.`,
                paragraph5:
                  "5. Bob places his mail content in his own private Web3Storage and pushes his notification to Alice, with the decryption key authorized only to Alice.",
                paragraph6:
                  "6. On notice, Alice retrieves the content from Bob’s private storage. She decrypts the content only after verifying the various TOFU parameters.",
              },
              button: {},
            },
            slide10: {
              title: "Running Cost",
              subtitle: "A Web3 Secure Email Service",
              content: {
                paragraph1: `PlexiMail is a free application, but its operating consumables, like electricity, computing power, traditional disk storage, RAM, printer, ink, Internet connectivity, etc., are not. As a Web3 dApp running on ${BLOCKCHAIN_NAME_CAMEL}, it consumes "${BLOCKCHAIN_NAME_CAMEL} gas", which is the charge by the ${BLOCKCHAIN_NAME_CAMEL} blockchain for your consumption of its computational resources. The initial setup costs gas and an extremely nominal charge of $.0001 per sent email is assessed to thwart DDOS. Note that there is no additional charge for oversized content (e.g., emails and attachments as large as 1 GB).`,
              },
              button: {},
            },
            slide11: {
              title: "Get Your Own Wallet & Web3Storage",
              content: {
                paragraph1:
                  "We hope you now have a better understanding of the PlexiMail framework. To obtain PlexiMail ++, please install MetaMask and apply for the Web3 cloud storage from the Web3storage site, as prompted in the following pages. ",
              },
              button: {},
            },
            slide12: {
              title: "",
              content: {
                paragraph1: `PlexiMail utilizes your own private Web3.Storage for your email repository. In the past, storing data on the decentralized web wasn't always easy — but that's where web3.storage comes in. Most data on the Internet today is hosted by massive storage providers like Amazon, Google, and Microsoft. This makes it simpler for developers to store application data, but big corporate platforms like these create silos by locking developers and users alike into walled gardens of services. What's more, as the market continues to consolidate, a small oligopoly of providers are essentially becoming the storage backbone of the internet. `,
                paragraph2:
                  'Get yourself first 5 GB for free by clicking the "Get" button blow. Extract the "Account" -> "<strong>API Token</strong>" from your Web3Storage dashboard when done and get back here to prepare for the PlexiMail configuration later.',
              },
              button: {
                get: {
                  title: "Get Web3.Storage",
                  confirm: {
                    title: "Get Web3.Storage",
                    content:
                      "Please return here after successfully acquiring your private Web3.Storage.",
                    button: "Get Web3.Storage",
                  },
                },
              },
            },
            slide13: {
              title: "",
              content: {
                paragraph1_1: `In order to use PlexiMail, you need to establish at least one digital identity, and carry out a trustless signup through our ${BLOCKCHAIN_NAME_CAMEL} smart contract, which requires you to install the MetaMask wallet extension through your browser. Follow our`,
                paragraph1_2: ` to learn more about the various ${BLOCKCHAIN_NAME_CAMEL} network options and how to fund your wallet (faucets). If you want to practice with a test network, expand the default network displayed on the upper-right corner of MetaMask and enable "Show/hide test networks". We suggest ${DEFAULT_NET_NAME} for testing. Go to ${FAUCET_URL} to request for test coins. Please click on the "Install MetaMask" box blow to install MetaMask. `,
              },
              button: {
                install: {
                  title: "Install MetaMask",
                  confirm: {
                    title: "Install MetaMask",
                    content: "Please return here after MetaMask installation.",
                    button: "Install MetaMask",
                  },
                },
              },
            },
            slide14: {
              title: "Congratulations",
              content: {
                paragraph1:
                  "If the MetaMask has been installed and the Web3Storage acquired successfully, you are now ready to use PlexiMail. Please click on the green box below to configure PlexiMail. ",
              },
              button: {
                config: {
                  title: "Configure PlexiMail",
                },
              },
            },
          },
        },
      },
      setup_carousel: {
        go: "GO",
        intros: [{
          title: "Welcome to PlexiMail",
          text: "You're about to Sign Up with PlexiMail Here's What's Next ...",
          steps: [
            "Create your Internet Identity",
            "Create your passkey"
          ],
          text2: "A secure, privacy-focused way to log into PlexiMail without using passwords or sharing personal data."
        }, {
          title: "Welcome to PlexiSign",
          text: "You're about to Sign Up with PlexiSign Here's What's Next ...",
          steps: [
            "Create your Internet Identity",
            "Create your passkey"
          ],
          text2: "A secure, privacy-focused way to log into PlexiSign without using passwords or sharing personal data."
        }],
        cards: [
          {
            title: "Modern Blockchain Wallet",
            text: "You are the only one who can access and manage the wallet contents which includes your ICP Internet Identity that allows you to securely access the system.",
            image: "/bg.jpg",
          },
          {
            title: "Signal Protocol",
            text: "Widely respected encryption protocol for communication that continually updates encryption keys making surveillance and decryption attempts extremely difficult.",
            image: "/bg.jpg"
          },
          // {
          //   title: "Leverages Web3 Storage",
          //   text: "We enable you to manage your data yourself in a Web3 storage account further limiting access to the data you are working with and sharing with others.",
          //   image: "/bg.jpg"
          // },
          {
            title: "Internet Identity & ICP Blockchain",
            text: "PlexiSign and Pleximail are \"Trustless\" - Business services are conducted through Smart Contracts, not through a 3rd party who are open to compromise and trap doors.",
            image: "/bg.jpg"
          },
          {
            title: "Includes PlexiMail",
            text: "Secure email on the blockchain for private network emails and bridge emailing to all of the standard email systems.",
            image: "/bg.jpg"
          },
          {
            title: "Includes PlexiSign",
            text: "Secure, professional & affordable eSignature with a pay-as-you-go billing meter model.",
            image: "/bg.jpg"
          },
          {
            title: "No PII or PCI",
            text: "Our systems do not store any of your Personally Identifiable Information (PII) or Payment Card Industry data (PCI) increasing your data security profile.",
            image: "/bg.jpg"
          },
          {
            title: "Beyond GDPR & CCPA",
            text: "PlexiSign and PlexiMail don’t retain the data governed by GDPR and CCPA so you’re safe from marketing abuse.",
            image: "/bg.jpg"
          },
        ]
      },
      setup_method: {
        title: "Resume or Start Over a Configuration",
        content: {
          paragraph1:
            "Select \"Resume\" to pick up the same configuration or \"Start Over\" to create a brand new configuration for the same wallet. ",
          paragraph2:
            "Please make sure you understand that pressing the \"Start Over\" button would erase all your past emails.",
        },
        button: {
          create: {
            title: "Start Over",
          },
          restore: {
            title: "Resume",
          },
          back: {
            title: "Back",
          },
        },
      },
      backup_method: {
        // step: '1 / 4: ',
        title: "Back up Recovery Data",
        content: {
          paragraph1:
            "Your PlexiMail data are backed up by storing their root creation/recovery seeds, based on which all earlier session data and contents may be recovered from your previous backup.",
          paragraph2:
            "The backup data are fully encrypted, and are further protected by employing our Crypton technologies (patent pending).",
          paragraph3:
            "The password must be of sufficient strength to be accepted. A sentence-like passphrase works nicely.",
          paragraph4: "Steps remaining: 4/4    ",
        },
        button: {
          web3: {
            title: "Store into Your Web3Storage",
          },
          local: {
            title: "Store Locally",
          },
          back: {
            title: "Back",
          },
        },
      },
      restore_method: {
        // step: '1 / 4: ',
        title: "Retrieve Recovery Data",
        content: {
          paragraph1:
            "Your PlexiMail data are backed up by storing their root creation/recovery seeds, based on which all previous session data and contents may be recovered from your permanent Web3Storage.",
          paragraph2: "Steps remaining: 3.",
        },
        button: {
          web3: {
            title: "Retrieve from Web3.Storage",
          },
          local: {
            title: "Retrieve from Local File",
          },
          back: {
            title: "Back",
          },
        },
      },
      pwd: {
        override: {
          title: "Warning",
          message: "This Crypton already exists. Do you want to overwrite it?",
          button: {
            yes: "Yes",
            no: "No",
          },
        },
        initial: {
          step: "1 / 4: ",
          step_restore: "1 / 3",
          title: "Protecting Your Configuration Database",
          recover_title: "Unlock Your Configuration Database",
          content: {
            paragraph1_1:
              "This password is to protect your PlexiMail configuration and the full session context required for assuming your PlexiMail identity in managing all your emails. Make sure you record: 1) email used with Magic.Link 2) email used with Web3.Storage 3) this password. They are critically important for the PlexiMail backup and recovery.",
            paragraph1_2: "Please enter the protection password.",
            paragraph2:
              "The password must be of sufficient strength to be accepted. A long enough sentence-like passphrase works well.",
            // input: 'Please enter the protection password.'
          },
          tf: {
            pwd: {
              title: "Password",
            },
            confirm: {
              title: "Confirm Password",
            },
          },
          button: {
            next: {
              title: "Next",
            },
            back: {
              title: "Back",
            },
          },
        },
      },
      mnemonic: {
        generate: {
          step: "2 / 4: ",
          title: "Construct the Protection Chain",
          content: {
            paragraph1: "",
            paragraph2: "",
            // paragraph3: 'Click the mnemonic content above to copy to your clipboard.',
          },
          message: {
            copied: "Copied",
          },
          button: {
            display: { title: "Generate Mnemonic" },
            hide: { title: "Hide Mnemonic" },
            next: { title: "Next" },
            gen: { title: "Generate" },
            // gen_save: {title: 'Generate and Save Locally'},
            gen_save: { title: "Generate" },
            back: { title: "Back" },
          },
        },
        restore: {
          step: "2 / 3: ",
          title: "Restore the Protection Chain",
          content: {
            paragraph1: "",
            paragraph2: "",
            paragraph3:
              "Click the mnemonic content above to copy to your clipboard.",
          },
          mnemonic: {
            label: "Mnemonic Phrase",
            placeholder: "Mnemonic Phrase for Recovery",
          },
          button: {
            next: { title: "Next" },
            web3: { title: "Restore from Web3.Storage" },
            local: { title: "Restore from Local File" },
            back: { title: "Back" },
          },
        },
      },
      web3: {
        storage_selector: {
          title: "Configure Your Private Web3 Storage",
          recover_title: "Recover Your Private Web3 Storage",
          content: {
            line1: `Now, take control of your email privacy. Set up your own private
                email repository, free from any surveillance risks associated
                with some email providers.`,
            line2:`In the past, privately managing your own data on the
                decentralized web was challenging. However, Filecoin has emerged
                as a solution, allowing for a variety of front-end services.
                These services each support specific application models and
                offer subscription options. We currently offer two of these
                services:`,
            line3: `Offers 1GB of free storage as a starter plan, without
                requiring credit card information.`,
            line4: `Offers 5GB of free storage as a starter plan, but{" "}`,
            line5: `requires credit`,
            line6: `card information to subscribe. This service also uses public
            emails for user authentication.`,
            line7: `Visit their websites to compare options and choose the best
            provider for your needs. Be aware that additional charges apply
            after exceeding the free storage limit. Setting up Lighthouse
            requires credit card information only if you choose to exceed
            the free tier.`
          },
          lighthouse: "Lighthouse",
          web3storage: "Web3.Storage",
          sharedWeb3storage: "Shared Web3.Storage",
          back: "Back",
        },
        lighthouse: {
          step: "1 / 2:",
          title: "Configure Your Private Lighthouse Storage",
          content: `Please confirm your selection of the free Lighthouse storage plan!
              This storage is uniquely and anonymously linked to your PlexiMail
              wallet. You'll only need to provide payment information if you
              choose to upgrade beyond the free tier.`,
          auth: "Contacting Lighthouse...",
          import: {
            title: "",
            message: {
              ready: "",
              recover_web3: "Recovering Lighthouse Storage config...",
              retrieve_folder: "Retrieving mails from Lighthouse Storage...",
              recover_signal: "Recovering signal protocol storage...",
              completed: "Completed!",
            },
            content: {
              paragraph1: "Please select a config file",
            },
            button: {
              import: { title: "Import from saved file" },
              import_phone: { title: "Import from Your Phone" },
              back: { title: "Back" },
            },
          },
        },
        w3ui: {
          step: "1 / 2:",
          title: "Configure Your Private Web3 Storage",
          content: `Great job on successfully creating your PlexiMail address
              protected by your Ai-Fi wallet! Now it's time to acquire and
              configure your own private email repository without relying on any
              email providers. In the past, storing data on the decentralized
              web wasn't always easy — but that's where web3.storage comes in.`,
          note: "A confirmation email will be sent to this mailbox for validation. Take a momentary break here and switch to your email client to respond to the verification email by clicking 'Verify email address', sent by web3.storage. If prompted, you can sign up with a credit card, but feel free to choose the Free option initially. Web3.Storage is the most established Web3 storage provider with minimal risk to your credit card. After verification, continue with the configuration process.",
          verify: {
            title: "Verifying your email address...",
            message_1:
              "Please take a momentary break here and switch to your email client at",
            message_2:
              "to respond to the verification email in order to sign in.",
            message_3: "You can request a resend in",
            message_4: "seconds.",
            message_5: "RESEND",
            message_6: "if not succeeding.",
          },
          shared: {
            config_storage: "Configuring storage ...",
          },
        },
        config: {
          step: "3 / 4: ",
          step_restore: "Final: ",
          title: "Your Storage, Your Rules",
          recover_title: "Recover Web3 Storage",
          content: {
            paragraph1_1: "Visit",
            paragraph1_2:
              " to acquire your private Web3 storage. After finishing the Web3 account set-up, click the \"Account\" button on the upper right of the web3.storage page and select the \"API Tokens\" to copy the long token string. ",
            paragraph1_3:
              "The \"API Token\" of your Web3Storage has been auto-filled with retrieved data from your Configuration database. There is a small chance that it might have been invalidated by your Web3 storage provider. If the \"Next\" button below returns an error, please go back and get a new token by recovering your Web3 account.  (Click the \"Account\" button on the upper right of the web3.storage account page and select the \"API Tokens\" to copy the long token string.)",
            paragraph2:
              "Paste your Web3 Storage token here in order for PlexiMail to locate your private storage.",
            tokenTextField: {
              placeholder: "Enter Web3 Storage API Token here",
            },
            paragraph3:
              "All your PlexiMail data are stored in your own private storage space acquired from Web3Storage. Although it is in plain sight, it is virtually anonymous and fully encrypted through dynamic keys from your own wallet with strength equivalent to any public blockchain transaction keys. ",
            invalid_token:
              "Incorrect API Token format. Verify and ensure the complete string is copied.",
            as_default: "As Default Storage",
          },
          button: {
            next: { title: "NEXT" },
            back: { title: "Back" },
          },
        },
        import: {
          title: "",
          message: {
            ready: "",
            recover_web3: "Recovering Web3.Storage config...",
            retrieve_folder: "Retrieving mails from Web3.Storage...",
            recover_signal: "Recovering signal protocol storage...",
            completed: "Completed!",
          },
          content: {
            paragraph1: "Please select a config file",
          },
          button: {
            import: { title: "Import from saved file" },
            import_phone: { title: "Import from Your Phone" },
            back: { title: "Back" },
          },
        },
        mnemonic_recover: {
          title: "Recover Wallet from Mnemonic Phrase",
          token: {
            label: "Web3.Storage API Token",
            placeholder: "Web3 Storage API Token",
          },
          mnemonic: {
            label: "Mnemonic Phrase",
            placeholder: "Mnemonic Phrase for Recovery",
          },
          button: {
            close: { title: "Close" },
            recover: { title: "Recover" },
          },
          trigger: { title: "Recovery from Mnemonic" },
        },
      },
      signal: {
        initial: {
          step: "Final: ",
          title: "Prepare Signal Runtime",
          content: {
            paragraph1:
              "Hurray on setting up your web3 storage successfully! We adopt the Signal Protocol to protect your end-to-end communication sessions. Your PlexiMail addresses are bound to the private keys in your wallet at this step, which spawns a full spectrum of session keys and other security parameters as per situations.",
            paragraph2: `Please prepare to allow the signing of confirmation transaction with keys from your ${BLOCKCHAIN_NAME_CAMEL} wallet (if requested).`,
            paragraph3:
              "Learn more about Open Whisper Systems and Signal Protocol.",
          },
          button: {
            next: { title: "PROCEED" },
            back: { title: "Back" },
          },
        },
      },
      export: {
        default: {
          step: "Step 7: ",
          title: "Backup PlexiMail Configuration",
          content: {
            paragraph1:
              "Your PlexiMail session configuration and key generating materials are kept in your browser as \"Cookies and other site data\" under the \"Privacy and security\" settings, which may get cleared accidentally. For ease of recovery, this configuration data may be backed-up/exported here to recover your established sessions. Note that your identity or PlexiMail address is separately guarded through a more stringent passphrase mechanism. ",
          },
          button: {
            export: { title: "EXPORT CONFIGS" },
            back: { title: "Back" },
          },
        },
      },
      wait: {
        default: {
          // step: 'Wrap Up: ',
          title: "Waiting for transaction receipt...",
          content: {
            paragraph1: `Your PlexiMail address and session data are safeguarded on the ${BLOCKCHAIN_NAME_CAMEL} Blockchain through a Smart Contract. Please wait until this process completes.`,
            paragraph2: "Checking transaction receipt... ",
            paragraph3:
              "Failed to get the transaction receipt. Please try again later.",
            paragraph4:
              "Transaction has been confirmed, Automatically enter PlexiMail in 10 seconds... ",
          },
          button: {
            enter: { title: "Enter into PlexiMail" },
            retry: { title: "Retry" },
            back: { title: "Back" },
          },
        },
      },
      on_click_create: {
        title: "1-Click Create",
        loading: "Newly created account is initializing",
        description:
          "Most of the time when users restore PlexiMail, they will still use the previous configuration. Following the normal recovery process steps is very cumbersome. 1-Click resume provides a shortcut for this scenario.",
        note: "* If the Privacy Level is inconsistent with the current running platform, it will be modified to suit the new environment.",
        button: {
          back: "Back",
          retry: "Retry",
        },
      },
      one_click_resume: {
        title: "1-Click Resume",
        description:
          "Most of the time when users restore PlexiMail, they will still use the previous configuration. Following the normal recovery process steps is very cumbersome. 1-Click resume provides a shortcut for this scenario.",
        note: "* If the Privacy Level is inconsistent with the current running platform, it will be modified to suit the new environment.",
        button: {
          back: "Back",
          retry: "Retry",
        },
      },
      one_click_create: {
        title: "1-Click Create",
      },
      main: {
        title: "PlexiMail",
        sidebar: {
          create: "Create Folder",
        },
        menu: {
          apps_section: "Apps",
          account_section: "My Account",
          global_section: "Global",
          operations_section: "Operations",
          wallet: "Wallet",
          settings: "Settings",
          help: "Help",
          buy_eth: "Buy Eth",
          profile: "Addresses",
          contacts: "Contacts",
          more: "Advanced",
          tutorial: "Tutorial",
          sign_out: "Exit",
          switch_account: "Switch Account",
        },
        profile: {
          addresses: "Addresses",
          exit: "Exit",
          terms_and_privacy: "Terms & Privacy",
          copied: "Copied",
          hello: "Hello"
        },
        dialog: {
          pwa: {
            title: "PlexiMail can run as a standalone web application",
            content: {
              paragraph1:
                "Instead of running in a Browser tab, PlexiMail can be packaged to run in a standalone window, independently searchable and launchable through its dedicated application icon on the desktop almost like a native app. ",
            },
            button: {
              cancel: "Skip",
              install: "Install PlexiMail",
            },
          },
          create_folder: {
            title: "Create Folder",
            content: {
              name: "Name: ",
              parent: "Under: ",
            },
            button: {
              cancel: "Cancel",
              save: "Save",
            },
            message: {
              folder_name_is_empty: "Folder name cannot be empty",
              character_is_not_allowed: " is not allowed",
              folder_already_exists: " already exists",
              folder_name_is_too_long: "The folder name is longer than 128 characters"
            },
          },
          sign_out: {
            title: "Are you sure you want to exit PlexiMail?",
            content: {
              paragraph1:
                "All your cached session context will be cleared after signing out!",
              paragraph2:
                'To reconnect to current PlexiMail session, choose the "Recover" and then "Resume" option on reentry.',
            },
            button: {
              cancel: "Cancel",
              sign_out: "Exit",
            },
          },
        },
      },
      list: {
        welcome: {
          // title: 'Welcome to PlexiMail',
          title: "No Messages",
          sub_title: "Close the Loop with PlexiMail Pro",
          description:
            "Despite the rise in instant messaging, SMS, and social networking, email remains the predominant business collaboration tool. Unfortunately, the unsecured nature of email exposes sensitive information to malicious attacks. Distinguish your brand by halting the seemingly unstoppable phishing pandemic from eroding your reputation. Cultivate trust with your customers and ensure compliance with privacy regulations using PlexiMail Pro.",
          action: " Learn More",
        },
        includes_plexisign_messages: "Includes PlexiSign Messages"
      },
      previewer: {
        menu: {
          back: "Back",
          reply: "Reply",
          reply_all: "Reply All",
          forward: "Forward",
          move: "Move",
          delete: "Delete",
          reload: "Reload",
          actions: "Actions"
        },

        send_date: "Sent Date: ",
        from: "From: ",
        to: "To: ",
        cc: "Cc: ",
        bcc: "Bcc: ",
        subject: "Subject: ",
        content: "Content: ",
        attachment: "Attachment",
        message: {
          attachment: {
            title: "Attachments",
            download: {
              downloading: "Downloading, please wait",
              is_in_progress: "Download in progress",
              progress: {
                paragraph1_1: "Downloaded ",
                paragraph1_2: " of ",
                paragraph2: "Downloaded",
              },
            },
          },
          failed_to_load: "Failed to load message",
          select_folder: "Please select a folder to move",
          moving: "Moving...",
          deleting: "Deleting...",
          moved: "Moved",
          moved_to_trash: "Message moved to Trash",
          deleted: "Deleted",
          tofu_changed:
            'The signature of the sender has changed since the last time you two corresponded. You might want to re-authenticate the sender (through a different channel). Press "Trust & Decrypt" only if nothing is amiss.',
          tofu_new:
            'This is the first time getting PlexiMail from this sender. You might want to double-check the authenticity of the sender (through a different channel). Press "Trust & Decrypt" only if nothing is amiss.',
        },
        tofu: {
          // verify: <Text fontSize={"sm"} mt={4} align="left" width="100%">PlexiMail adopts the same signature scheme as {BLOCKCHAIN_NAME_CAMEL} and relies on its Smart Contract to authenticate registered users and to support online auditability. For unregistered or "Verified by ICP" users with a orange warning sign: "<GoUnverified size={16} color="orange" align={"middle"} style={{display: 'inline', verticalAlign: 'middle'}} />", you may want to <Link href="https://ai-fi.cc/help.html#double-check-the-tofu-signature-personally" target="_blank" color="#00aaff">double-check the TOFU signature personally</Link>, even when it is labeled as "CORRECT", based on the public {BLOCKCHAIN_NAME_CAMEL} Signature standard.</Text>,
          verify: `PlexiMail adopts the same signature scheme as 
              ${BLOCKCHAIN_NAME_CAMEL} and relies on its Smart Contract to
              authenticate registered users and to support online auditability.`,
          steps: "",
          sender: "Sender",
          idkey: "Identity Key",
          signature: "Signature",
          address: "Address",
          copied: "Copied",
          verified: "",
          miss: "",
          correct: "Correct",
          incorrect: "Incorrect",
        },
        dialog: {
          add_contact: {
            title: "Add Contact",
            content: {
              name: "Name: ",
              email: "PlexiMail Address: ",
            },
            button: {
              cancel: "Cancel",
              add: "Add",
            },
          },
          move_message: {
            title: "Move Message",
            button: {
              cancel: "Cancel",
              move: "Move",
            },
          },
          cid_not_found: {
            title: "Failed to download",
            message:
              "Due to the high volume of PlexiMail traffic, your download request couldn't be met right now. You can opt for continuous retries until completion, or come back later to check again. Please be patient, as the wait time is difficult to predict. 10 ~ 20 min is not unusual. The world record is about 3 hours.",
          },
        },
      },
      editor: {
        title: {
          new_message: "New Message",
          reply: "Reply",
          reply_all: "Reply All",
          forward: "Forward",
        },

        sent_by: "Sent by PlexiMail",

        full_screen: "Full screen",
        exit_full_screen: "Exit full screen",
        content: {
          pwd: {
            passcode: "Passcode",
            title: "Please enter a passcode for encrypting this message",
            description:
              "Password required to send encrypted emails to non-PlexiMail recipients.",
            allow_reply: "Allow recipient to reply",
            allow_reply_explain:
              " (Reply is allowed only if there is a single recipient)",
            assist_account_creation:
              "Assisting the recipient with a streamlined PlexiMail signup script.",
            cancel: "Cancel",
            next: "Next",
            passcode_less_than_128: "Passcode must be less than 128 characters",
            copied: "Copied"
          },
          tofu: {
            message:
              "This is the first time sending PlexiMail to the recipient(s) listed at the end. You might want to double-check their authenticity (through a different channel).",
            verify: `PlexiMail adopts the same signature scheme as{" "}
                ${BLOCKCHAIN_NAME_CAMEL} and relies on its Smart Contract to
                authenticate registered users and to support online
                auditability.`,
            // steps: (
            //   <>
            //     <OrderedList fontSize={"sm"} px={3}>
            //       <ListItem>
            //         go to{" "}
            //         <Link
            //           href="https://etherscan.io/verifiedSignatures"
            //           target="_blank"
            //           color="#00aaff"
            //         >
            //           https://etherscan.io/verifiedSignatures
            //         </Link>{" "}
            //         and click <Badge variant="solid">Verify Signature</Badge>.
            //       </ListItem>
            //       <ListItem>
            //         On the Etherscan Verify Signature pop-up, fill the data
            //         fields<Badge variant="solid">Address</Badge>,
            //         <Badge variant="solid">Message</Badge>, and
            //         <Badge variant="solid">Signature Hash</Badge>with PlexiMail
            //         <Badge variant="solid">Address</Badge>,
            //         <Badge variant="solid">Identity Key</Badge>,
            //         <Badge variant="solid">Signature</Badge> respectively from
            //         below. Data displayed below are all clickable for copy and
            //         paste.
            //       </ListItem>
            //     </OrderedList>
            //     <Text mt={3} fontSize={"sm"} fontWeight={"bold"}></Text>
            //   </>
            // ),
            title: "Untrusted Recipient(s)",
            idkey: "Identity Key",
            signature: "Signature",
            address: "Address",
            copied: "Copied",
            // miss: (
            //   <Badge variant="solid" colorScheme="red">
            //     Missing
            //   </Badge>
            // ),
            correct: "Correct",
            incorrect: "Incorrect",
          },
          editor: {
            from: {
              title: "From: ",
            },
            to: {
              title: "To: ",
              placeholder: `e.g. 0x0...000${mailAddressSuffix()} or name from Contacts (Required)`,
              placeholder_more: "Enter more recipients here",
              show_contact: "Select Recipient(s)",
            },
            subject: {
              title: "Subject: ",
              placeholder: "",
            },
            content: {
              initial_content: "Sent by PlexiMail",
            },
            attachment: {
              title: "Attachments",
            },
          },
          contacts: {
            title: "Select Recipient(s)",
            content: {
              search: "Search...",
              empty: "No contacts",
            },
            button: {
              confirm: "Confirm",
            },
          },
        },
        message: {
          upload: {
            paragraph1_1: "Uploading... (",
            paragraph1_2: " uploaded)",
            paragraph1_3: "Uploading...",
            paragraph1_4: "Uploaded ",
            paragraph1_5: " of ",
            encrypting: "Encrypting...",
          },
          address: {
            invalid_addr_1: "The above address",
            invalid_addr_2:
              "was not recognized. Please ensure that all addresses are in the correct format.",
            invalid_eth:
              "Cannot send email to traditional mailboxes and PlexiMail mailboxes at the same time.",
            invalid_normal:
              "Cannot send email to traditional mailboxes and PlexiMail mailboxes at the same time.",
            multi_recps:
              "Cannot send email to multiple traditional mailboxes at once.",
          },
          sent: "Message is sent!",
          // restriction: 'Attachments are not allowed, plus many other restrictions.'
          restriction:
            "The bridging function is one-way and accepts no replies. ",
        },
        button: {
          add_attachment: {
            title: "",
            tips: "Add Attachment(s)",
          },
          send: {
            send: "Send",
            trust_and_send: "Trust & Send",
          },
        },
        unverified: {
          title: "Warning",
          description_1:
            'Your PlexiMail Address is currently in the "Verified by ICP" status, placing an additional burden on your partners to authenticate you without the advantages provided by registering with the PlexiMail Smart Contract.',
          description_2:
            'To upgrade this status, simply click on the "Verified by ICP" status display located on the upper left of the main screen and follow the instructions provided. Alternatively, you can upgrade your status from within the "Settings".',
          description_3: "",
          dont_show_again: "Don't show this message again",
          next: "Next",
        },
        save_draft: {
          title: "Save Draft",
          description:
            "We have detected an unsent draft in the buffer. Would you like to save it?",
          discard: "Discard",
          save: "Save",
        },
        load_draft: {
          title: "Load Draft",
          description: "There is a draft copy saved previously.",
          discard: "Discard",
          recover: "Recover",
        },
      },
      settings: {
        account_title: "Advanced",
        title: "Settings",
        message: {
          cache_cleard: "Cached Data was cleared",
        },
        list: {
          export: {
            title: "Export Configuration Settings",
            description:
              "Configuration Settings will help recover your PlexiMails after any loss event.",
          },
          mnemonic: {
            title: "Show Mnemonic Phrase",
            description:
              "Display Seed Phrase for recovering all encryption key materials.",
          },
          privateKeys: {
            title: "Show Lighthouse Accounts",
            description:
              "Display Lighthouse Accounts for filling in Metamask Wallet.",
          },
          clear: {
            title: "Clear Cached Data",
            description:
              "For performance, all received PlexiMails are cached locally. They may grow excessively large.",
          },
          close: {
            title: "Close Your PlexiMail",
            description:
              "All data produced by this account will be permanently erased from canister",
          },
          backup_wallet: {
            title: "Backup Wallet",
            description: "",
          },
          change_w3s_api_token: {
            title: "Migrate to a Different Web3Storage",
            description: "Storage space can be expanded in this way",
          },
          change_pin: {
            title: "Change PIN Code",
            description: "",
          },
          verify_sender: {
            title: "Display Risk Level of Mail Sender",
            description:
              "Assess and display the risk level of the mail sender - this may impact performance.",
          },
          upgrade: {
            title: "Register with PlexiMail Blockchain",
            description:
              "Verify & Register with PlexiMail Smart Contract. This will incur smart contract charges in AVAX.",
          },
        },
        dialog: {
          export_confirm: {
            title: "Select Where to Export the Configuration",
            content:
              'Press "Export as a File" to package the Configuration as a file for manual download, or press "Sync to Your Phone" to encrypt and upload to your phone. ',
            button: {
              download: "Export as a File",
              sync: "Sync to Your Phone",
            },
          },
          sync: {
            title: {
              export: "Backup Config Settings to Your Mobile Phone",
              import: "Import Config Settings from Your Mobile Phone",
            },
            content: {
              paragraph1: "Scan to connect to your phone",
              paragraph2: "Download and install the mobile app",
            },
            button: {
              cancel: "Cancel",
              done: "Done",
            },
          },
          mnemonic: {
            title: "Display Mnemonic",
            message: {
              copied: "Copied",
            },
            content: {
              paragraph1:
                "Click the mnemonic content above to copy to your clipboard.",
              paragraph2: "The mnemonic is most import",
            },
            button: {
              hide: "Hide Mnemonic",
              display: "Display Mnemonic",
              copy: "Copy to your clipboard",
              close: "Close",
            },
          },
          privateKeys: {
            title: "Display Lighthouse Accounts",
            message: {
              copied: "Copied",
            },
            content: {
              paragraph1: "Click the content above to copy to your clipboard.",
              paragraph2: "The account is most import",
            },
            button: {
              hide: "Hide Lighthouse Accounts",
              display: "Display Lighthouse Accounts",
              copy: "Copy to your clipboard",
              close: "Close",
            },
          },
        },
      },
      profile: {
        title: "Address",
        content: {
          copy: "This QR image represents your PlexiMail Address, which is protected by the auto-generated passcode below it. Please take a screenshot or save the QR image as a file to share your PlexiMail Address. Click the eye icon to view and copy the auto-generated passcode. Send the passcode securely to your partner through a separate channel. Use two independent channels for the QR image and the passcode to ensure safe delivery.",
          note: "Please keep the passcode hidden, If you share your address by taking a screenshot.",
        },
        message: {
          copied: "Copied",
        },
        save: {
          title: "Save as an Address Token",
          message:
            "Encode your PlexiMail Address into a QR code file for passing along to your friends and partners.",
          checkbox: "Scramble the file content with an optional passcode.",
          input: "Please enter a passcode here",
          button: { next: "Save", cancel: "Cancel" },
        },
        button: {
          refresh: "Regenerate the QR code",
          copy: "Copy Address",
          close: "Close",
          save: "Save as an Address Token",
          back: "Back",
        },
        delete_address: "Delete Address",
        delete_address_confirmation: "Are you sure you want to delete the following address:",
        deleting_address: "Deleting Addresses ...",
        cancel: "Cancel",
        delete: "Delete",
        empty_address: "Address could not be empty",
        name_contains_special_characters:"Name cannot contain special characters",
        add_incognito_address: "Add Incognito Address",
        add_normal_address: "Add Normal Address",
        generate_address_message: 'An incognito PlexiMail Address will be generated after "Add" button clicked.',
        human_readable_address: "Human readable address",
        saving_address: "Saving Addresses ...",
        add: "Add",
        loading_addresses: "Loading Addresses ...",
        refresh: "Refresh",
        close: "Close",
        my_addresses: "My Addresses",
        new_incognito_address: "New Incognito Address",
        new_normal_address: "New Normal Address",
        label: "Label"
      },
      qrcode: {
        alert: {
          title: "Enter PlexiMail Addresses",
          trigger: "Scan",
          scan_message:
            "Press \"Open\" for a QR code image file; \"Scan\" if the QR code is readable through the camera.",
          decode_message: "Press \"Decode\" to decode the selected file.",
          cancel: "Cancel",
          decode: "Decode",
          next: "Next"
        },
        pwd: {
          title: "A passcode is required",
          message:
            "The code passed in was encrypted for privacy protection. Please enter the decryption passcode. Contact the sender for one if you don’t have it.",
          input: "Please enter passcode here",
          button: {
            cancel: "Cancel",
            next: "Decrypt",
          },
        },
        zip: {
          title: "A password is required",
          message:
            "The password passed in was encrypted for privacy protection. Please enter the decryption password.",
          input: "Please enter password here",
          button: {
            cancel: "Cancel",
            next: "Open",
          },
        },
        scanner: {
          title: "Scan QR Code",
          message: "Please aim your camera at the QR Code.",
          button: { cancel: "Cancel" },
        },
        button: { open: "Open", scan: "Scan" },
      },
      contacts: {
        title: "Contacts",
        editTitle: "Edit Contact",
        addTitle: "New Contact",
        previewTitle: "Contact",
        content: {
          list: {
            search: {
              placeholder: "Search...",
            },
            new_contact: "New",
            add: "Add",
            import: "Import",
            empty: "No contacts",
          },
          editor: {
            name: "Name: ",
            email: "PlexiMail Address: ",
            save: "Save",
            back: "Back",
            delete: "Delete",
          },
          preview: {
            name: "Name: ",
            email: "PlexiMail Address: ",
            back: "Back",
          },
        },
        message: {
          empty_name: "Name could not be empty",
          empty_email: "PlexiMail address could not be empty",
          name_too_long: "The name length exceeds 128",
          email_too_long: "The email length exceeds 256",
          invalid_name: "Name is invalid",
          invalid_email: "PlexiMail address is invalid",
          repeated: "Your PlexiMail address already exists",
        },
      },
      buy_eth: {
        title: `Redeem Plexi Tokens for ${COIN_SYMBOL}`,
        head: "Plexi Tokens",
        status: {
          unused: "Unspent",
          redeemed: "Spent",
          refunded: "Refunded",
        },

        // description: (
        //   <Text fontSize="sm">
        //     To enhance privacy and minimize traceability, the Plexi Token
        //     Service enables you to anonymously purchase {COIN_SYMBOL} through a
        //     two-step process: Step 1: Outside this webpage,{" "}
        //     <Link
        //       color="#00aaff"
        //       textDecoration={"underline"}
        //       href="https://ai-fi.cc/store"
        //       target="_blank"
        //     >
        //       visit the token store to acquire anonymized tokens.
        //     </Link>{" "}
        //     Make sure to keep this webpage open or bookmark it to return for
        //     Step 2. Step 2: Once you have acquired the tokens, return here and
        //     redeem them by scanning into the list below. After scanning all the
        //     tokens, click the 'Redeem' button. <br />
        //     <br />
        //     <i>The selected tokens to be redeemed are maintained below:</i>
        //   </Text>
        // ),
        messages: {
          no_ecash: "No Plexi Tokens",
          getting_current_price: `Getting current ${COIN_SYMBOL} price...`,
          current_price_1: `Current ${COIN_SYMBOL} price: $`,
          current_price_2: ` / ${COIN_SYMBOL}`,
          test_note: `This is a simulated process for purchasing Plexi Tokens for a testnet. The returned amount is fixed at 0.01 ${COIN_SYMBOL} regardless of the face value of the simulated purchases due to our limited supply of test coins.`,
        },
        qrcode: {
          title: `Buy ${COIN_SYMBOL} with Plexi Tokens`,
          description: "",
        },
        table: {
          head: {
            col0: "",
            col1: "Plexi Token",
            col2: "Face Value ($)",
            col3: "Status",
            col4: "Del",
          },
          body: {
            empty_title: "Tokens list to redeem is empty",
            empty:
              'Press the "Scan" button to add Plexi Tokens to the redemption list here',
          },
          foot: {
            prefix: "Total: $",
            suffix: ` ${COIN_SYMBOL}`,
          },
        },
        foot: {
          buy_ecash: "Buy Plexi Tokens",
          buy_eth: "Redeem",
        },
      },
    },
    zh: {
      appName: "PlexiMail",
      error: {
        rpc: {
          "-32002":
            "您的请求因钱包中有一个挂起的请求而被排队处理，可能被其他窗口遮挡。请恢复钱包应用程序并首先清除挂起的条目。",
        },
        client: {
          miss_param: "缺少数据参数",
          miss_signature: "缺少签名参数",
          invalid_signature: "无效签名",
          not_in_blockchain: "未在区块链中找到",
          name_empty: "名称不能为空",
          email_empty: "无效的 PlexiMail 地址",
          contact_already_existed: "联系人条目已存在",
          invalid_signal_message: "系统错误（无效的信号消息）",
          invalid_message_type: "系统错误（无效的消息类型）",
          prekey_message_not_found: "系统错误（预密钥消息未找到）",
          enc_data_undefined: "系统错误（加密数据未找到）",
          enc_data_null: "系统错误（加密数据未找到）",
          unsupported_data_type_1: "数据类型 ",
          unsupported_data_type_2: " 不受支持",
          plaintext_null: "系统错误（加密数据不能为空）",
          failed_clear_cache: "系统错误（清除缓存失败）",
          lost_conn: "连接已丢失",
          ws_not_ready: "系统错误（WebSocket 尚未准备好）",
          att_not_bob: "系统错误（附件不是 Blob 类型）",
          enckey_bundle_not_found: "系统错误（加密密钥包未找到）",
          enckey_for_att_not_found_1: "系统错误（附件的加密密钥未找到）",
          enckey_for_att_not_found_2: " 未找到",
          enckey_for_msg_not_found_1: "系统错误（消息的加密密钥未找到）",
          enckey_for_msg_not_found_2: " 未找到",
          metamask_not_installed: "MetaMask 未安装",
          wallet_not_found: "钱包未找到",
          idkey_not_found: "系统错误（身份密钥对未找到）",
          devid_lost: "设备 ID 未找到",
          regid_lost: "注册 ID 未找到",
          idkey_lost: "身份密钥对未找到",
          msg_is_null: "消息不能为空",
          unsupported_msg_type: "不支持的消息类型",
          file_not_found: "文件未找到 ",
          timeout_retry: "错误或超时：点击重试或暂时退出。",
          idkey_not_identical: "身份密钥不匹配",
          account_not_in_blockchain: "区块链中未找到账户",
          need_a_subscription: "您需要订阅 PlexiSign 才能继续使用它",
          attachment_size_exceeded: '附件大小超过 100MB 限制',
        },
      },
      common: {
        message: {
          prepare_env: "正在检查环境...",
          supply_prekeys: "提供预密钥...",
          generate_keys:
            "正在生成身份密钥、注册 ID 和预密钥...",
          save_prekey: "正在将预密钥包存储到云端...",
          save_idkey: "正在将身份密钥保存到智能合约...",
          wait_tx_receipt: "等待交易回执...",
          save_signal: "正在保存信号协议存储...",
          completed: "完成！",
          wallet_is_backup:
            "您的自管账户已生成，您的 PlexiMail 身份已创建。",
          wallet_safe_smart_contract:
            "您的钱包已安全存储在您的私人存储中。相应的 PlexiMail 身份已注册到 ICP 区块链上，以便自管和匿名审计。请务必保管好您的双重锁。探索设置以选择额外的安全和审计选项。",
          checking_balance: `正在检查 ${COIN_SYMBOL} 账户余额...`,
          wait_funds: "等待外部资金操作...",
          incorrect_password: "PIN 码不正确",
          init_web3_storage: "正在初始化存储...",
          backup_wallet: "备份您的钱包...",
          sync_folders: "正在同步文件夹...",
          create_wallet: "正在创建钱包...",
          recover_wallet: "正在恢复钱包...",
          acquire_storage: "正在获取存储...",
          config_storage: "正在配置存储...",
          initial_signal: "正在初始化信号环境...",
          completed_initialization: "初始化完成，正在保存数据...",
          retrieve_folder: "正在检索文件夹...",
          recover_signal: "正在恢复信号...",
          completed_recovery: "恢复成功，正在保存数据...",
          sign_in_with_ii: "正在使用 Internet Identity 登录...",
        },
        learn_more: "了解更多",
        retry: "重试"
      },
      tips: {
        tip0: "您的身份已由ICP验证，ICP是PlexiSign的合作伙伴，负责启动、处理、完成和管理您的数字签名工作流。",
        tip1: "\"全部\"文件夹包含您已启动的任何状态下的所有数字合同工作流和流程，从启动到完成。您存档的任何内容只会出现在\"安全存档\"文件夹中。",
        tip2: "\"已启动\"文件夹包含您已启动但尚未进入或超过签名轮次阶段的所有数字合同工作流和流程。",
        tip3: "\"签名轮次\"文件夹包含您已启动并进入签名轮次阶段的所有数字合同工作流和流程。其他正在进行中的工作流将根据其当前状态或是否已存档，出现在\"已启动\"、\"已完成\"或\"安全存档\"文件夹中。",
        tip5: "\"安全存档\"文件夹包含您手动存档的所有数字合同工作流和流程。这些工作流在存档时可能处于任何状态，并将从其原始文件夹中移除，无论其状态如何。其他正在进行中的工作流将根据其当前状态，出现在\"已启动\"、\"签名轮次\"或\"已完成\"文件夹中。",
        tip6: "通过打开电子邮件客户端启动一个新的数字签名工作流，准备好进行填写和配置。",
        tip7: "高级选项使您能够管理您的安全设置。",
        tip8: "主下拉菜单使用户能够在使用PlexiSign时管理\"我的账户\"和\"全局设置\"。\"我的账户\"包括查看或管理您的PlexiSign地址、您合作过的联系人以及您的安全设置。\"全局设置\"包括管理您的访问权限和数据。",
        tip9: "在设置中，您可以管理您的数据或更新用于锁定屏幕的PIN码。",
        tip10: "退出将完全注销您在PlexiSign中的登录状态，下次重新启动PlexiSign时，您需要提供您的身份和密钥（存储在您的计算机上）。您的\"身份\"是在设置过程中创建并要求您保存的多位数字。",
        tip11: "锁定屏幕将使您的屏幕返回锁定状态，而不会退出您的会话。您可以使用6位数字的PIN码解锁屏幕，从而从该状态进入PlexiSign。",
        tip12: "企业仪表板",
        tip13: "联系人帮助您搜索并找到您在启动和管理数字签名工作流和流程时使用过的任何电子邮件地址。",
        tip14: "帮助",
        tip15: "个人资料",
        get_credits: "获取15美元低佣金",
      },
      app: {
        mode: {
          unverified: "未验证",
          verified: "已通过 ICP 验证",
        },
        privacy_level: {
          standard: "标准隐私",
          high: "高隐私",
        },
        message: {
          ready: "准备就绪！",
          new_message: "有新的传入消息！",
          prepare_signal: "正在准备信号环境...",
          check_prekeys: "正在检查预密钥。请稍候...",
          generate_prekeys: "正在生成预密钥。请稍候...",
          save_prekeys: "正在保存预密钥。请稍候...",
          load_contact: "正在加载联系人。请稍候...",
          load_messages: "正在加载 PlexiMails。请稍候...",
        },
        dialog: {
          contract_intro: {
            "title": "签名轮次",
            "content1": "准备启动签名轮次以执行协议:",
            "content2": "此向导简化了为协议发起签名轮次的过程，涉及所有参与者。作为主持人，您可以使用提供的示例封面信来指导他们完成签署流程。此外，您还可以利用最后的\"模板\"按钮来保存、选择或创建您自己的封面信。封面信是可定制的！通过填写或删除括号中的占位符（例如{{客户名称}}）或根据需要合并字段来自定义它。",
            "content3": "您需要做的是:",
            "content4": "<strong>提供参与者信息: </strong>由于目前涉及的所有人都未识别，请输入每个参与者的必要联系信息。这将包括一些个人身份信息（PII），例如姓名和电子邮件地址。",
            "content5": "<strong>双因素认证（可选）: </strong>为了增加安全性，PlexiSign 可以在您选择启用的情况下协助向参与者的手机或电子邮件地址发送双因素认证码。",
            "content6": "<strong>分别附加所有合同材料 </strong> 使用\"附加\"按钮供他们最终审查和签名。",
            "content7": "提供参与者信息的好处:",
            "content8": "<strong>更快的签署流程: </strong>拥有准确的联系信息可确保每个人都能及时收到签署通知。",
            "content9": "<strong>增强的安全性: </strong>通过提供联系信息，您可以在签署前验证每个参与者的身份，降低欺诈行为的风险。",
            "content10": "让我们开始吧!",
            "next": "下一步",
            "cancel": "取消"
          },
          private_key: {
            lighthouse_for_storing_pleximail: "用于存储 PlexiMail 的 Lighthouse",
            lighthouse_for_backup_pleximail: "用于备份 PlexiMail 的 Lighthouse",
          },
          delete_account: { 
            title: "删除你的 PlexiMail 账号",
            description: "账号产生的数据都会被永久从服务器端删除.",
            cancel: "取消",
            delete: "删除",
            deleting: "正在删除...",
            please_try_again_later: "请稍后再试。",
            failed_to_delete: "删除账户失败。",
          },
          search: {
            title: "搜索消息",
            tips: "搜索帮助您找到使用关键词匹配而不是手动导航文件夹的传入消息。",
            search: "搜索",
            noResults: "无结果",
            noBackup: "无备份",
            keyword_length_100: "关键字长度不能超过 100 个字符",
            scope: "搜索范围: ",
            from: "发件人: ",
            to: "结束时间",
            subject: "主题: ",
            all: "全部: ",
            from1: "开始时间",
            select_date_and_time: "选择日期和时间",
            searching: "搜索中...",
          },
          ask_pwd: {
            title: "需要密码",
            description:
              "消息已加密，需要密码才能解锁，将通过 SMS 或其他安全路径发送给您。如果您有密码，请点击下方按钮解锁。",
            passcode_label: "请输入密码",
            passcode_placeholder: "xxxx xxxx xxxx xxxx",
            next: "下一步",
            cancel: "取消",
          },
          faucet: {
            title: "激活自管账户",
            message: {
              back: "请先用足够的加密货币填充您的钱包，然后再继续此配置过程。",
            },
            content: {
              paragraph1:
                "您已成功创建了一个 PlexiMail 钱包，用于维护您的 PlexiMail 身份，并获得了 Web3 存储。现在，您需要通过 PlexiMail 智能合约注册一组安全的联系参数，以便您的合作伙伴在允许的情况下联系您。此外，所有异步消息传递上下文将被封装在一个配置数据库中，也存储在您的 Web3 存储中，并双重锁定。要启用此自管 PlexiMail 账户，您将被要求：",
              paragraph2: {
                item0: "如果您选择通过 PlexiMail 智能合约注册以最大化保护，则需要用加密货币为您的钱包充值。",
                item1: "提供双重锁以保护您的配置。",
              },
              paragraph3: `注意：PlexiMail 仅指此 PlexiMail 软件可免费用于非商业用途，但所消耗的物资，如电力、计算能力、传统磁盘存储、RAM、打印机、墨水、互联网连接等并不免费。作为运行在 ${BLOCKCHAIN_NAME_CAMEL} 区块链上的 Web3 dApp，它消耗 "${BLOCKCHAIN_NAME_CAMEL} 燃气"，这是 ${BLOCKCHAIN_NAME_CAMEL} 对您使用其计算资源的收费。初始智能合约运行成本为燃气，每发送一封电子邮件收取 $0.0001 的象征性费用，以在必要时防止 DDOS 攻击.`,
            },
            button: {
              get_coins: "进入智能合约",
              buy_with_ecash:
                "使用匿名化的 Plexi 代币激活合约",
              redeem_promo_code: "使用促销代码激活合约",
              buy: "通过加密货币交易所激活合约",
              get: "激活",
              email: "通过发送请求激活",
              show_wallet: "显示钱包",
            },
          },
          kickout: {
            title: "应用程序已重置",
            message:
              "由于您已在另一设备上登录，此设备上的数据已被清除。",
            quit: "退出",
          },
          af_faucet: {
            title: "申请测试币",
            description:
              "输入电子邮件地址以查看您是否有资格获得促销 PlexiMail 启动测试币：",
            description2:
              "确认电子邮件将发送到输入的邮箱以验证您的电子邮件地址。",
            email: "电子邮件地址",
            email_placeholder: "请输入电子邮件",
            cancel: "取消",
            request: "请求",
            menu_item: "通过电子邮件获取测试币",
            note: "* 或者，您可以直接从",
          },
          exit_setup: {
            title: "您确定要退出配置向导吗？",
            message: "如果退出，此向导将重新开始。",
            cancel: "取消",
            exit: "退出",
          },
          promo_code: {
            title: "兑换促销代码",
            description: `输入您的一次性促销代码（可选），以使用外部资源共享池，如 ${COIN_SYMBOL} 测试网加密货币和 Web3 云存储的 API 令牌，而无需自行配置。某些限制适用.`,
            cancel: "取消",
            redeem: "兑换",
            waiting: "等待交易回执...",
            redeeming: "正在兑换促销代码...",
            rejected: "交易被拒绝",
            redeemed: "促销代码已兑换。",
          },
          address_verify_popup: {
            verified: {
              title: "已通过 ICP 验证",
              message:
                "收件人已被验证为通过 PlexiMail 智能合约注册的 PlexiMail 地址的所有者。",
              sender_message:
                "发件人已被验证为通过 PlexiMail 智能合约注册的 PlexiMail 地址的所有者。",
              self_message:
                '您的 PlexiMail 地址目前处于"已通过 ICP 验证"状态，无需额外负担即可享受通过 PlexiMail 智能合约注册的优势。',
            },
            unverified: {
              title: "未验证",
              message:
                "无法通过 PlexiMail 智能合约验证收件人地址的所有权。",
              sender_message:
                "无法通过 PlexiMail 智能合约验证发件人地址的所有权。",
              self_message:
                '您的 PlexiMail 地址目前处于"未验证"状态，这会给您的合作伙伴带来额外负担，以验证您通过 PlexiMail 智能合约注册的优势。',
            },
            warning: {
              trigger: "跳过智能合约",
              confirmation: "我了解风险",
              title: "跳过智能合约",
              message:
                "您可以在区块链上存储您的身份密钥，以显著降低身份盗窃的风险，尽管通过 Avalanche 上的智能合约注册会产生约 1 美元的费用。您可以始终为每个账户创建多个账户，并根据评估的风险选择单独的选项。",
            },
          },
          activate_account: {
            trigger: "使用智能合约注册",
            get_start: {
              title: "注册",
              description: "您尚未通过使用 PlexiMail 智能合约注册来验证您拥有 PlexiMail 地址。",
              description_upgrade: "您尚未通过在主网上使用 PlexiMail 智能合约注册来验证您拥有 PlexiMail 地址。",
              button: {
                cancel: "取消",
                next: "注册",
                upgrade: "升级",
              },
            },
            select_network: {
              title: "选择区块链",
              description:
                "PlexiMail 采用自执行的智能合约来注册和保护 PlexiMail 地址/身份。一旦注册，PlexiMail 身份的真实性将变得可审计且无需中央授权，且在没有私钥的情况下无法更改。",
              mainnet: "主网",
              mainnet_note:
                "* 用 AVAX 加密货币支付以在 Avalanche 主网上注册您的 PlexiMail 地址。",
              testnet: "测试网",
              testnet_note:
                "* 在 Fuji 测试网上进行测试运行，无需支付 AVAX 费用。在这种情况下，您的 PlexiMail 地址不会受到完全保护。您可以稍后将运行升级到主网。",
              button: {
                back: "返回",
                next: "下一步",
              },
            },
            check_balance: {
              title: "为注册充值",
              message: {
                back: "请确保您的钱包已充值足够的加密货币，然后再继续此配置过程。",
                no_enough_eth: `您的钱包中没有足够的 ${COIN_SYMBOL} 来通过智能合约注册您的身份。点击"购买 ${COIN_SYMBOL}"为您的钱包充值.`,
                ready:
                  '点击"下一步"通过 PlexiMail 智能合约发布您的 PlexiMail 地址。',
              },
              description: {
                line1: "为了使您的合作伙伴在允许的情况下联系您并进行无信任审计，您需要通过 PlexiMail 智能合约注册一组安全的联系参数。",
                line2: "通过智能合约注册需要支付加密货币的交易费用，以最大限度地保护您的 PlexiMail 身份。",
              },
              button: {
                back: "返回",
                previous: "上一步",
                next: "下一步",
                check: "检查余额",
              },
              menu: {
                trigger: `购买 ${COIN_SYMBOL}`,
                items: {
                  token: `用 Plexi 代币购买 ${COIN_SYMBOL}`,
                  exchange: `通过交易所购买 ${COIN_SYMBOL}`,
                  email: "通过电子邮件请求测试币",
                },
              },
            },
            save_idkey: {
              title: "通过智能合约保存身份密钥",
              description: {
                line1: "我们采用信号协议来保护您的端到端通信会话。您的 PlexiMail 地址在此步骤中绑定到钱包中的私钥，这会根据情况生成一系列会话密钥和其他安全参数。",
                line2: `您可能需要使用 ${BLOCKCHAIN_NAME_CAMEL} 钱包中的密钥签署确认交易弹出窗口.`,
              },
              button: {
                previous: "上一步",
                next: "下一步",
              },
            },
            wait_receipt: {
              title: "等待交易回执",
              description: `您的 PlexiMail 地址和会话数据通过智能合约在 ${BLOCKCHAIN_NAME_CAMEL} 区块链上得到保护。请等待此过程完成.`,
              high_privacy_warning:
                    "点击\"完成\"将刷新网页。由于应用程序当前以高隐私级别运行，刷新网页后您只能通过\"恢复\"返回此账户。",
              button: {
                previous: "上一步",
                next: "完成",
              },
              message: {
                checking: "正在检查交易回执...",
                failed:
                  "获取交易回执失败。请稍后再试。",
                confirmed: "交易已确认",
              },
            },
          },
          indexeddb: {
            tor: {
              title: "Tor 浏览器尚不支持",
              description: `PlexiMail 无法在 Tor 浏览器中运行，因为它默认不支持 indexeddb。如果您想要 Tor 浏览器带来的隐私，建议您在 `,
              brave: "Brave"
            },
            normal: {
              title: "当前浏览器尚不支持",
              description: `PlexiMail 无法在当前浏览器中运行，因为它不支持 indexeddb。建议您在 `,
              chrome: "Chrome"
            },
          },
          privacy_level: {
            title: "隐私级别",
            description:
              "可用性和隐私通常涉及权衡，因为更高的隐私措施可能会导致用户体验较差。我们提供两种隐私级别以适应不同的偏好：",
            tor_warning: 'Tor 浏览器仅支持"高"隐私级别',
            normal_warning:
              '当前浏览器仅支持"高"隐私级别。',
            level: {
              standard: {
                title: "标准",
                description:
                  "PlexiMail 生成的数据将被加密并存储在浏览器的内置数据库中，直到用户退出。",
              },
              high: {
                title: "高",
                description:
                  "PlexiMail 生成的数据仅在运行时存在于内存中。",
              },
            },
            error: {
              cancelled: "已取消",
            },
            button: {
              cancel: "取消",
              confirm: "确认",
            },
          },
        },
      },
      home: {
        help: "帮助",
        tab: { 
          individual: "个人",
          business: "企业"
        },
        promotion: {
          title: "使用网络邮件的数字签名工作流程",
          content: {
            paragraph1: " - 安全",
            paragraph2: " - 专业",
            paragraph3: " - 实惠",
            paragraph4: " - 开源且永久免费 **",
          },
        },
        signIn: {
          title_1: "",
          zero: "0",
          title_2: "追踪邮件",
          description_1:
            "分布式、无需许可、无痕且隐形。",
          description_2: `您只能联系同一网络上的合作伙伴。默认是 "${DEFAULT_NET_NAME}"，一个测试网络，显示在右上角。您可以将网络更改为 "${MAINNET_NAME}"，即主公共 ${BLOCKCHAIN_NAME_CAMEL} 区块链网络，或列出的其他测试网络.`,
          description_3:
            "登录或注册一个新的 PlexiMail 身份。此安全、匿名的技术在透明且安全的 ICP 区块链上保护您的 PlexiMail 地址和私钥。它通过隐藏所有元数据来最小化数据痕迹，为私人通信加强强匿名性。",
          description_3_continue:
            "生成新的 PlexiMail 账户/地址或从其他钱包导入涉及多个步骤。请耐心回答提示，直到完成。",
          note: {
            text: "** 按下\"进入\"按钮表示您同意 ",
            link: "PlexiMail 条款和隐私政策"
          },
          note_continue: {
            text: "** 按下\"继续\"按钮表示您同意 ",
            link: "PlexiMail 条款和隐私政策"
          },
          button: "使用 Internet Identity 进入",
          one_click_resume: "一键恢复",
          try_live_demo: `尝试实时演示 (${TESTNET_NAME})`,
          reset: "重新开始",
          resume: "使用 Internet Identity 恢复",
          continue: "使用 Internet Identity 继续",
          incomplete_setup_detected:
            "您之前的配置会话未完成。恢复它或重新开始？",
          switch_wallet: "切换账户",
        },
        business: {
          title_1: "",
          zero: "0",
          title_2: "追踪业务",
          description_1:
            "简单、加密的解决方案来保护您的业务。",
          description_2:
            "通过我们的一系列安全业务应用程序，为您的公司电子邮件、日历、密码、网络等提供高级保护。",
          note: {
            text: "** 按下\"进入\"按钮表示您同意 ",
            link: "PlexiMail 条款和隐私政策"
          },
          note_continue: {
            text: "** 按下\"继续\"按钮表示您同意 ",
            link: "PlexiMail 条款和隐私政策"
          }
        },
        unlock: {
          title: "使用密码解锁",
          title_pin: "使用 PIN 码解锁",
          unlocking: "正在解锁...",
          idle_timeout: "在空闲超时后解锁缓存会话",
          button: {
            unlock: "解锁",
            forgot: "忘记 PIN 码或重置？",
            switch_wallet: "切换账户",
          },
        },
        dialog: {
          reset: {
            title: "忘记 PIN 码",
            content: {
              paragraph1:
                "仅凭正确的 PIN 码才能恢复本地维护的先前电子邮件上下文。",
              paragraph2:
                '按下"重置"以清除本地缓存，以便使用您的 Crypton 密钥重新进入。新条目允许重置 PIN 码。',
            },
            button: {
              cancel: "取消",
              reset: "重置",
            },
            message: {},
          },
          unsupported: {
            title: browserName + " 尚不支持",
            content: {
              paragraph1: "目前仅支持以下浏览器：",
              paragraph2: "Brave（推荐）",
              paragraph3: "Chrome",
              paragraph4: "Edge",
              paragraph5: "Firefox",
            },
            button: {},
          },
          notReady: {
            title: "PlexiMail 需要 MetaMask 和 Web3Storage",
            content: {
              paragraph1:
                "您即将进入 PlexiMail，这是最先进的安全邮件 dApp，得益于区块链技术的出现。您必须先安装一个加密货币钱包（MetaMask）并提供一定量的云存储（Web3Storage）。",
              paragraph2:
                "注意：MetaMask 和 Web3.Storage 都是值得信赖的开源 Web3 服务。我们犹豫将它们集成到我们的 PlexiMail 基线中，以免影响它们的可信度。它们也是进入 Web3 dApp 新世界的理想介绍。请在成功安装它们后返回此处尝试免费的 PlexiMail。",
              paragraph3:
                "如果您是经验丰富的 Web3 实践者，可以跳过此教程，否则我们建议您阅读。",
            },
            button: {
              skip: "跳过教程",
              read: "阅读教程",
            },
          },
          walletNotFound: {
            title: "未找到 MetaMask 钱包",
            content: {
              paragraph1: `PlexiMail 地址是从与您的 ${BLOCKCHAIN_NAME_CAMEL} 账户关联的公钥转换而来，由 MetaMask 钱包共同管理。您需要用加密货币为这些账户充值，因为通过 PlexiMail 智能合约进行的电子邮件逻辑会产生 ${COIN_SYMBOL} 代币费用。通过智能合约的所有交易都需要您在 MetaMask 应用中确认（"确认"或"签署"）。您和您的合作伙伴可以选择其中一个测试网络进行练习，通过在 MetaMask 的右上角展开默认网络并启用"显示/隐藏测试网络"。我们建议使用 ${TESTNET_NAME} 进行测试。前往 ${FAUCET_URL} 请求测试币.`,
            },
            button: {
              read: {
                title: "阅读教程",
              },
              install: {
                title: "安装 MetaMask",
                confirm: {
                  title: "安装 MetaMask",
                  content:
                    "请在 MetaMask 安装后刷新此网页以继续下一步",
                  button: "安装 MetaMask",
                },
              },
            },
          },
          confirm: {
            checkbox: {
              title:
                "我即将暂停并暂时切换到外部应用程序。我可以回来继续此配置过程。",
            },
            cancel: "取消",
          },
          tutorial: {
            slide1: {
              title: "PlexiMail",
              subtitle: "一个 Web3 安全电子邮件 dApp",
              content: {
                paragraph1_1:
                  "PlexiMail 是一个 Web3 dApp（去中心化应用程序）。这是我们提供的众多 Web3 应用程序之一。请访问 ",
                paragraph1_2: " 了解我们的 Counterseal 移动应用，或 ",
                paragraph1_3: " 了解我们的总体背景。",
                paragraph2:
                  '更长、更详细的介绍可以通过点击屏幕右下角的 "?" 框找到。',
              },
              button: {},
            },
            slide2: {
              title: `如果您不付费，您就是产品.`,
              content: {
                paragraph1:
                  "Web2 指的是我们今天所知的互联网版本，主要由提供免费服务的公司主导，以换取我们的个人数据。交换的条款通常被晦涩的语言所掩盖，以满足最低法律要求。我们的个人数据通过无所不知的监控技术被收集，这种技术没有边界且不留痕迹。所有流行的免费服务，如 Facebook、Twitter、Google、Outlook、WeChat、Telegram 等，都是根植于监控资本主义的 Web2 应用的典型例子。这是一个为顺利入职和随后剥利用戶而设计的\"养牛场\"模型。我们不知不觉地在眼前变成了产品。",
              },
              button: {},
            },
            slide3: {
              title: "监控资本主义",
              content: {
                paragraph1:
                  "Web3 是在意识到我们被 Web2 大科技公司像牛群一样驱赶以获取财务收益后成长起来的。无论通过多少隐私法规，都无法将我们从这种压迫性的\"养牛场\"环境底层拯救出来。我们需要一个新的开始。这就是 Web3 框架的由来，由区块链技术和代币化云存储提供支持。",
              },
              button: {},
            },
            slide4: {
              title: "不再有免费饲料",
              content: {
                paragraph1:
                  "可以肯定的是，要\"危险\"且独立地生活在 Web2 之外，意味着个人必须更加参与。至少，我们必须纠正我们对服务提供商所声称的隐私和安全性的扭曲概念，这需要我们教育自己真正了解安全保护是什么。然后我们面临资源问题——我们可以在哪里以及如何获得数据存储、处理能力和服务平台？事实证明，帮助其实就在眼前。",
              },
              button: {},
            },
            slide5: {
              title: "Web3 下的自给自足",
              content: {
                table: "已移除",
                paragraph1: `断奶这些免费服务后，上述红色项成为您的责任。您必须创建和保护您的数字身份，以便在 ${BLOCKCHAIN_NAME_CAMEL} 区块链上进入智能合约。您的身份由您的 <strong>MetaMask 钱包</strong> 中的区块链地址派生而来，进一步由密码作为第二因素安全性保护。您拥有由 <strong>Web3Storage</strong> 分配给您的私人云存储，这是由 Filecoin 提供的代币化存储服务.`,
              },
              button: {},
            },
            slide6: {
              title: "电子明信片和元数据",
              content: {
                paragraph1:
                  "在 Web3 下，您掌控自己的身份。这很重要，因为传统电子邮件就像电子明信片，所有参与方的身份都是公开的。这有问题，特别是因为电子邮件通信通常涉及敏感、私人事务。此外，电子邮件中的元数据使您容易受到黑暗行为者的利用。",
              },
              button: {},
            },
            slide7: {
              title: "匿名性和隐私性",
              content: {
                paragraph1: `PlexiMail 将您的 ${BLOCKCHAIN_NAME_CAMEL} 地址转换为带有 "${mailAddressSuffix()}" 作为域名的 PlexiMail 地址，由 <strong>MetaMask 钱包</strong> 中的私钥保护，仅由它们所代表的所有者持有。发送者/接收者的身份因此被匿名化，且与任何 PII（个人可识别信息）无关。功能上，它们由自发行/管理的数字资产（钱包中的密钥对）像 SSL 证书一样保护。这些有些笨拙的 PlexiMail 地址可以通过将其添加到您现有的或新的‘联系人’中来更好地管理。请注意，这些"联系人"由所有者本地维护，不会复制到邮件内容中.`,
                paragraph2:
                  "注意：甚至钱包地址也可以被匿名化。我们将提供这样的服务。",
              },
              button: {},
            },
            slide8: {
              title: "保证匿名性",
              content: {
                paragraph1:
                  "这就是如何通过 PlexiMail <strong>智能合约</strong>、信任最小化的 <strong>注册和通知转发器</strong> 以及个性化的 <strong>云 Web3Storage</strong> 建立端到端加密会话。更多细节在下一页。",
              },
              button: {},
            },
            slide9: {
              title: "保证匿名性",
              content: {
                paragraph1: `1. Alice 和 Bob 都通过 ${BLOCKCHAIN_NAME_CAMEL} 区块链上的 PlexiMail 智能合约注册他们的钱包地址和从多个候选服务器中选择的服务器.`,
                paragraph2:
                  "2. Alice 选择并在选定的注册服务器上准备预密钥存储。",
                paragraph3:
                  "3. Alice/Bob 私下交换他们的 PlexiMail 地址\"带外\"，为稍后的 TOFU（首次使用信任）过程做准备，将他们的身份与其各自的隐身地址绑定。",
                paragraph4: `4. 在 Bob 首次向 Alice 发送邮件之前，他从 ${BLOCKCHAIN_NAME_CAMEL} 数据存储和注册表中检索有关 Alice 的所有相关数据。然后他与 Alice 异步协商端到端信号加密会话，而 Alice 无需在线.`,
                paragraph5:
                  "5. Bob 将邮件内容放置在他自己的私人 Web3Storage 中，并向 Alice 推送通知，解密密钥仅授权给 Alice。",
                paragraph6:
                  "6. 收到通知后，Alice 从 Bob 的私人存储中检索内容。她在验证各种 TOFU 参数后才解密内容。",
              },
              button: {},
            },
            slide10: {
              title: "运行成本",
              subtitle: "一个 Web3 安全电子邮件服务",
              content: {
                paragraph1: `PlexiMail 是一个免费应用程序，但其运行消耗品，如电力、计算能力、传统磁盘存储、RAM、打印机、墨水、互联网连接等，并非免费。作为运行在 ${BLOCKCHAIN_NAME_CAMEL} 上的 Web3 dApp，它消耗 "${BLOCKCHAIN_NAME_CAMEL} 燃气"，这是 ${BLOCKCHAIN_NAME_CAMEL} 区块链对您使用其计算资源的收费。初始设置成本为燃气，每发送一封电子邮件收取极其象征性的 $0.0001 费用，以在必要时防止 DDOS。请注意，对于超大内容（例如，电子邮件和附件大到 1 GB）没有额外收费.`,
              },
              button: {},
            },
            slide11: {
              title: "获取您自己的钱包和 Web3Storage",
              content: {
                paragraph1:
                  "希望您现在对 PlexiMail 框架有了更好的了解。要获取 PlexiMail ++，请按照接下来页面中的提示安装 MetaMask 并从 Web3storage 站点申请 Web3 云存储。",
              },
              button: {},
            },
            slide12: {
              title: "",
              content: {
                paragraph1: `PlexiMail 使用您自己的私人 Web3.Storage 作为您的电子邮件存储库。过去，在去中心化网络上存储数据并不总是那么容易——但 web3.storage 正是为此而来。如今，互联网上的大多数数据都由亚马逊、谷歌和微软等大型存储提供商托管。这使开发人员更容易存储应用程序数据，但这些大型企业平台通过将开发人员和用户锁定在服务的围墙花园中创建了数据孤岛。更重要的是，随着市场继续整合，少数提供商实际上正在成为互联网的存储骨干.`,
                paragraph2:
                  '首先点击下方的"获取"按钮免费获取 5 GB。从您的 Web3Storage 仪表板的 "Account" -> "<strong>API Token</strong>" 中提取完成后的 API 令牌，稍后准备 PlexiMail 配置。',
              },
              button: {
                get: {
                  title: "获取 Web3.Storage",
                  confirm: {
                    title: "获取 Web3.Storage",
                    content:
                      "成功获取私人 Web3.Storage 后请返回此处。",
                    button: "获取 Web3.Storage",
                  },
                },
              },
            },
            slide13: {
              title: "",
              content: {
                paragraph1_1: `要使用 PlexiMail，您需要建立至少一个数字身份，并通过我们的 ${BLOCKCHAIN_NAME_CAMEL} 智能合约进行无信任注册，这需要您通过浏览器安装 MetaMask 钱包扩展。请按照我们的`,
                paragraph1_2: `了解有关 ${BLOCKCHAIN_NAME_CAMEL} 网络选项的更多信息以及如何为您的钱包充值（水龙头）。如果您想使用测试网络进行练习，请在 MetaMask 的右上角展开默认网络并启用"显示/隐藏测试网络"。我们建议使用 ${DEFAULT_NET_NAME} 进行测试。前往 ${FAUCET_URL} 请求测试币。请点击下方的"安装 MetaMask"框来安装 MetaMask.`,
              },
              button: {
                install: {
                  title: "安装 MetaMask",
                  confirm: {
                    title: "安装 MetaMask",
                    content: "MetaMask 安装完成后请返回此处。",
                    button: "安装 MetaMask",
                  },
                },
              },
            },
            slide14: {
              title: "恭喜",
              content: {
                paragraph1:
                  "如果 MetaMask 已安装并且 Web3Storage 已成功获取，您现在可以使用 PlexiMail 了。请点击下方的绿色框来配置 PlexiMail。",
              },
              button: {
                config: {
                  title: "配置 PlexiMail",
                },
              },
            },
          },
        },
      },
      setup_carousel: {
        go: "开始",
        intros: [{
          title: "欢迎使用PlexiMail",
          text: "您即将注册PlexiMail，接下来是...",
          steps: [
            "创建您的网络身份",
            "创建您的通行密钥"
          ],
          text2: "一种安全、注重隐私的登录PlexiMail的方式，无需使用密码或分享个人数据。"
        }, {
          title: "欢迎使用PlexiSign",
          text: "您即将注册PlexiSign，接下来是...",
          steps: [
            "创建您的网络身份",
            "创建您的通行密钥"
          ],
          text2: "一种安全、注重隐私的登录PlexiSign的方式，无需使用密码或分享个人数据。"
        }],
        cards: [
          {
            "title": "现代区块链钱包",
            "text": "您是唯一可以访问和管理钱包内容的人，包括您的ICP互联网身份，允许您安全地访问系统。",
            "image": "/bg.jpg"
          },
          {
            "title": "Signal协议",
            "text": "广受尊敬的通信加密协议，不断更新加密密钥，使监控和解密尝试变得极其困难。",
            "image": "/bg.jpg"
          },
          // {
          //   "title": "利用Web3存储",
          //   "text": "我们使您能够在Web3存储账户中自行管理数据，进一步限制对您正在处理和与他人共享的数据的访问。",
          //   "image": "/bg.jpg"
          // },
          {
            "title": "互联网身份与ICP区块链",
            "text": "PlexiSign和PlexiMail是\"无信任\"的 - 业务服务通过智能合约进行，而不是通过容易受到妥协和后门攻击的第三方。",
            "image": "/bg.jpg"
          },
          {
            "title": "包含PlexiMail",
            "text": "基于区块链的私有网络电子邮件，安全且可与所有标准电子邮件系统进行桥接。",
            "image": "/bg.jpg"
          },
          {
            "title": "包含PlexiSign",
            "text": "安全、专业的电子签名服务，采用按需付费的计费模式，价格实惠。",
            "image": "/bg.jpg"
          },
          {
            "title": "无PII或PCI",
            "text": "我们的系统不存储您的任何个人身份信息（PII）或支付卡行业数据（PCI），从而提高您的数据安全级别。",
            "image": "/bg.jpg"
          },
          {
            "title": "超越GDPR和CCPA",
            "text": "PlexiSign和PlexiMail不保留受GDPR和CCPA管辖的数据，因此您免受营销滥用的风险。",
            "image": "/bg.jpg"
          }
        ]
      },
      setup_method: {
        title: "恢复或重新开始配置",
        content: {
          paragraph1:
            '选择"恢复"以继续相同的配置，或"重新开始"以创建同一钱包的新配置。',
          paragraph2:
            "请确保您了解按下\"重新开始\"按钮会清除您过去的所有电子邮件。",
        },
        button: {
          create: {
            title: "重新开始",
          },
          restore: {
            title: "恢复",
          },
          back: {
            title: "返回",
          },
        },
      },
      backup_method: {
        title: "备份恢复数据",
        content: {
          paragraph1:
            "您的 PlexiMail 数据通过存储其根创建/恢复种子来备份，基于这些种子可以从您的先前备份中恢复所有早期的会话数据和内容。",
          paragraph2:
            "备份数据完全加密，并进一步采用我们的 Crypton 技术（专利申请中）进行保护。",
          paragraph3:
            "密码必须足够强才能被接受。类似句子的密码短语效果很好。",
          paragraph4: "剩余步骤：4/4    ",
        },
        button: {
          web3: {
            title: "存储到您的 Web3Storage",
          },
          local: {
            title: "本地存储",
          },
          back: {
            title: "返回",
          },
        },
      },
      restore_method: {
        title: "检索恢复数据",
        content: {
          paragraph1:
            "您的 PlexiMail 数据通过存储其根创建/恢复种子来备份，基于这些种子可以从您的永久 Web3Storage 中恢复所有先前的会话数据和内容。",
          paragraph2: "剩余步骤：3。",
        },
        button: {
          web3: {
            title: "从 Web3.Storage 检索",
          },
          local: {
            title: "从本地文件检索",
          },
          back: {
            title: "返回",
          },
        },
      },
      pwd: {
        override: {
          title: "警告",
          message: "此 Crypton 已存在。您想覆盖它吗？",
          button: {
            yes: "是",
            no: "否",
          },
        },
        initial: {
          step: "1 / 4: ",
          step_restore: "1 / 3",
          title: "保护您的配置数据库",
          recover_title: "解锁您的配置数据库",
          content: {
            paragraph1_1:
              "此密码用于保护您的 PlexiMail 配置以及管理所有电子邮件所需的完整会话上下文的 PlexiMail 身份。请确保记录：1）用于 Magic.Link 的电子邮件 2）用于 Web3.Storage 的电子邮件 3）此密码。它们对 PlexiMail 的备份和恢复至关重要。",
            paragraph1_2: "请输入保护密码。",
            paragraph2:
              "密码必须足够强才能被接受。足够长的类似句子的密码短语效果很好。",
          },
          tf: {
            pwd: {
              title: "密码",
            },
            confirm: {
              title: "确认密码",
            },
          },
          button: {
            next: {
              title: "下一步",
            },
            back: {
              title: "返回",
            },
          },
        },
      },
      mnemonic: {
        generate: {
          step: "2 / 4: ",
          title: "构建保护链",
          content: {
            paragraph1: "",
            paragraph2: "",
          },
          message: {
            copied: "已复制",
          },
          button: {
            display: { title: "生成助记词" },
            hide: { title: "隐藏助记词" },
            next: { title: "下一步" },
            gen: { title: "生成" },
            gen_save: { title: "生成" },
            back: { title: "返回" },
          },
        },
        restore: {
          step: "2 / 3: ",
          title: "恢复保护链",
          content: {
            paragraph1: "",
            paragraph2: "",
            paragraph3:
              "点击上方的助记词内容以复制到剪贴板。",
          },
          mnemonic: {
            label: "助记词",
            placeholder: "用于恢复的助记词",
          },
          button: {
            next: { title: "下一步" },
            web3: { title: "从 Web3.Storage 恢复" },
            local: { title: "从本地文件恢复" },
            back: { title: "返回" },
          },
        },
      },
      web3: {
        storage_selector: {
          title: "配置您的私人 Web3 存储",
          recover_title: "恢复您的私人 Web3 存储",
          content: {
            line1: `现在，掌控您的电子邮件隐私。设置您自己的私人电子邮件存储库，摆脱一些电子邮件提供商带来的监控风险.`,
            line2:`过去，在去中心化网络上私下管理自己的数据是具有挑战性的。然而，Filecoin 的出现提供了多种前端服务的解决方案。这些服务各自支持特定的应用模型并提供订阅选项。我们目前提供以下两种服务：`,
            line3: `提供 1GB 的免费存储作为入门计划，无需信用卡信息.`,
            line4: `提供 5GB 的免费存储作为入门计划，但`,
            line5: `需要信用卡`,
            line6: `信息进行订阅。此服务还使用公共电子邮件进行用户身份验证.`,
            line7: `访问他们的网站比较选项并选择最适合您需求的提供商。请注意，超过免费存储限制后会产生额外费用。设置 Lighthouse 仅在您选择超出免费层时才需要信用卡信息.`,
          },
          lighthouse: "Lighthouse",
          web3storage: "Web3.Storage",
          sharedWeb3storage: "共享 Web3.Storage",
          back: "返回",
        },
        lighthouse: {
          step: "1 / 2:",
          title: "配置您的私人 Lighthouse 存储",
          content: `请确认您选择的是免费的 Lighthouse 存储计划！此存储唯一且匿名地链接到您的 PlexiMail 钱包。您只需在选择升级到免费层之外时才需要提供支付信息.`,
          auth: "正在联系 Lighthouse...",
          import: {
            title: "",
            message: {
              ready: "",
              recover_web3: "正在恢复 Lighthouse 存储配置...",
              retrieve_folder: "正在从 Lighthouse 存储中检索邮件...",
              recover_signal: "正在恢复信号协议存储...",
              completed: "已完成！",
            },
            content: {
              paragraph1: "请选择一个配置文件",
            },
            button: {
              import: { title: "从已保存的文件导入" },
              import_phone: { title: "从您的手机导入" },
              back: { title: "返回" },
            },
          },
        },
        w3ui: {
          step: "1 / 2:",
          title: "配置您的私人 Web3 存储",
          content: `成功创建受 Ai-Fi 钱包保护的 PlexiMail 地址后，现在是时候获取并配置您自己的私人电子邮件存储库，而无需依赖任何电子邮件提供商。过去，在去中心化网络上存储数据并不总是那么容易——但 web3.storage 正是为此而来.`,
          note: "确认电子邮件将发送到此邮箱进行验证。花点时间切换到您的电子邮件客户端，通过点击 web3.storage 发送的\"验证电子邮件地址\"来响应验证电子邮件。如果提示，您可以使用信用卡注册，但最初可以选择免费选项。Web3.Storage 是最成熟的 Web3 存储提供商，对您的信用卡风险最小。验证后，继续配置过程。",
          verify: {
            title: "正在验证您的电子邮件地址...",
            message_1:
              "请花点时间切换到您的电子邮件客户端，",
            message_2:
              "以通过点击‘验证电子邮件地址’来响应验证电子邮件。",
            message_3: "您可以要求重新发送",
            message_4: "秒后。",
            message_5: "重新发送",
            message_6: "如果未成功。",
          },
          shared: {
            config_storage: "正在配置存储...",
          },
        },
        config: {
          step: "3 / 4: ",
          step_restore: "最终: ",
          title: "您的存储，您的规则",
          recover_title: "恢复 Web3 存储",
          content: {
            paragraph1_1: "访问",
            paragraph1_2:
              "以获取您的私人 Web3 存储。完成 Web3 账户设置后，点击 web3.storage 页面右上角的\"账户\"按钮，选择\"API 令牌\"以复制长令牌字符串。",
            paragraph1_3:
              "您的 Web3Storage 的\"API 令牌\"已从您的配置数据库中自动填充。虽然有可能被您的 Web3 存储提供商使无效。如果下方的\"下一步\"按钮返回错误，请返回并通过恢复您的 Web3 账户获取新的令牌。（点击 web3.storage 账户页面右上角的\"账户\"按钮，选择\"API 令牌\"以复制长令牌字符串。",
            paragraph2:
              "粘贴您的 Web3 存储令牌，以便 PlexiMail 定位您的私人存储。",
            tokenTextField: {
              placeholder: "在此输入您的 Web3 存储 API 令牌",
            },
            paragraph3:
              "所有您的 PlexiMail 数据都存储在您从 Web3Storage 获取的私人存储空间中。尽管它显而易见，但通过来自您自己的钱包的动态密钥进行匿名化和完全加密，其强度等同于任何公共区块链交易密钥。",
            invalid_token:
              "API 令牌格式不正确。请验证并确保完整字符串已复制。",
            as_default: "作为默认存储",
          },
          button: {
            next: { title: "下一步" },
            back: { title: "返回" },
          },
        },
        import: {
          title: "",
          message: {
            ready: "",
            recover_web3: "正在恢复 Web3.Storage 配置...",
            retrieve_folder: "正在从 Web3.Storage 中检索邮件...",
            recover_signal: "正在恢复信号协议存储...",
            completed: "已完成！",
          },
          content: {
            paragraph1: "请选择一个配置文件",
          },
          button: {
            import: { title: "从已保存的文件导入" },
            import_phone: { title: "从您的手机导入" },
            back: { title: "返回" },
          },
        },
        mnemonic_recover: {
          title: "从助记词恢复钱包",
          token: {
            label: "Web3.Storage API 令牌",
            placeholder: "Web3 存储 API 令牌",
          },
          mnemonic: {
            label: "助记词",
            placeholder: "用于恢复的助记词",
          },
          button: {
            close: { title: "关闭" },
            recover: { title: "恢复" },
          },
          trigger: { title: "从助记词恢复" },
        },
      },
      signal: {
        initial: {
          step: "最终: ",
          title: "准备信号运行时",
          content: {
            paragraph1:
              "成功设置您的 web3 存储后，恭喜！我们采用信号协议来保护您的端到端通信会话。您的 PlexiMail 地址在此步骤中绑定到钱包中的私钥，这会根据情况生成一系列会话密钥和其他安全参数。",
            paragraph2: `请准备允许使用 ${BLOCKCHAIN_NAME_CAMEL} 钱包中的密钥签署确认交易（如果需要）。`,
            paragraph3:
              "了解更多关于 Open Whisper Systems 和信号协议的信息。",
          },
          button: {
            next: { title: "继续" },
            back: { title: "返回" },
          },
        },
      },
      export: {
        default: {
          step: "步骤 7: ",
          title: "备份 PlexiMail 配置",
          content: {
            paragraph1:
              "您的 PlexiMail 会话配置和密钥生成材料保存在浏览器中，作为\"Cookie 和其他网站数据\"，在\"隐私和安全\"设置下，可能会被意外清除。为了便于恢复，可以在此备份/导出这些配置数据以恢复您的会话。请注意，您的身份或 PlexiMail 地址通过更严格的密码机制单独保护。",
          },
          button: {
            export: { title: "导出配置" },
            back: { title: "返回" },
          },
        },
      },
      wait: {
        default: {
          title: "等待交易回执...",
          content: {
            paragraph1: `您的 PlexiMail 地址和会话数据通过智能合约在 ${BLOCKCHAIN_NAME_CAMEL} 区块链上得到保护。请等待此过程完成.`,
            paragraph2: "正在检查交易回执...",
            paragraph3:
              "获取交易回执失败。请稍后再试。",
            paragraph4:
              "交易已确认，将在 10 秒后自动进入 PlexiMail...",
          },
          button: {
            enter: { title: "进入 PlexiMail" },
            retry: { title: "重试" },
            back: { title: "返回" },
          },
        },
      },
      on_click_create: {
        title: "一键创建",
        loading: "新创建的账户正在初始化",
        description:
          "大多数情况下，当用户恢复 PlexiMail 时，他们仍会使用之前的配置。按照正常恢复过程步骤非常繁琐。一键恢复为此场景提供了快捷方式。",
        note: "* 如果隐私级别与当前运行平台不一致，将修改为适应新环境。",
        button: {
          back: "返回",
          retry: "重试",
        },
      },
      one_click_resume: {
        title: "一键恢复",
        description:
          "大多数情况下，当用户恢复 PlexiMail 时，他们仍会使用之前的配置。按照正常恢复过程步骤非常繁琐。一键恢复为此场景提供了快捷方式。",
        note: "* 如果隐私级别与当前运行平台不一致，将修改为适应新环境。",
        button: {
          back: "返回",
          retry: "重试",
        },
      },
      one_click_create: {
        title: "一键创建",
      },
      main: {
        title: "PlexiMail",
        sidebar: {
          create: "创建文件夹",
        },
        profile: {
          addresses: "地址",
          exit: "退出",
          terms_and_privacy:"隐私政策",
          copied: "已复制",
          hello: "您好"
        },
        menu: {
          apps_section: "应用",
          account_section: "我的账户",
          global_section: "全局",
          operations_section: "操作",
          wallet: "钱包",
          settings: "设置",
          help: "帮助",
          buy_eth: "购买 Eth",
          profile: "地址",
          contacts: "联系人",
          more: "高级",
          tutorial: "教程",
          sign_out: "退出",
          switch_account: "切换账户",
        },
        dialog: {
          pwa: {
            title: "PlexiMail 可以作为独立的 Web 应用程序运行",
            content: {
              paragraph1:
                "PlexiMail 可以打包为在独立窗口中运行，几乎像原生应用一样，可通过其专用应用程序图标在桌面上独立搜索和启动。",
            },
            button: {
              cancel: "跳过",
              install: "安装 PlexiMail",
            },
          },
          create_folder: {
            title: "创建文件夹",
            content: {
              name: "名称: ",
              parent: "位于: ",
            },
            button: {
              cancel: "取消",
              save: "保存",
            },
            message: {
              folder_name_is_empty: "文件夹名称不能为空",
              character_is_not_allowed: "不允许的字符",
              folder_already_exists: "文件夹已存在",
              folder_name_is_too_long: "文件夹名称长度超过了128个字符",
            },
          },
          sign_out: {
            title: "您确定要退出 PlexiMail 吗？",
            content: {
              paragraph1:
                "退出后，所有缓存的会话上下文将被清除！",
              paragraph2:
                '要重新连接到当前 PlexiMail 会话，请选择"恢复"然后"恢复"选项。',
            },
            button: {
              cancel: "取消",
              sign_out: "退出",
            },
          },
        },
      },
      list: {
        welcome: {
          title: "没有消息",
          sub_title: "通过 PlexiMail Pro 完成闭环",
          description:
            "尽管即时消息、短信和社交网络的兴起，电子邮件仍然是主要的业务协作工具。不幸的是，电子邮件的不安全性使敏感信息容易受到恶意攻击。通过 PlexiMail Pro 区分您的品牌，阻止似乎无法阻止的网络钓鱼大流行，培养客户信任并确保遵守隐私法规。",
          action: "了解更多",
        },
        includes_plexisign_messages: "包含 PlexiSign 消息",
      },
      previewer: {
        menu: {
          back: "返回",
          reply: "回复",
          reply_all: "回复全部",
          forward: "转发",
          move: "移动",
          delete: "删除",
          reload: "重新加载",
          actions: "操作"
        },
        send_date: "发送于",
        from: "发件人",
        to: "收件人",
        cc: "抄送",
        bcc: "密送",
        subject: "主题",
        content: "内容",
        attachment: "附件",
        message: {
          attachment: {
            title: "附件",
            download: {
              downloading: "正在下载，请稍候",
              is_in_progress: "下载中",
              progress: {
                paragraph1_1: "已下载 ",
                paragraph1_2: " / ",
                paragraph2: "已下载",
              },
            },
          },
          failed_to_load: "无法加载消息",
          select_folder: "请选择要移动到的文件夹",
          moving: "正在移动...",
          deleting: "正在删除...",
          moved: "已移动",
          moved_to_trash: "消息已移动到垃圾箱",
          deleted: "已删除",
          tofu_changed:
            '发件人的签名自您上次通信以来已更改。您可能需要通过其他渠道重新验证发件人身份。只有在一切正常的情况下，才按"信任并解密"。',
          tofu_new:
            '这是您第一次收到此发件人的 PlexiMail。您可能需要通过其他渠道验证发件人的真实性。只有在一切正常的情况下，才按"信任并解密"。',
        },
        tofu: {
          verify: `PlexiMail 采用与 ${BLOCKCHAIN_NAME_CAMEL} 相同的签名方案，并依赖其智能合约来验证注册用户并支持在线可审计性.`,
          steps: "",
          sender: "发件人",
          idkey: "身份密钥",
          signature: "签名",
          address: "地址",
          copied: "已复制",
          verified: "",
          miss: "",
          correct: "正确",
          incorrect: "不正确",
        },
        dialog: {
          add_contact: {
            title: "添加联系人",
            content: {
              name: "姓名: ",
              email: "PlexiMail 地址: ",
            },
            button: {
              cancel: "取消",
              add: "添加",
            },
          },
          move_message: {
            title: "移动消息",
            button: {
              cancel: "取消",
              move: "移动",
            },
          },
          cid_not_found: {
            title: "下载失败",
            message:
              "由于 PlexiMail 流量较大，您的下载请求暂时无法满足。您可以选择持续重试直到完成，或者稍后再来检查。请耐心等待，因为等待时间难以预测。10 ~ 20 分钟是常见的，世界纪录约为 3 小时。",
          },
        },
      },
      editor: {
        title: {
          new_message: "新消息",
          reply: "回复",
          reply_all: "回复全部",
          forward: "转发",
        },
        sent_by: "由 PlexiMail 发送",
        full_screen: "全屏",
        exit_full_screen: "退出全屏",
        content: {
          pwd: {
            passcode: "密码",
            title: "请输入用于加密此消息的密码",
            description:
              "发送加密电子邮件到非 PlexiMail 收件人需要密码。",
            allow_reply: "允许收件人回复",
            allow_reply_explain:
              "（仅当有一个收件人时才允许回复）",
            assist_account_creation:
              "协助收件人使用简化的 PlexiMail 注册脚本。",
            cancel: "取消",
            next: "下一步",
            passcode_less_than_128: "密码长度不能小于 128 位",
            copied: "已复制"
          },
          tofu: {
            message:
              "这是您第一次向列表末尾的收件人发送 PlexiMail。您可能需要通过其他渠道验证他们的身份。",
            verify: `PlexiMail 采用与 ${BLOCKCHAIN_NAME_CAMEL} 相同的签名方案，并依赖其智能合约来验证注册用户并支持在线可审计性.`,
            title: "不受信任的收件人",
            idkey: "身份密钥",
            signature: "签名",
            address: "地址",
            copied: "已复制",
            miss: "",
            correct: "正确",
            incorrect: "不正确",
          },
          editor: {
            from: {
              title: "发件人: ",
            },
            to: {
              title: "收件人: ",
              placeholder: `例如 0x0...000${mailAddressSuffix()} 或来自联系人的名称（必需）`,
              placeholder_more: "在此输入更多收件人",
              show_contact: "选择收件人",
            },
            subject: {
              title: "主题: ",
              placeholder: "",
            },
            content: {
              initial_content: "由 PlexiMail 发送",
            },
            attachment: {
              title: "附件",
            },
          },
          contacts: {
            title: "选择收件人",
            content: {
              search: "搜索...",
              empty: "没有联系人",
            },
            button: {
              confirm: "确认",
            },
          },
        },
        message: {
          upload: {
            paragraph1_1: "正在上传... (",
            paragraph1_2: " 已上传)",
            paragraph1_3: "正在上传...",
            paragraph1_4: "已上传 ",
            paragraph1_5: " / ",
            encrypting: "正在加密...",
          },
          address: {
            invalid_addr_1: "上述地址",
            invalid_addr_2:
              "未被识别。请确保所有地址格式正确。",
            invalid_eth:
              "不能同时向传统邮箱和 PlexiMail 邮箱发送电子邮件。",
            invalid_normal:
              "不能同时向多个传统邮箱发送电子邮件。",
          },
          sent: "消息已发送！",
          restriction:
            "桥接功能是单向的，不接受回复。",
        },
        button: {
          add_attachment: {
            title: "",
            tips: "添加附件",
          },
          send: {
            send: "发送",
            trust_and_send: "信任并发送",
          },
        },
        unverified: {
          title: "警告",
          description_1:
            '您的 PlexiMail 地址目前处于"已通过 ICP 验证"状态，这会给您的合作伙伴带来额外负担，而无法享受通过 PlexiMail 智能合约注册的优势。',
          description_2:
            '要升级此状态，只需点击主屏幕左上角显示的"已通过 ICP 验证"状态，然后按照提供的说明进行操作。或者，您可以从"设置"中升级此状态。',
          description_3: "",
          dont_show_again: "不再显示此消息",
          next: "下一步",
        },
        save_draft: {
          title: "保存草稿",
          description:
            "我们检测到缓冲区中有一个未发送的草稿。您想保存它吗？",
          discard: "丢弃",
          save: "保存",
        },
        load_draft: {
          title: "加载草稿",
          description: "之前保存了一个草稿副本。",
          discard: "丢弃",
          recover: "恢复",
        },
      },
      settings: {
        account_title: "高级",
        title: "设置",
        message: {
          cache_cleard: "缓存数据已清除",
        },
        list: {
          export: {
            title: "导出配置设置",
            description:
              "配置设置将帮助在任何丢失事件后恢复您的 PlexiMails。",
          },
          mnemonic: {
            title: "显示助记词",
            description:
              "显示种子短语以恢复所有加密密钥材料。",
          },
          privateKeys: {
            title: "显示 Lighthouse 账户",
            description:
              "显示 Lighthouse 账户以填写 Metamask 钱包。",
          },
          clear: {
            title: "清除缓存数据",
            description:
              "为了性能，所有收到的 PlexiMails 都会本地缓存。它们可能会变得非常大。",
          },
          close: {
            title: "关闭您的 PlexiMail",
            description:
              "此账户产生的所有数据将从 canister 中永久删除。",
          },
          backup_wallet: {
            title: "备份钱包",
            description: "",
          },
          change_w3s_api_token: {
            title: "迁移到不同的 Web3Storage",
            description: "可以通过这种方式扩展存储空间",
          },
          change_pin: {
            title: "更改 PIN 码",
            description: "",
          },
          verify_sender: {
            title: "显示邮件发件人的风险级别",
            description:
              "评估并显示邮件发件人的风险级别——这可能会影响性能。",
          },
          upgrade: {
            title: "使用 PlexiMail 区块链注册",
            description:
              "通过 PlexiMail 智能合约验证和注册。这将产生 AVAX 智能合约费用。",
          },
        },
        dialog: {
          export_confirm: {
            title: "选择导出配置的位置",
            content:
              '按"导出为文件"将配置打包为文件以手动下载，或按"同步到您的手机"加密并上传到您的手机。',
            button: {
              download: "导出为文件",
              sync: "同步到您的手机",
            },
          },
          sync: {
            title: {
              export: "将配置备份到您的手机",
              import: "从您的手机导入配置",
            },
            content: {
              paragraph1: "扫描以连接到您的手机",
              paragraph2: "下载并安装移动应用",
            },
            button: {
              cancel: "取消",
              done: "完成",
            },
          },
          mnemonic: {
            title: "显示助记词",
            message: {
              copied: "已复制",
            },
            content: {
              paragraph1:
                "点击上方的助记词内容以复制到剪贴板。",
              paragraph2: "助记词非常重要",
            },
            button: {
              hide: "隐藏助记词",
              display: "显示助记词",
              copy: "复制到剪贴板",
              close: "关闭",
            },
          },
          privateKeys: {
            title: "显示 Lighthouse 账户",
            message: {
              copied: "已复制",
            },
            content: {
              paragraph1: "点击上方的内容以复制到剪贴板。",
              paragraph2: "账户非常重要",
            },
            button: {
              hide: "隐藏 Lighthouse 账户",
              display: "显示 Lighthouse 账户",
              copy: "复制到剪贴板",
              close: "关闭",
            },
          },
        },
      },
      profile: {
        title: "地址",
        content: {
          copy: "此 QR 图像代表您的 PlexiMail 地址，由下方自动生成的密码保护。请截屏或保存 QR 图像以分享您的 PlexiMail 地址。点击眼睛图标以查看并复制自动生成的密码。通过独立渠道安全地将密码发送给您的合作伙伴。使用两个独立的渠道发送 QR 图像和密码以确保安全交付。",
          note: "如果您通过截屏分享地址，请保持密码隐藏。",
        },
        message: {
          copied: "已复制",
        },
        save: {
          title: "保存为地址令牌",
          message:
            "将您的 PlexiMail 地址编码为 QR 码文件，以便传递给您的朋友和合作伙伴。",
          checkbox: "使用可选密码加密文件内容。",
          input: "请输入密码",
          button: { next: "保存", cancel: "取消" },
        },
        button: {
          refresh: "重新生成 QR 码",
          copy: "复制地址",
          close: "关闭",
          save: "保存为地址令牌",
          back: "返回",
        },
        delete_address: "删除地址",
        delete_address_confirmation: "您确定要删除以下地址吗：",
        deleting_address: "正在删除地址 ...",
        cancel: "取消",
        delete: "删除",
        empty_address: "地址不能为空",
        "name_contains_special_characters": "姓名不能包含特殊字符",
        add_incognito_address: "添加匿名地址",
        add_normal_address: "添加普通地址",
        generate_address_message: "点击\"添加\"按钮后将生成一个匿名的PlexiMail地址。",
        human_readable_address: "人类可读地址",
        saving_address: "正在保存地址 ...",
        add: "添加",
        loading_addresses: "正在加载地址 ...",
        refresh: "刷新",
        close: "关闭",
        my_addresses: "我的地址",
        new_incognito_address: "新匿名地址",
        new_normal_address: "新普通地址",
        label: "标签"
        
      },
      qrcode: {
        alert: {
          title: "输入 PlexiMail 地址",
          trigger: "扫描",
          scan_message:
            "按\"打开\"选择 QR 码图像文件；如果可以通过相机读取 QR 码，则按\"扫描\"。",
          decode_message: "按\"解码\"解码所选文件。",
          cancel: "取消",
          decode: "解码",
          next: "下一步",
        },
        pwd: {
          title: "需要密码",
          message:
            "传递的代码已加密以保护隐私。如果您没有密码，请联系发件人获取。",
          input: "请输入密码",
          button: {
            cancel: "取消",
            next: "解密",
          },
        },
        zip: {
          title: "需要密码",
          message:
            "传递的密码已加密以保护隐私。请输入解密密码。",
          input: "请输入密码",
          button: {
            cancel: "取消",
            next: "打开",
          },
        },
        scanner: {
          title: "扫描 QR 码",
          message: "请将相机对准 QR 码。",
          button: { cancel: "取消" },
        },
        button: { open: "打开", scan: "扫描" },
      },
      contacts: {
        title: "联系人",
        editTitle: "编辑联系人",
        addTitle: "新建联系人",
        previewTitle: "联系人",
        content: {
          list: {
            search: {
              placeholder: "搜索...",
            },
            new_contact: "新建",
            add: "添加",
            import: "导入",
            empty: "没有联系人",
          },
          editor: {
            name: "姓名: ",
            email: "PlexiMail 地址: ",
            save: "保存",
            back: "返回",
            delete: "删除",
          },
          preview: {
            name: "姓名: ",
            email: "PlexiMail 地址: ",
            back: "返回",
          },
        },
        message: {
          empty_name: "姓名不能为空",
          empty_email: "PlexiMail 地址不能为空",
          name_too_long: "姓名长度超过 128 个字符",
          email_too_long: "邮箱地址超过 256 个字符",
          invalid_name: "姓名无效",
          invalid_email: "PlexiMail 地址无效",
          repeated: "您的 PlexiMail 地址已存在",
        },
      },
      buy_eth: {
        title: `用 Plexi 代币兑换 ${COIN_SYMBOL}`,
        head: "Plexi 代币",
        status: {
          unused: "未使用",
          redeemed: "已使用",
          refunded: "已退款",
        },
        messages: {
          no_ecash: "没有 Plexi 代币",
          getting_current_price: `获取当前 ${COIN_SYMBOL} 价格...`,
          current_price_1: `当前 ${COIN_SYMBOL} 价格: $`,
          current_price_2: ` / ${COIN_SYMBOL}`,
          test_note: `这是为测试网购买 Plexi 代币的模拟过程。返回的金额固定为 0.01 ${COIN_SYMBOL}，无论模拟购买的面值如何，因为我们的测试币供应有限.`,
        },
        qrcode: {
          title: `用 Plexi 代币购买 ${COIN_SYMBOL}`,
          description: "",
        },
        table: {
          head: {
            col0: "",
            col1: "Plexi 代币",
            col2: "面值 ($)",
            col3: "状态",
            col4: "删除",
          },
          body: {
            empty_title: "要兑换的代币列表为空",
            empty:
              '按"扫描"按钮将 Plexi 代币添加到兑换列表中。',
          },
          foot: {
            prefix: "总计: $",
            suffix: ` ${COIN_SYMBOL}`,
          },
        },
        foot: {
          buy_ecash: "购买 Plexi 代币",
          buy_eth: "兑换",
        },
      },
    },
    // slide.1.paragraph.1

    es: {
      appName: "PlexiMail",
      error: {
        rpc: {
          "-32002":
            "Su solicitud está en cola detrás de una pendiente para su billetera, que puede estar oculta debajo de otras ventanas. Recupere su aplicación de billetera y borre primero las entradas pendientes.",
        },
        client: {
          miss_param: "Falta el parámetro de datos",
          miss_signature: "Falta el parámetro de firma",
          invalid_signature: "Firma inválida",
          not_in_blockchain: " no se encontró en la blockchain",
          name_empty: "El nombre no debe estar vacío",
          email_empty: "Dirección de PlexiMail inválida",
          contact_already_existed: "La entrada de contacto ya existe",
          invalid_signal_message: "Error del sistema (Mensaje de señal inválido)",
          invalid_message_type: "Error del sistema (Tipo de mensaje inválido)",
          prekey_message_not_found: "Error del sistema (Mensaje de preclave no encontrado)",
          enc_data_undefined: "Error del sistema (Datos de cifrado no encontrados)",
          enc_data_null: "Error del sistema (Datos de cifrado no encontrados)",
          unsupported_data_type_1: "tipo de datos ",
          unsupported_data_type_2: " no es compatible",
          plaintext_null: "Error del sistema (Los datos de cifrado no deben ser nulos)",
          failed_clear_cache: "Error del sistema (Fallo al borrar la caché)",
          lost_conn: "Conexión perdida",
          ws_not_ready: "Error del sistema (Web socket no está listo)",
          att_not_bob: "Error del sistema (el adjunto no es de tipo Blob)",
          enckey_bundle_not_found: "Error del sistema (Paquete de clave de cifrado no encontrado)",
          enckey_for_att_not_found_1: "Error del sistema (Clave de cifrado para el adjunto ",
          enckey_for_att_not_found_2: " no encontrada)",
          enckey_for_msg_not_found_1: 'Error del sistema (Clave de cifrado para el mensaje "',
          enckey_for_msg_not_found_2: '" no encontrada)',
          metamask_not_installed: "MetaMask no está instalado",
          wallet_not_found: "Billetera no encontrada",
          idkey_not_found: "Error del sistema (Par de claves de identidad no encontrado)",
          devid_lost: "ID del dispositivo no encontrado",
          regid_lost: "ID de registro no encontrado",
          idkey_lost: "Par de claves de identidad no encontrado",
          msg_is_null: "El mensaje no debe estar vacío",
          unsupported_msg_type: "Tipo de mensaje no compatible",
          file_not_found: "Archivo no encontrado ",
          timeout_retry: "Error o tiempo de espera: haga clic para reintentar o salir por ahora.",
          idkey_not_identical: "Las claves de identidad no coinciden",
          account_not_in_blockchain: "Cuenta no encontrada en la blockchain",
          need_a_subscription: "Debes suscribirte a PlexiSign para seguir usándolo",
          attachment_size_exceeded: 'El adjunto excede el límite de 100MB',
        },
      },
      common: {
        message: {
          prepare_env: "Preparando entorno...",
          supply_prekeys: "Suministrar preclaves...",
          generate_keys:
            "Generando clave de identidad, ID de registro y preclaves...",
          save_prekey: "Almacenando el paquete de preclaves en la nube...",
          save_idkey: "Guardando la clave de identidad en el contrato inteligente...",
          wait_tx_receipt: "Esperando el recibo de la transacción...",
          save_signal: "Guardando el almacén del protocolo Signal...",
          completed: "¡Completado!",
          wallet_is_backup:
            "Su cuenta autogestionada ha sido generada y sus identidades PlexiMail creadas.",
          wallet_safe_smart_contract:
            "Su billetera se almacena de forma segura en su almacenamiento privado. Su correspondiente identidad PlexiMail está registrada en la blockchain ICP para una auditabilidad autogestionada y anónima. Recuerde proteger sus cerraduras dobles. Explore la configuración para elegir opciones adicionales de seguridad y auditoría.",
          checking_balance: `Comprobando el saldo de la cuenta ${COIN_SYMBOL}...`,
          wait_funds: "pendiente de las acciones de financiación externas ...",
          incorrect_password: "El código PIN es incorrecto",
          init_web3_storage: "Inicializando Storage...",
          backup_wallet: "Haga una copia de seguridad de su billetera ...",
          sync_folders: "Sincronizando carpetas...",
          create_wallet: "Creando billetera...",
          recover_wallet: "Recuperando billetera...",
          acquire_storage: "Obteniendo Storage...",
          config_storage: "Configurando Storage...",
          initial_signal: "Inicializando Signal...",
          completed_initialization: "Inicialización completada, guardando datos...",
          retrieve_folder: "Recuperando carpetas...",
          recover_signal: "Recuperando Signal...",
          completed_recovery: "Recuperación completada, guardando datos...",
          sign_in_with_ii: "Iniciando sesión con Internet Identity...",
        },
        learn_more: "Más información",
        retry: "Reintentar"
      },
      tips: {
        tip0: "Tu identidad ha sido verificada por ICP, quien es un socio de PlexiSign para iniciar, procesar, completar y gestionar tus flujos de trabajo de firma digital.",
        tip1: "La carpeta 'Todos' contiene todos los flujos de trabajo y procesos de contratos digitales que hayas iniciado en cualquier estado, desde el inicio hasta la finalización. Cualquier cosa que hayas archivado aparecerá solo en la carpeta 'Archivo Seguro'.",
        tip2: "La carpeta 'Iniciados' contiene todos los flujos de trabajo y procesos de contratos digitales que hayas iniciado pero que aún no hayan avanzado a o más allá de la etapa de 'Ronda de Firma'.",
        tip3: "La carpeta 'Ronda de Firma' contiene todos los flujos de trabajo y procesos de contratos digitales que hayas iniciado y que hayan avanzado a la etapa de 'Ronda de Firma'. Los demás que estén en proceso aparecerán en las carpetas 'Iniciados', 'Completados' o 'Archivo Seguro' dependiendo de su estado actual o si los has archivado.",
        tip4: "La carpeta 'Completados' contiene todos los flujos de trabajo y procesos de contratos digitales que hayas iniciado y que hayan finalizado. Los demás que estén en proceso aparecerán en las carpetas 'Iniciados', 'Ronda de Firma' o 'Archivo Seguro' dependiendo de su estado actual o si los has archivado.",
        tip5: "La carpeta 'Archivo Seguro' contiene todos los flujos de trabajo y procesos de contratos digitales que hayas archivado manualmente. Estos pueden estar en cualquier estado al momento de archivarlos y serán eliminados de su carpeta anterior independientemente de su estado. Los demás que estén en proceso aparecerán en las carpetas 'Iniciados', 'Ronda de Firma' o 'Completados' dependiendo de su estado actual.",
        tip6: "Inicia un nuevo flujo de trabajo de firma digital al abrir el cliente de correo electrónico, listo para ser completado y configurado.",
        tip7: "La opción Avanzado te permite gestionar tus configuraciones de seguridad.",
        tip8: "El menú desplegable Principal permite al usuario gestionar 'Mi Cuenta' y las 'Configuraciones Globales' al utilizar PlexiSign. Mi Cuenta incluye ver o gestionar tus direcciones de PlexiSign, los Contactos con los que has trabajado y tus configuraciones de seguridad. Las configuraciones globales incluyen gestionar tu acceso y datos.",
        tip9: "En Configuraciones puedes gestionar tus datos o actualizar tu código PIN para usar al bloquear tu pantalla.",
        tip10: "Salir te desconectará completamente de PlexiSign, requiriendo que proporciones tu identidad y clave de acceso (almacenada en tu computadora) la próxima vez que reinicies PlexiSign. Tu 'Identidad' es el número de varios dígitos que creaste y te pidieron guardar durante tu configuración.",
        tip11: "Bloquear Pantalla devolverá tu pantalla al estado bloqueado sin salir de tu sesión. Puedes acceder a PlexiSign desde este estado desbloqueando tu pantalla con tu código PIN de 6 dígitos.",
        tip12: "Panel de Empresa",
        tip13: "Contactos te ayuda a buscar y encontrar cualquiera de las direcciones de correo electrónico que hayas utilizado al iniciar y gestionar flujos de trabajo y procesos de firma digital.",
        tip14: "Ayuda",
        tip15: "Perfil",
        get_credits: "Obtenga $15 en créditos"
      },
      app: {
        mode: {
          unverified: "No verificado",
          verified: "Verificado por ICP",
        },
        privacy_level: {
          standard: "Privacidad estándar",
          high: "Alta privacidad",
        },
        message: {
          ready: "¡Listo!",
          new_message: "¡Nuevos mensajes entrantes!",
          prepare_signal: "Preparando el entorno Signal...",
          check_prekeys: "Comprobando preclaves. Por favor, espere...",
          generate_prekeys: "Generando preclaves. Por favor, espere...",
          save_prekeys: "Guardando preclaves. Por favor, espere...",
          load_contact: "Cargando contactos. Por favor, espere...",
          load_messages: "Cargando PlexiMails. Por favor, espere...",
        },
        dialog: {
          contract_intro: {
            "title": "Ronda de Firma",
            "content1": "¡Prepárese para iniciar la Ronda de Firma para ejecutar el acuerdo:",
            "content2": "Este asistente simplifica el inicio de la ronda de firma de su acuerdo con todos los participantes. Como moderador, puede utilizar la carta de presentación proporcionada como ejemplo para guiarlos a través del proceso de firma. Además, puede utilizar el botón \"Plantillas\" al final para guardar, seleccionar o crear su propia carta de presentación a partir de sus colecciones. ¡La carta de presentación es personalizable! Personalícela llenando o eliminando los marcadores entre llaves (por ejemplo, {{Nombre del Cliente}}) o combinando campos según sea apropiado.",
            "content3": "Aquí está lo que necesita hacer:",
            "content4": "<strong>Proporcione información de los participantes: </strong>Ya que actualmente todas las personas involucradas no están identificadas, por favor ingrese los datos de contacto necesarios para cada participante. Esto incluirá algunos Datos de Identificación Personal (PII) como nombres y direcciones de correo electrónico.",
            "content5": "<strong>Autenticación de dos factores (opcional): </strong>Para mayor seguridad, PlexiSign puede ayudar a enviar códigos de autenticación de dos factores (2FA) a los teléfonos móviles o direcciones de correo electrónico de los participantes si elige habilitarlo.",
            "content6": "<strong>Adjunte todos los materiales contractuales individualmente </strong> utilizando el botón \"Adjuntar\" para su revisión y firma finales.",
            "content7": "Beneficios de la información de los participantes:",
            "content8": "<strong>Proceso de firma más rápido: </strong>Tener información de contacto precisa garantiza que todos reciban la notificación de firma de inmediato.",
            "content9": "<strong>Mayor seguridad: </strong>Al proporcionar datos de contacto, puede verificar la identidad de cada participante antes de la firma, reduciendo el riesgo de acciones fraudulentas.",
            "content10": "¡Comencemos!",
            "next": "Siguiente",
            "cancel": "Cancelar"
          },
          private_key: {
            lighthouse_for_storing_pleximail: "Lighthouse para Almacenar PlexiMail",
            lighthouse_for_backup_pleximail: "Lighthouse para Copia de Seguridad PlexiMail",
          },
          delete_account: { 
            title: "Eliminar mi cuenta de PlexiMail",
            description: "Todos los datos producidos por esta cuenta se borrarán permanentemente de los contenedores.",
            cancel: "Cancelar",
            delete: "Eliminar",
            deleting: "Eliminando...",
            please_try_again_later: "Por favor, inténtelo de nuevo más tarde.",
            failed_to_delete: "Error al eliminar la cuenta."
          },
          search: {
            title: "Buscar mensajes",
            tips: "Busca mensajes por palabras clave, remitente, destinatario, asunto o contenido.",
            search: "Buscar",
            noResults: "Sin resultados",
            noBackup: "Sin copia de seguridad",
            keyword_length_100: "La longitud máxima de la palabra clave es de 100 caracteres",
            scope: "Ámbito: ",
            from: "De: ",
            to: "Para",
            subject: "Asunto: ",
            all: "Todos: ",
            from1: "De",
            select_date_and_time: "Seleccionar fecha y hora",
            searching: "Buscando...",
          },
          ask_pwd: {
            title: "Se requiere código de acceso",
            description:
              "El mensaje está cifrado y requiere un código de acceso para desbloquearlo, que se le enviará por SMS u otra vía de entrega segura según acuerdo previo. Si posee el código de acceso, haga clic en el botón a continuación para desbloquear el mensaje.",
            passcode_label: "Por favor, ingrese el código de acceso aquí",
            passcode_placeholder: "xxxx xxxx xxxx xxxx",
            next: "Siguiente",
            cancel: "Cancelar",
          },
          faucet: {
            title: "Activar cuenta autogestionada",
            message: {
              back: "Por favor, llene su billetera con suficientes criptomonedas antes de reanudar este proceso de configuración.",
            },
            content: {
              paragraph1:
                "Ha creado con éxito una billetera PlexiMail para mantener su identidad PlexiMail y ha adquirido su almacenamiento Web3. Ahora necesita registrar un conjunto seguro de parámetros de contacto a través del Contrato Inteligente PlexiMail para que sus socios puedan comunicarse con usted cuando lo permita. Además, todo su contexto de mensajería asíncrona se encapsulará en una base de datos de configuración, también almacenada en su almacenamiento Web3 y doblemente bloqueada. Para habilitar esta cuenta PlexiMail autogestionada, se le pedirá que:",
              paragraph2: {
                item0: "Fondee su billetera con criptomonedas si opta por registrarse con el Contrato Inteligente PlexiMail para maximizar la protección.",
                item1: "Proporcione las cerraduras dobles para proteger su configuración."
              },
              paragraph3: `Nota: PlexiMail es gratuito solo en el sentido de que este software PlexiMail se ofrece libremente para uso no comercial, pero los consumibles incurridos, como electricidad, potencia de cómputo, almacenamiento de disco tradicional, RAM, impresora, tinta, conectividad a Internet, etc., no lo son. Como una dApp Web3 que se ejecuta en la blockchain ${BLOCKCHAIN_NAME_CAMEL}, consume "${BLOCKCHAIN_NAME_CAMEL} gas", que es el cargo por parte de ${BLOCKCHAIN_NAME_CAMEL} por su consumo de sus recursos computacionales. La ejecución inicial del contrato inteligente cuesta gas y se evalúa un cargo nominal de $0.0001 por correo electrónico enviado para frustrar los DDOS cuando sea necesario.`,
            },
            button: {
              get_coins: "Entrar en el Contrato Inteligente",
              buy_with_ecash:
                "Activar el contrato con Plexi Tokens anonimizados",
              redeem_promo_code: "Activar el contrato con Código Promocional",
              buy: "Activar el contrato a través de un intercambio de criptomonedas",
              get: "Activar",
              email: "Activar enviando una solicitud",
              show_wallet: "Mostrar billetera",
            },
          },
          kickout: {
            title: "La aplicación ha sido reiniciada",
            message:
              "Dado que ya ha iniciado sesión en otro dispositivo, los datos en este dispositivo han sido borrados.",
            quit: "Salir",
          },
          af_faucet: {
            title: "Solicitar monedas de prueba",
            description:
              "Ingrese la dirección de correo electrónico para ver si califica para las monedas de prueba de inicio promocional de PlexiMail:",
            description2:
              "Se enviará un correo electrónico de confirmación al buzón ingresado para validar su dirección de correo electrónico.",
            email: "Dirección de correo electrónico",
            email_placeholder: "Por favor, ingrese el correo electrónico aquí",
            cancel: "Cancelar",
            request: "Solicitar",
            menu_item: "Obtener monedas de prueba con correo electrónico",
            note: "* Alternativamente, puede obtener monedas de prueba usted mismo directamente desde",
          },
          exit_setup: {
            title: "¿Está seguro de que desea salir del asistente de configuración?",
            message: "Este asistente comenzará de nuevo si sale.",
            cancel: "Cancelar",
            exit: "Salir",
          },
          promo_code: {
            title: "Canjear un código promocional",
            description: `Ingrese su código promocional de un solo uso (opcional) para probar con recursos externos de un pool compartido, como criptomonedas ${COIN_SYMBOL} para testnet y un token API para almacenamiento en la nube Web3, sin configurarlos usted mismo. Se aplican algunas restricciones.`,
            cancel: "Cancelar",
            redeem: "Canjear",
            waiting: "Esperando el recibo de la transacción ...",
            redeeming: "Canjeando código promocional ...",
            rejected: "La transacción ha sido rechazada",
            redeemed: "El código promocional ha sido canjeado.",
          },
          address_verify_popup: {
            verified: {
              title: "Verificado por ICP",
              message:
                "Se ha verificado que el destinatario posee la dirección PlexiMail registrada a través del Contrato Inteligente PlexiMail.",
              sender_message:
                "Se ha verificado que el remitente posee la dirección PlexiMail registrada a través del Contrato Inteligente PlexiMail.",
              self_message:
                'Su dirección PlexiMail está actualmente en el estado "Verificado por ICP", sin carga adicional para autenticarlo con las ventajas proporcionadas por el registro con el Contrato Inteligente PlexiMail.',
            },
            unverified: {
              title: "No verificado",
              message:
                "La propiedad de la dirección del destinatario no es verificable a través del Contrato Inteligente PlexiMail. ",
              sender_message:
                "La propiedad de la dirección del remitente no es verificable a través del Contrato Inteligente PlexiMail. ",
              self_message:
                'Su dirección PlexiMail está actualmente en el estado "No verificado", lo que impone una carga adicional a sus socios para autenticarlo sin las ventajas proporcionadas por el registro con el Contrato Inteligente PlexiMail.',
            },
            warning: {
              trigger: "Omitir Contrato Inteligente",
              confirmation: "Entiendo el riesgo",
              title: "Omitir Contrato Inteligente",
              message:
                "Puede almacenar su clave de identidad en la blockchain para reducir significativamente el riesgo de robo de identidad, aunque esto conlleva el costo asociado de aproximadamente $1 por registrarse a través del contrato inteligente en Avalanche. Siempre puede crear múltiples cuentas y elegir una opción separada para cada cuenta según su nivel de riesgo evaluado. ",
            },
          },
          activate_account: {
            trigger: "Registrarse con Contrato Inteligente",
            get_start: {
              title: "Registrarse",
              description: "No ha sido verificado para poseer la dirección PlexiMail registrándose con el Contrato Inteligente PlexiMail.",
              description_upgrade: "No ha sido verificado para poseer la dirección PlexiMail registrándose con el Contrato Inteligente PlexiMail en la Mainnet.",
              button: {
                cancel: "Cancelar",
                next: "Registrarse",
                upgrade: "Actualizar",
              },
            },
            select_network: {
              title: "Seleccionar Blockchain",
              description:
                "PlexiMail adopta el contrato inteligente autoejecutable para registrar y proteger las direcciones/identidades de PlexiMail. Una vez registradas, la autenticidad de una identidad PlexiMail se vuelve auditable sin una autoridad central y inalterable sin poseer la clave privada.",
              mainnet: "Mainnet",
              mainnet_note:
                "* Pague criptomonedas AVAX para registrar sus direcciones PlexiMail en la Mainnet de Avalanche.",
              testnet: "Testnet",
              testnet_note:
                "* Realice una prueba en la Testnet Fuji sin incurrir en cargos de AVAX. Sus direcciones PlexiMail no están completamente protegidas en este caso. Puede actualizar su ejecución a la Mainnet más adelante.",
              button: {
                back: "Atrás",
                next: "Siguiente",
              },
            },
            check_balance: {
              title: "Financiar el registro",
              message: {
                back: "Asegúrese de que su billetera esté llena con suficientes criptomonedas antes de reanudar este proceso de configuración.",
                no_enough_eth: `No hay suficiente ${COIN_SYMBOL} en su billetera para registrar su identidad con el Contrato Inteligente. Haga clic en "Comprar ${COIN_SYMBOL}" para recargar su billetera.`,
                ready:
                  'Haga clic en "Siguiente" para publicar su dirección PlexiMail con el Contrato Inteligente PlexiMail.',
              },
              description: {
                line1: "Para que sus socios puedan comunicarse con usted cuando lo permita y para una auditabilidad sin confianza, necesita registrar un conjunto seguro de parámetros de contacto a través del Contrato Inteligente PlexiMail.",
                line2: "Cuesta tarifas de transacción en criptomonedas registrar con el Contrato Inteligente para maximizar la protección de sus identidades PlexiMail."
              },
              button: {
                back: "Atrás",
                previous: "Anterior",
                next: "Siguiente",
                check: "Verificar saldo",
              },
              menu: {
                trigger: `Comprar ${COIN_SYMBOL}`,
                items: {
                  token: `Comprar ${COIN_SYMBOL} con Plexi tokens`,
                  exchange: `Comprar ${COIN_SYMBOL} con Exchange`,
                  email: "Solicitar moneda de prueba a través de correo electrónico",
                },
              },
            },
            save_idkey: {
              title: "Guardar clave de identidad a través del Contrato Inteligente",
              description: {
                line1: "Adoptamos el Protocolo Signal para proteger sus sesiones de comunicación de extremo a extremo. Sus direcciones PlexiMail están vinculadas a las claves privadas en su billetera en este paso, lo que genera un espectro completo de claves de sesión y otros parámetros de seguridad según las situaciones.",
                line2: `Es posible que deba firmar la transacción de confirmación emergente con claves de su billetera ${BLOCKCHAIN_NAME_CAMEL}.`
              },
              button: {
                previous: "Anterior",
                next: "Siguiente",
              },
            },
            wait_receipt: {
              title: "Esperando el recibo de la transacción",
              description: `Su dirección PlexiMail y los datos de sesión están protegidos en la Blockchain ${BLOCKCHAIN_NAME_CAMEL} a través de un Contrato Inteligente. Por favor, espere hasta que este proceso se complete.`,
              high_privacy_warning: `
                    Al hacer clic en "Hecho" se actualizará la página web. Dado que
                    la aplicación se está ejecutando actualmente en un nivel de privacidad alto,
                    solo podrá volver a esta cuenta a través de "Recuperación" después de
                    que la página web se haya recargado.`,
              button: {
                previous: "Anterior",
                next: "Hecho",
              },
              message: {
                checking: "Comprobando el recibo de la transacción... ",
                failed:
                  "No se pudo obtener el recibo de la transacción. Por favor, intente de nuevo más tarde.",
                confirmed: "La transacción ha sido confirmada",
              },
            },
          },
          indexeddb: {
            tor: {
              title: "El navegador Tor aún no es compatible",
              description: `PlexiMail no puede ejecutarse en el navegador Tor porque no
                  soporta indexeddb por defecto. Si desea obtener la privacidad que ofrece
                  el navegador Tor, se recomienda visitar PlexiMail en `,
              brave: "Brave"
            },
            normal: {
              title: "El navegador actual aún no es compatible",
              description: `PlexiMail no puede ejecutarse en el navegador actual porque no
                  soporta indexeddb. Se recomienda visitar PlexiMail en `,
              chrome: "Chrome"
            },
          },
          privacy_level: {
            title: "Nivel de privacidad",
            description:
              "La usabilidad y la privacidad a menudo implican un compromiso, ya que medidas de privacidad más altas pueden resultar en una experiencia menos amigable para el usuario. Ofrecemos dos niveles de privacidad para adaptarse a diferentes preferencias:",
            tor_warning: 'El navegador Tor solo soporta el nivel "Alto" de privacidad',
            normal_warning:
              'El navegador actual solo soporta el nivel "Alto" de privacidad.',
            level: {
              standard: {
                title: "Estándar",
                description:
                  "Los datos generados por PlexiMail se cifrarán y almacenarán en la base de datos incorporada del navegador, persistiendo hasta que el usuario salga.",
              },
              high: {
                title: "Alto",
                description:
                  "Los datos generados por PlexiMail solo existirán en la memoria en tiempo de ejecución.",
              },
            },
            error: {
              cancelled: "Cancelado",
            },
            button: {
              cancel: "Cancelar",
              confirm: "Confirmar",
            },
          },
        },
      },
      home: {
        help: "Ayuda",
        tab: {
          "individual": "Individual",
          "business": "Empresarial"
        },
        promotion: {
          title: "Flujo de trabajo de firma digital usando correo web",
          content: {
            paragraph1: " - Seguro",
            paragraph2: " - Profesional",
            paragraph3: " - Asequible",
            paragraph4: " - Código abierto y siempre gratuito **",
          },
        },
        signIn: {
          title_1: "El",
          zero: "correo",
          title_2: "Electrónico Sin Rastro",
          description_1:
            "Distribuido, sin permisos, sin rastros e invisible. ",
          description_2: `Solo puede comunicarse con sus socios en la misma red. El valor predeterminado es "${DEFAULT_NET_NAME}", una red de prueba que se muestra en la esquina superior derecha. Puede cambiar su red a "${MAINNET_NAME}", la red principal de blockchain pública de ${BLOCKCHAIN_NAME_CAMEL}, o cualquier otra red de prueba listada.`,
          description_3:
            "Inicie sesión o regístrese para obtener una nueva identidad PlexiMail. Esta tecnología segura y anonimizada protege sus direcciones PlexiMail y claves privadas en la blockchain transparente y segura de ICP. Además, minimiza los rastros de datos ocultando todos los metadatos, reforzando un fuerte anonimato para la comunicación privada.  ",
          description_3_continue:
            "Generar una nueva cuenta/dirección PlexiMail o importarla desde otra billetera implica múltiples pasos. Por favor, responda pacientemente a las indicaciones hasta su finalización.  ",
          note: {
            text: "** Presione \"Entrar\" a continuación solo si está de acuerdo con los ",
            link: "Términos y Política de Privacidad de PlexiMail"
          },
          note_continue: {
            text: `** Presione "Continuar" a continuación solo si está de acuerdo con los`,
            link: "Términos y Política de Privacidad de PlexiMail"
          },
          button: "Entrar con Internet Identity",
          one_click_resume: "Reanudar con 1 clic",
          try_live_demo: `Probar demo en vivo (${TESTNET_NAME})`,
          reset: "Comenzar de nuevo",
          resume: "Reanudar con Internet Identity",
          continue: "Continuar con Internet Identity",
          incomplete_setup_detected:
            "Su sesión de configuración anterior no se completó. ¿Recuperarla o comenzar de nuevo?",
          switch_wallet: "Cambiar cuenta",
        },
        business: {
          title_1: "El",
          zero: "Negocio",
          title_2: "Del Cero Rastro",
          description_1:
            "Soluciones simples y cifradas para proteger su negocio.",
          description_2:
            "Protección avanzada para los correos electrónicos, calendarios, contraseñas, red y más de su empresa con nuestro conjunto de aplicaciones seguras para negocios.",
          
          note: {
            text: "** Presione \"Entrar\" a continuación solo si está de acuerdo con los ",
            link: "Términos y Política de Privacidad de PlexiMail"
          },
          note_continue: {
            text: `** Presione "Continuar" a continuación solo si está de acuerdo con los`,
            link: "Términos y Política de Privacidad de PlexiMail"
          }
        },
        unlock: {
          title: "Desbloquear con contraseña",
          title_pin: "Desbloquear con código PIN",
          unlocking: "Desbloqueando...",
          idle_timeout: "Para desbloquear su sesión en caché después de un tiempo de inactividad",
          button: {
            unlock: "Desbloquear",
            forgot: "¿Olvidó el PIN o restablecer?",
            switch_wallet: "Cambiar cuenta",
          },
        },
        dialog: {
          reset: {
            title: "Olvidó el PIN",
            content: {
              paragraph1:
                "Su contexto de correo electrónico anterior mantenido localmente solo es recuperable con el PIN correcto.",
              paragraph2:
                'Presione "Restablecer" para borrar la caché local y volver a entrar con sus claves Crypton. Una nueva entrada permite restablecer el código PIN.',
            },
            button: {
              cancel: "Cancelar",
              reset: "Restablecer",
            },
            message: {},
          },
          unsupported: {
            title: browserName + " aún no es compatible",
            content: {
              paragraph1: "Solo se admiten los siguientes navegadores ahora:",
              paragraph2: "Brave (Recomendado)",
              paragraph3: "Chrome",
              paragraph4: "Edge",
              paragraph5: "Firefox",
            },
            button: {},
          },
          notReady: {
            title: "PlexiMail requiere MetaMask y Web3Storage",
            content: {
              paragraph1:
                "Está a punto de ingresar a PlexiMail, la dApp de correo electrónico seguro más avanzada, habilitada por el advenimiento de la tecnología Blockchain. Primero debe instalar una billetera de criptomonedas (MetaMask) y hacer disponible cierta cantidad de almacenamiento en la nube (Web3Storage).",
              paragraph2:
                "NOTA: Tanto MetaMask como Web3.Storage son servicios Web3 de código abierto bien confiables. Dudamos en integrarlos en nuestra línea base de PlexiMail para evitar enturbiar el agua de su confiabilidad. También son una introducción ideal al valiente nuevo mundo de las dApps Web3. Por favor, regrese aquí para probar su PlexiMail gratuito después de la instalación exitosa.",
              paragraph3:
                "Puede omitir este tutorial si es un practicante experimentado de web3, de lo contrario, le aconsejamos que lo lea.",
            },
            button: {
              skip: "Omitir tutorial",
              read: "Leer tutorial",
            },
          },
          walletNotFound: {
            title: "Billetera MetaMask no encontrada",
            content: {
              paragraph1: `Las direcciones PlexiMail se convierten de sus claves públicas asociadas con sus cuentas ${BLOCKCHAIN_NAME_CAMEL}, gestionadas conjuntamente con la billetera MetaMask. Debe fondear esas cuentas con criptomonedas, ya que la lógica de correo electrónico realizada a través del Contrato Inteligente PlexiMail incurre en cargos en tokens ${COIN_SYMBOL}. Todas las transacciones a través del Contrato Inteligente requieren su confirmación ("Confirmar" o "Firmar") en la aplicación MetaMask. Usted y sus socios pueden seleccionar una de las redes de prueba para practicar, expandiendo la red predeterminada que se muestra en la esquina superior derecha de MetaMask y habilitando "Mostrar/ocultar redes de prueba". Sugerimos ${TESTNET_NAME} para pruebas. Vaya a ${FAUCET_URL} para solicitar monedas de prueba. `,
            },
            button: {
              read: {
                title: "Leer tutorial",
              },
              install: {
                title: "Instalar MetaMask",
                confirm: {
                  title: "Instalar MetaMask",
                  content:
                    "Por favor, actualice esta página web para proceder al siguiente paso después de la instalación de MetaMask",
                  button: "Instalar MetaMask",
                },
              },
            },
          },
          confirm: {
            checkbox: {
              title:
                "Estoy a punto de pausar y cambiar a una aplicación externa temporalmente. Puedo volver para reanudar este proceso de configuración.",
            },
            cancel: "Cancelar",
          },
          tutorial: {
            slide1: {
              title: "PlexiMail",
              subtitle: "Una dApp de correo electrónico seguro Web3",
              content: {
                paragraph1_1:
                  "PlexiMail es una dApp Web3 (aplicación descentralizada). Esta es solo una de las aplicaciones Web3 que ofrecemos. Por favor, visite ",
                paragraph1_2: " para nuestra aplicación móvil Counterseal, o ",
                paragraph1_3: " para el fondo general sobre nosotros.",
                paragraph2:
                  'Un escrito más largo y detallado se puede encontrar haciendo clic en el cuadro "?" en la esquina inferior derecha de la pantalla.',
              },
              button: {},
            },
            slide2: {
              title: `Si no estás pagando, eres el producto.`,
              content: {
                paragraph1:
                  "Web2 se refiere a la versión de Internet que la mayoría de nosotros conocemos hoy, dominada por empresas que proporcionan servicios gratuitos a cambio de nuestros datos personales. Los términos del intercambio suelen estar envueltos en un lenguaje arcano para satisfacer los requisitos legales mínimos. Nuestros datos personales se recopilan a través de una tecnología de vigilancia sofisticada que no conoce límites y no deja rastros. Todos los servicios gratuitos populares, como Facebook, Twitter, Google, Outlook, WeChat, Telegram, etc., son ejemplos principales de aplicaciones Web2 profundamente arraigadas en el Capitalismo de Vigilancia. Es un modelo de \"granja de ganado\" diseñado para un onboarding suave y posterior explotación de los desprevenidos. Nos están convirtiendo involuntariamente en productos ante nuestros propios ojos.",
              },
              button: {},
            },
            slide3: {
              title: "Capitalismo de Vigilancia",
              content: {
                paragraph1:
                  "Web3 surge de la escalofriante realización de que estamos siendo arreados como ganado para los beneficios financieros de esos grandes tecnológicos de Web2. Ninguna cantidad de regulaciones de privacidad nos salvará de sus prácticas depredadoras. No hay alternativa sino rebelarse contra este entorno represivo de \"granja de ganado\" que subyace en Internet en general. Necesitamos un nuevo comienzo. Así es como surgió el marco Web3, impulsado por la tecnología Blockchain y el almacenamiento en la nube tokenizado. ",
              },
              button: {},
            },
            slide4: {
              title: "No más feeds gratuitos",
              content: {
                paragraph1:
                  "Una cosa es segura, \"vivir peligrosamente\" e independientemente fuera de la red de Web2 implica que los individuos deben involucrarse más. Como mínimo, tenemos que corregir nuestro concepto distorsionado de privacidad y seguridad supuestamente ofrecido por los proveedores de servicios, lo que nos obliga a educarnos sobre lo que realmente es la protección de seguridad. Luego nos enfrentamos a los problemas de recursos: ¿Cómo y dónde podemos obtener nuestro almacenamiento de datos, potencia de procesamiento y plataformas de servicio? Resulta que la ayuda está a la vuelta de la esquina.",
              },
              button: {},
            },
            slide5: {
              title: "Autosuficiencia bajo Web3",
              content: {
                table: "eliminado",
                paragraph1: `Destetados de esos servicios gratuitos, los elementos en rojo anteriores se convierten en su responsabilidad. Debe crear y proteger sus identidades digitales para ingresar al Contrato Inteligente en la blockchain ${BLOCKCHAIN_NAME_CAMEL}. Sus ID se derivan de sus direcciones de blockchain en su <strong>Billetera MetaMask</strong>, protegidas adicionalmente por una contraseña como segundo factor de seguridad. Posee su propio almacenamiento en la nube privado asignado por <strong>Web3Storage</strong>, un servicio de almacenamiento tokenizado ofrecido por Filecoin.`,
              },
              button: {},
            },
            slide6: {
              title: "ePostcard y Metadatos",
              content: {
                paragraph1:
                  "Bajo Web3, usted está a cargo de su propia identidad. Esto es importante porque los correos electrónicos tradicionales son como ePostcards, donde las identidades de todas las partes están al descubierto. Esto es problemático, particularmente porque las comunicaciones por correo electrónico a menudo involucran asuntos sensibles y privados. Además, los metadatos en sus correos electrónicos lo exponen a la explotación por parte de actores oscuros.",
              },
              button: {},
            },
            slide7: {
              title: "Anonimato y Privacidad",
              content: {
                paragraph1: `PlexiMail traduce sus direcciones ${BLOCKCHAIN_NAME_CAMEL} en direcciones PlexiMail con "${mailAddressSuffix()}" como nombre de dominio, protegidas por sus claves privadas almacenadas de forma segura en la <strong>Billetera MetaMask</strong> que solo posee el propietario que representan. Las identidades de los remitentes/destinatarios están así anonimizadas y no se relacionan con ninguna PII (Información Personalmente Identificable). Funcionalmente, están aseguradas por activos digitales autoemitidos/gestionados (par de claves en la billetera) como certificados SSL. Estas direcciones PlexiMail algo engorrosas se pueden gestionar mejor agregándolas a sus ‘Contactos’ existentes o nuevos. Tenga en cuenta que esos "Contactos" se mantienen localmente en el entorno del propietario y no se copian en el contenido del correo.`,
                paragraph2:
                  "NOTA: Incluso las direcciones de billetera se pueden anonimizar. Estaremos ofreciendo tal servicio.",
              },
              button: {},
            },
            slide8: {
              title: "Anonimato Garantizado",
              content: {
                paragraph1:
                  "Así es como se establece una sesión cifrada de extremo a extremo atravesando el <strong>Contrato Inteligente</strong> PlexiMail, el <strong>Registro y Notificador de Reenvío</strong> minimizado en confianza y el <strong>almacenamiento en la nube Web3Storage</strong> individualizado. Los detalles sangrientos están en la siguiente página.",
              },
              button: {},
            },
            slide9: {
              title: "Anonimato Garantizado",
              content: {
                paragraph1: `1. Alice y Bob registran sus direcciones desde sus billeteras y la selección del servidor desde múltiples servidores candidatos, a través del contrato inteligente PlexiMail en la blockchain ${BLOCKCHAIN_NAME_CAMEL}.`,
                paragraph2:
                  "2. Alice selecciona y prepara el almacén de preclaves en el servidor de registro seleccionado.",
                paragraph3:
                  "3. Alice/Bob intercambian privadamente sus direcciones PlexiMail \"fuera de banda\" en preparación para el proceso TOFU (Confianza en el Primer Uso) de persona a persona más adelante, que vincula sus identidades con sus respectivas direcciones sigilosas.",
                paragraph4: `4. Antes de que Bob envíe un correo a Alice por primera vez, recupera todos los datos relevantes sobre Alice del almacén de datos ${BLOCKCHAIN_NAME_CAMEL} y el Registro. Luego, negocia asincrónicamente una sesión de cifrado Signal de extremo a extremo con Alice, quien no necesita estar en línea.`,
                paragraph5:
                  "5. Bob coloca el contenido de su correo en su propio almacenamiento privado Web3Storage y envía su notificación a Alice, con la clave de descifrado autorizada solo para Alice.",
                paragraph6:
                  "6. Al recibir la notificación, Alice recupera el contenido del almacenamiento privado de Bob. Descifra el contenido solo después de verificar los diversos parámetros TOFU.",
              },
              button: {},
            },
            slide10: {
              title: "Costo de funcionamiento",
              subtitle: "Un servicio de correo electrónico seguro Web3",
              content: {
                paragraph1: `PlexiMail es una aplicación gratuita, pero sus consumibles operativos, como electricidad, potencia de cómputo, almacenamiento de disco tradicional, RAM, impresora, tinta, conectividad a Internet, etc., no lo son. Como una dApp Web3 que se ejecuta en ${BLOCKCHAIN_NAME_CAMEL}, consume "${BLOCKCHAIN_NAME_CAMEL} gas", que es el cargo por parte de la blockchain ${BLOCKCHAIN_NAME_CAMEL} por su consumo de sus recursos computacionales. La configuración inicial cuesta gas y se evalúa un cargo extremadamente nominal de $0.0001 por correo electrónico enviado para frustrar los DDOS. Tenga en cuenta que no hay cargo adicional por contenido de gran tamaño (por ejemplo, correos electrónicos y adjuntos tan grandes como 1 GB).`,
              },
              button: {},
            },
            slide11: {
              title: "Obtenga su propia billetera y Web3Storage",
              content: {
                paragraph1:
                  "Esperamos que ahora tenga una mejor comprensión del marco PlexiMail. Para obtener PlexiMail ++, instale MetaMask y solicite el almacenamiento en la nube Web3 desde el sitio Web3storage, como se indica en las siguientes páginas. ",
              },
              button: {},
            },
            slide12: {
              title: "",
              content: {
                paragraph1: `PlexiMail utiliza su propio almacenamiento privado Web3.Storage para su repositorio de correo electrónico. En el pasado, almacenar datos en la web descentralizada no siempre era fácil, pero ahí es donde entra web3.storage. La mayoría de los datos en Internet hoy en día están alojados por proveedores de almacenamiento masivos como Amazon, Google y Microsoft. Esto facilita a los desarrolladores almacenar datos de aplicaciones, pero plataformas corporativas grandes como estas crean silos al encerrar a los desarrolladores y usuarios por igual en jardines amurallados de servicios. Además, a medida que el mercado continúa consolidándose, una pequeña oligopolia de proveedores se está convirtiendo esencialmente en la columna vertebral de almacenamiento de Internet. `,
                paragraph2:
                  'Obtenga sus primeros 5 GB gratis haciendo clic en el botón "Obtener" a continuación. Extraiga la "Cuenta" -> "<strong>Token API</strong>" de su panel de Web3Storage cuando haya terminado y regrese aquí para prepararse para la configuración de PlexiMail más adelante.',
              },
              button: {
                get: {
                  title: "Obtener Web3.Storage",
                  confirm: {
                    title: "Obtener Web3.Storage",
                    content:
                      "Por favor, regrese aquí después de adquirir con éxito su almacenamiento privado Web3.Storage.",
                    button: "Obtener Web3.Storage",
                  },
                },
              },
            },
            slide13: {
              title: "",
              content: {
                paragraph1_1: `Para usar PlexiMail, necesita establecer al menos una identidad digital y realizar un registro sin confianza a través de nuestro contrato inteligente ${BLOCKCHAIN_NAME_CAMEL}, lo que requiere que instale la extensión de billetera MetaMask a través de su navegador. Siga nuestro`,
                paragraph1_2: ` para aprender más sobre las diversas opciones de red ${BLOCKCHAIN_NAME_CAMEL} y cómo fondear su billetera (faucets). Si desea practicar con una red de prueba, expanda la red predeterminada que se muestra en la esquina superior derecha de MetaMask y habilite "Mostrar/ocultar redes de prueba". Sugerimos ${DEFAULT_NET_NAME} para pruebas. Vaya a ${FAUCET_URL} para solicitar monedas de prueba. Haga clic en el cuadro "Instalar MetaMask" a continuación para instalar MetaMask. `,
              },
              button: {
                install: {
                  title: "Instalar MetaMask",
                  confirm: {
                    title: "Instalar MetaMask",
                    content: "Por favor, regrese aquí después de la instalación de MetaMask.",
                    button: "Instalar MetaMask",
                  },
                },
              },
            },
            slide14: {
              title: "Felicidades",
              content: {
                paragraph1:
                  "Si MetaMask ha sido instalado y Web3Storage adquirido con éxito, ahora está listo para usar PlexiMail. Haga clic en el cuadro verde a continuación para configurar PlexiMail. ",
              },
              button: {
                config: {
                  title: "Configurar PlexiMail",
                },
              },
            },
          },
        },
      },
      setup_carousel: {
        go: "GO",
        intros: [{
          title: "Bienvenido a PlexiMail",
          text: "Estás a punto de registrarte en PlexiMail. Esto es lo que sigue...",
          steps: [
            "Crea tu Identidad en Internet",
            "Crea tu clave de acceso"
          ],
          text2: "Una forma segura y centrada en la privacidad para iniciar sesión en PlexiMail sin usar contraseñas ni compartir datos personales."
        }, {
          title: "Bienvenido a PlexiSign",
          text: "Estás a punto de registrarte en PlexiSign. Esto es lo que sigue...",
          steps: [
            "Crea tu Identidad en Internet",
            "Crea tu clave de acceso"
          ],
          text2: "Una forma segura y centrada en la privacidad para iniciar sesión en PlexiSign sin usar contraseñas ni compartir datos personales."
        }],
        cards: [
          {
            "title": "Monedero Blockchain Moderno",
            "text": "Tú eres el único que puede acceder y gestionar el contenido del monedero, que incluye tu Identidad de Internet ICP que te permite acceder al sistema de forma segura.",
            "image": "/bg.jpg"
          },
          {
            "title": "Protocolo Signal",
            "text": "Protocolo de cifrado ampliamente respetado para la comunicación que actualiza continuamente las claves de cifrado, haciendo que los intentos de vigilancia y descifrado sean extremadamente difíciles.",
            "image": "/bg.jpg"
          },
          // {
          //   "title": "Aprovecha el Almacenamiento Web3",
          //   "text": "Te permitimos gestionar tus datos tú mismo en una cuenta de almacenamiento Web3, limitando aún más el acceso a los datos con los que estás trabajando y compartiendo con otros.",
          //   "image": "/bg.jpg"
          // },
          {
            "title": "Identidad de Internet y Blockchain ICP",
            "text": "PlexiSign y PlexiMail son 'sin confianza' - Los servicios comerciales se llevan a cabo a través de contratos inteligentes, no a través de un tercero que está abierto a compromisos y trampas.",
            "image": "/bg.jpg"
          },
          {
            "title": "Incluye PlexiMail",
            "text": "Correo electrónico seguro en la blockchain para correos de red privada y puente de correo a todos los sistemas de correo electrónico estándar.",
            "image": "/bg.jpg"
          },
          {
            "title": "Incluye PlexiSign",
            "text": "Firma electrónica segura, profesional y asequible con un modelo de facturación de pago por uso.",
            "image": "/bg.jpg"
          },
          {
            "title": "Sin PII ni PCI",
            "text": "Nuestros sistemas no almacenan ninguna de tu Información de Identificación Personal (PII) ni datos de la Industria de Tarjetas de Pago (PCI), aumentando tu perfil de seguridad de datos.",
            "image": "/bg.jpg"
          },
          {
            "title": "Más allá de GDPR y CCPA",
            "text": "PlexiSign y PlexiMail no retienen los datos regulados por GDPR y CCPA, por lo que estás protegido contra el abuso de marketing.",
            "image": "/bg.jpg"
          }
        ]
      },
      setup_method: {
        title: "Reanudar o comenzar de nuevo una configuración",
        content: {
          paragraph1:
            'Seleccione "Reanudar" para continuar con la misma configuración o "Comenzar de nuevo" para crear una configuración completamente nueva para la misma billetera. ',
          paragraph2:
            "Por favor, asegúrese de entender que presionar el botón \"Comenzar de nuevo\" borrará todos sus correos electrónicos pasados.",
        },
        button: {
          create: {
            title: "Comenzar de nuevo",
          },
          restore: {
            title: "Reanudar",
          },
          back: {
            title: "Atrás",
          },
        },
      },
      backup_method: {
        title: "Respaldar datos de recuperación",
        content: {
          paragraph1:
            "Sus datos de PlexiMail se respaldan almacenando sus semillas de creación/recuperación raíz, con base en las cuales todos los datos de sesión y contenidos anteriores pueden recuperarse de su copia de seguridad anterior.",
          paragraph2:
            "Los datos de respaldo están completamente cifrados y están protegidos adicionalmente mediante el empleo de nuestras tecnologías Crypton (patente pendiente).",
          paragraph3:
            "La contraseña debe ser lo suficientemente fuerte para ser aceptada. Una frase de paso similar a una oración funciona bien.",
          paragraph4: "Pasos restantes: 4/4    ",
        },
        button: {
          web3: {
            title: "Almacenar en su Web3Storage",
          },
          local: {
            title: "Almacenar localmente",
          },
          back: {
            title: "Atrás",
          },
        },
      },
      restore_method: {
        title: "Recuperar datos de recuperación",
        content: {
          paragraph1:
            "Sus datos de PlexiMail se respaldan almacenando sus semillas de creación/recuperación raíz, con base en las cuales todos los datos de sesión y contenidos anteriores pueden recuperarse de su Web3Storage permanente.",
          paragraph2: "Pasos restantes: 3.",
        },
        button: {
          web3: {
            title: "Recuperar desde Web3.Storage",
          },
          local: {
            title: "Recuperar desde archivo local",
          },
          back: {
            title: "Atrás",
          },
        },
      },
      pwd: {
        override: {
          title: "Advertencia",
          message: "Este Crypton ya existe. ¿Desea sobrescribirlo?",
          button: {
            yes: "Sí",
            no: "No",
          },
        },
        initial: {
          step: "1 / 4: ",
          step_restore: "1 / 3",
          title: "Protegiendo su base de datos de configuración",
          recover_title: "Desbloquear su base de datos de configuración",
          content: {
            paragraph1_1:
              "Esta contraseña es para proteger su configuración de PlexiMail y el contexto completo de la sesión requerido para asumir su identidad PlexiMail en la gestión de todos sus correos electrónicos. Asegúrese de registrar: 1) correo electrónico utilizado con Magic.Link 2) correo electrónico utilizado con Web3.Storage 3) esta contraseña. Son críticamente importantes para la copia de seguridad y recuperación de PlexiMail.",
            paragraph1_2: "Por favor, ingrese la contraseña de protección.",
            paragraph2:
              "La contraseña debe ser lo suficientemente fuerte para ser aceptada. Una frase de paso lo suficientemente larga similar a una oración funciona bien.",
          },
          tf: {
            pwd: {
              title: "Contraseña",
            },
            confirm: {
              title: "Confirmar contraseña",
            },
          },
          button: {
            next: {
              title: "Siguiente",
            },
            back: {
              title: "Atrás",
            },
          },
        },
      },
      mnemonic: {
        generate: {
          step: "2 / 4: ",
          title: "Construir la cadena de protección",
          content: {
            paragraph1: "",
            paragraph2: "",
          },
          message: {
            copied: "Copiado",
          },
          button: {
            display: { title: "Generar mnemónico" },
            hide: { title: "Ocultar mnemónico" },
            next: { title: "Siguiente" },
            gen: { title: "Generar" },
            gen_save: { title: "Generar" },
            back: { title: "Atrás" },
          },
        },
        restore: {
          step: "2 / 3: ",
          title: "Restaurar la cadena de protección",
          content: {
            paragraph1: "",
            paragraph2: "",
            paragraph3:
              "Haga clic en el contenido mnemónico anterior para copiarlo a su portapapeles.",
          },
          mnemonic: {
            label: "Frase mnemónica",
            placeholder: "Frase mnemónica para recuperación",
          },
          button: {
            next: { title: "Siguiente" },
            web3: { title: "Restaurar desde Web3.Storage" },
            local: { title: "Restaurar desde archivo local" },
            back: { title: "Atrás" },
          },
        },
      },
      web3: {
        storage_selector: {
          title: "Configurar su almacenamiento privado Web3",
          recover_title: "Recuperar su almacenamiento privado Web3",
          content: {
            line1: `Ahora, tome el control de su privacidad de correo electrónico. Configure su propio repositorio de correo electrónico privado, libre de cualquier riesgo de vigilancia asociado con algunos proveedores de correo electrónico.`,
            line2:`En el pasado, gestionar privadamente sus propios datos en la web descentralizada era desafiante. Sin embargo, Filecoin ha surgido como una solución, permitiendo una variedad de servicios front-end. Estos servicios cada uno soporta modelos de aplicación específicos y ofrece opciones de suscripción. Actualmente ofrecemos dos de estos servicios:`,
            line3: `Ofrece 1GB de almacenamiento gratuito como plan inicial, sin requerir información de tarjeta de crédito.`,
            line4: `Ofrece 5GB de almacenamiento gratuito como plan inicial, pero{" "}`,
            line5: `requiere información de tarjeta de`,
            line6: `crédito para suscribirse. Este servicio también utiliza correos electrónicos públicos para la autenticación del usuario.`,
            line7: `Visite sus sitios web para comparar opciones y elegir el mejor proveedor para sus necesidades. Tenga en cuenta que se aplican cargos adicionales después de exceder el límite de almacenamiento gratuito. Configurar Lighthouse requiere información de tarjeta de crédito solo si elige exceder el nivel gratuito.`
          },
          lighthouse: "Lighthouse",
          web3storage: "Web3.Storage",
          sharedWeb3storage: "Web3.Storage compartido",
          back: "Atrás",
        },
        lighthouse: {
          step: "1 / 2:",
          title: "Configurar su almacenamiento privado Lighthouse",
          content: `¡Confirme su selección del plan de almacenamiento gratuito de Lighthouse! Este almacenamiento está vinculado de forma única y anónima a su billetera PlexiMail. Solo necesitará proporcionar información de pago si elige actualizar más allá del nivel gratuito.`,
          auth: "Contactando con Lighthouse...",
          import: {
            title: "",
            message: {
              ready: "",
              recover_web3: "Recuperando configuración de almacenamiento Lighthouse...",
              retrieve_folder: "Recuperando correos de almacenamiento Lighthouse...",
              recover_signal: "Recuperando almacenamiento del protocolo Signal...",
              completed: "¡Completado!",
            },
            content: {
              paragraph1: "Por favor, seleccione un archivo de configuración",
            },
            button: {
              import: { title: "Importar desde archivo guardado" },
              import_phone: { title: "Importar desde su teléfono" },
              back: { title: "Atrás" },
            },
          },
        },
        w3ui: {
          step: "1 / 2:",
          title: "Configurar su almacenamiento privado Web3",
          content: `¡Buen trabajo al crear con éxito su dirección PlexiMail protegida por su billetera Ai-Fi! Ahora es el momento de adquirir y configurar su propio repositorio de correo electrónico privado sin depender de ningún proveedor de correo electrónico. En el pasado, almacenar datos en la web descentralizada no siempre era fácil, pero ahí es donde entra web3.storage.`,
          note: "Se enviará un correo electrónico de confirmación a este buzón para su validación. Tómese un breve descanso aquí y cambie a su cliente de correo electrónico para responder al correo electrónico de verificación haciendo clic en 'Verificar dirección de correo electrónico', enviado por web3.storage. Si se le solicita, puede registrarse con una tarjeta de crédito, pero siéntase libre de elegir la opción Gratuita inicialmente. Web3.Storage es el proveedor de almacenamiento Web3 más establecido con un riesgo mínimo para su tarjeta de crédito. Después de la verificación, continúe con el proceso de configuración.",
          verify: {
            title: "Verificando su dirección de correo electrónico...",
            message_1:
              "Por favor, tómese un breve descanso aquí y cambie a su cliente de correo electrónico en",
            message_2:
              "para responder al correo electrónico de verificación para iniciar sesión.",
            message_3: "Puede solicitar un reenvío en",
            message_4: "segundos.",
            message_5: "REENVIAR",
            message_6: "si no tiene éxito.",
          },
          shared: {
            config_storage: "Configurando almacenamiento ...",
          },
        },
        config: {
          step: "3 / 4: ",
          step_restore: "Final: ",
          title: "Su almacenamiento, sus reglas",
          recover_title: "Recuperar almacenamiento Web3",
          content: {
            paragraph1_1: "Visite",
            paragraph1_2:
              " para adquirir su almacenamiento privado Web3. Después de finalizar la configuración de la cuenta Web3, haga clic en el botón \"Cuenta\" en la parte superior derecha de la página web3.storage y seleccione \"Tokens API\" para copiar la cadena larga del token. ",
            paragraph1_3:
              "El \"Token API\" de su Web3Storage se ha llenado automáticamente con datos recuperados de su base de datos de configuración. Hay una pequeña posibilidad de que haya sido invalidado por su proveedor de almacenamiento Web3. Si el botón \"Siguiente\" a continuación devuelve un error, vuelva atrás y obtenga un nuevo token recuperando su cuenta Web3. (Haga clic en el botón \"Cuenta\" en la parte superior derecha de la página de la cuenta web3.storage y seleccione \"Tokens API\" para copiar la cadena larga del token.)",
            paragraph2:
              "Pegue su token de almacenamiento Web3 aquí para que PlexiMail pueda localizar su almacenamiento privado.",
            tokenTextField: {
              placeholder: "Ingrese el token API de almacenamiento Web3 aquí",
            },
            paragraph3:
              "Todos sus datos de PlexiMail se almacenan en su propio espacio de almacenamiento privado adquirido de Web3Storage. Aunque está a la vista, es virtualmente anónimo y está completamente cifrado a través de claves dinámicas de su propia billetera con una fuerza equivalente a cualquier clave de transacción de blockchain pública. ",
            invalid_token:
              "Formato de token API incorrecto. Verifique y asegúrese de que la cadena completa se haya copiado.",
            as_default: "Como almacenamiento predeterminado",
          },
          button: {
            next: { title: "SIGUIENTE" },
            back: { title: "Atrás" },
          },
        },
        import: {
          title: "",
          message: {
            ready: "",
            recover_web3: "Recuperando configuración de Web3.Storage...",
            retrieve_folder: "Recuperando correos de Web3.Storage...",
            recover_signal: "Recuperando almacenamiento del protocolo Signal...",
            completed: "¡Completado!",
          },
          content: {
            paragraph1: "Por favor, seleccione un archivo de configuración",
          },
          button: {
            import: { title: "Importar desde archivo guardado" },
            import_phone: { title: "Importar desde su teléfono" },
            back: { title: "Atrás" },
          },
        },
        mnemonic_recover: {
          title: "Recuperar billetera desde frase mnemónica",
          token: {
            label: "Token API de Web3.Storage",
            placeholder: "Token API de almacenamiento Web3",
          },
          mnemonic: {
            label: "Frase mnemónica",
            placeholder: "Frase mnemónica para recuperación",
          },
          button: {
            close: { title: "Cerrar" },
            recover: { title: "Recuperar" },
          },
          trigger: { title: "Recuperación desde mnemónico" },
        },
      },
      signal: {
        initial: {
          step: "Final: ",
          title: "Preparar tiempo de ejecución de Signal",
          content: {
            paragraph1:
              "¡Hurra por configurar su almacenamiento web3 con éxito! Adoptamos el Protocolo Signal para proteger sus sesiones de comunicación de extremo a extremo. Sus direcciones PlexiMail están vinculadas a las claves privadas en su billetera en este paso, lo que genera un espectro completo de claves de sesión y otros parámetros de seguridad según las situaciones.",
            paragraph2: `Por favor, prepárese para permitir la firma de la transacción de confirmación con claves de su billetera ${BLOCKCHAIN_NAME_CAMEL} (si se solicita).`,
            paragraph3:
              "Aprenda más sobre Open Whisper Systems y el Protocolo Signal.",
          },
          button: {
            next: { title: "PROCEDER" },
            back: { title: "Atrás" },
          },
        },
      },
      export: {
        default: {
          step: "Paso 7: ",
          title: "Respaldar configuración de PlexiMail",
          content: {
            paragraph1:
              "Su configuración de sesión de PlexiMail y los materiales generadores de claves se mantienen en su navegador como \"Cookies y otros datos del sitio\" en la configuración de \"Privacidad y seguridad\", que pueden borrarse accidentalmente. Para facilitar la recuperación, estos datos de configuración pueden respaldarse/exportarse aquí para recuperar sus sesiones establecidas. Tenga en cuenta que su identidad o dirección PlexiMail está protegida por separado a través de un mecanismo de frase de paso más estricto. ",
          },
          button: {
            export: { title: "EXPORTAR CONFIGURACIONES" },
            back: { title: "Atrás" },
          },
        },
      },
      wait: {
        default: {
          title: "Esperando el recibo de la transacción...",
          content: {
            paragraph1: `Su dirección PlexiMail y los datos de sesión están protegidos en la Blockchain ${BLOCKCHAIN_NAME_CAMEL} a través de un Contrato Inteligente. Por favor, espere hasta que este proceso se complete.`,
            paragraph2: "Comprobando el recibo de la transacción... ",
            paragraph3:
              "No se pudo obtener el recibo de la transacción. Por favor, intente de nuevo más tarde.",
            paragraph4:
              "La transacción ha sido confirmada, Entrando automáticamente a PlexiMail en 10 segundos... ",
          },
          button: {
            enter: { title: "Entrar a PlexiMail" },
            retry: { title: "Reintentar" },
            back: { title: "Atrás" },
          },
        },
      },
      on_click_create: {
        title: "Crear con 1 clic",
        loading: "La cuenta recién creada se está inicializando",
        description:
          "La mayoría de las veces, cuando los usuarios restauran PlexiMail, todavía usarán la configuración anterior. Seguir los pasos normales del proceso de recuperación es muy engorroso. Reanudar con 1 clic proporciona un atajo para este escenario.",
        note: "* Si el nivel de privacidad no es consistente con la plataforma actual en ejecución, se modificará para adaptarse al nuevo entorno.",
        button: {
          back: "Atrás",
          retry: "Reintentar",
        },
      },
      one_click_resume: {
        title: "Reanudar con 1 clic",
        description:
          "La mayoría de las veces, cuando los usuarios restauran PlexiMail, todavía usarán la configuración anterior. Seguir los pasos normales del proceso de recuperación es muy engorroso. Reanudar con 1 clic proporciona un atajo para este escenario.",
        note: "* Si el nivel de privacidad no es consistente con la plataforma actual en ejecución, se modificará para adaptarse al nuevo entorno.",
        button: {
          back: "Atrás",
          retry: "Reintentar",
        },
      },
      one_click_create: {
        title: "Crear con 1 clic",
      },
      main: {
        title: "PlexiMail",
        sidebar: {
          create: "Crear carpeta",
        },
        profile: {
          addresses: "Direcciones",
          exit: "Salir",
          terms_and_privacy: "Términos y privacidad",
          copied: "Copiado",
          hello: "Hola",
        },
        menu: {
          apps_section: "Apps",
          account_section: "Mi cuenta",
          global_section: "Global",
          operations_section: "Operaciones",
          wallet: "Billetera",
          settings: "Configuración",
          help: "Ayuda",
          buy_eth: "Comprar Eth",
          profile: "Direcciones",
          contacts: "Contactos",
          more: "Avanzado",
          tutorial: "Tutorial",
          sign_out: "Salir",
          switch_account: "Cambiar cuenta",
        },
        dialog: {
          pwa: {
            title: "PlexiMail puede ejecutarse como una aplicación web independiente",
            content: {
              paragraph1:
                "En lugar de ejecutarse en una pestaña del navegador, PlexiMail puede empaquetarse para ejecutarse en una ventana independiente, buscable y lanzable a través de su icono de aplicación dedicado en el escritorio, casi como una aplicación nativa. ",
            },
            button: {
              cancel: "Omitir",
              install: "Instalar PlexiMail",
            },
          },
          create_folder: {
            title: "Crear carpeta",
            content: {
              name: "Nombre: ",
              parent: "Debajo de: ",
            },
            button: {
              cancel: "Cancelar",
              save: "Guardar",
            },
            message: {
              folder_name_is_empty: "El nombre de la carpeta no puede estar vacío.",
              character_is_not_allowed: " no está permitido",
              folder_already_exists: " ya existe",
              folder_name_is_too_long: "El nombre de la carpeta tiene más de 128 caracteres.",
            },
          },
          sign_out: {
            title: "¿Está seguro de que desea salir de PlexiMail?",
            content: {
              paragraph1:
                "¡Todo su contexto de sesión en caché se borrará después de cerrar sesión!",
              paragraph2:
                'Para reconectarse a la sesión actual de PlexiMail, elija la opción "Recuperar" y luego "Reanudar" al volver a entrar.',
            },
            button: {
              cancel: "Cancelar",
              sign_out: "Salir",
            },
          },
        },
      },
      list: {
        welcome: {
          title: "Sin mensajes",
          sub_title: "Cierre el ciclo con PlexiMail Pro",
          description:
            "A pesar del aumento de la mensajería instantánea, SMS y redes sociales, el correo electrónico sigue siendo la herramienta de colaboración empresarial predominante. Desafortunadamente, la naturaleza no segura del correo electrónico expone información sensible a ataques maliciosos. Distinga su marca deteniendo la pandemia de phishing aparentemente imparable que erosiona su reputación. Cultive la confianza con sus clientes y asegure el cumplimiento de las regulaciones de privacidad utilizando PlexiMail Pro.",
          action: " Aprenda más",
        },
        includes_plexisign_messages: "Incluye mensajes PlexiSign"
      },
      previewer: {
        menu: {
          back: "Atrás",
          reply: "Responder",
          reply_all: "Responder a todos",
          forward: "Reenviar",
          move: "Mover",
          delete: "Eliminar",
          reload: "Recargar",
          actions: "Comportamiento"
        },

        send_date: "Fecha de envío: ",
        from: "De: ",
        to: "Para: ",
        cc: "Cc: ",
        bcc: "Bcc: ",
        subject: "Asunto: ",
        content: "Contenido: ",
        attachment: "Adjuntos: ",
        message: {
          attachment: {
            title: "Adjuntos",
            download: {
              downloading: "Descargando, por favor espere",
              is_in_progress: "Descarga en progreso",
              progress: {
                paragraph1_1: "Descargado ",
                paragraph1_2: " de ",
                paragraph2: "Descargado",
              },
            },
          },
          failed_to_load: "No se pudo cargar el mensaje",
          select_folder: "Por favor, seleccione una carpeta para mover",
          moving: "Moviendo...",
          deleting: "Deleting...",
          moved: "Movido",
          moved_to_trash: "Mensaje movido a la papelera",
          deleted: "Eliminado",
          tofu_changed:
            'La firma del remitente ha cambiado desde la última vez que correspondieron. Es posible que desee volver a autenticar al remitente (a través de un canal diferente). Presione "Confiar y descifrar" solo si todo está en orden.',
          tofu_new:
            'Esta es la primera vez que recibe PlexiMail de este remitente. Es posible que desee verificar la autenticidad del remitente (a través de un canal diferente). Presione "Confiar y descifrar" solo si todo está en orden.',
        },
        tofu: {
          verify: `PlexiMail adopta el mismo esquema de firma que 
              ${BLOCKCHAIN_NAME_CAMEL} y se basa en su Contrato Inteligente para
              autenticar a los usuarios registrados y soportar la auditabilidad en línea.`,
          steps: "",
          sender: "Remitente",
          idkey: "Clave de identidad",
          signature: "Firma",
          address: "Dirección",
          copied: "Copiado",
          verified: "",
          miss: "",
          correct: "Correcto",
          incorrect: "Incorrecto",
        },
        dialog: {
          add_contact: {
            title: "Agregar contacto",
            content: {
              name: "Nombre: ",
              email: "Dirección PlexiMail: ",
            },
            button: {
              cancel: "Cancelar",
              add: "Agregar",
            },
          },
          move_message: {
            title: "Mover mensaje",
            button: {
              cancel: "Cancelar",
              move: "Mover",
            },
          },
          cid_not_found: {
            title: "No se pudo descargar",
            message:
              "Debido al alto volumen de tráfico de PlexiMail, su solicitud de descarga no pudo ser atendida en este momento. Puede optar por reintentos continuos hasta que se complete, o volver más tarde para verificar nuevamente. Por favor, sea paciente, ya que el tiempo de espera es difícil de predecir. 10 ~ 20 min no es inusual. El récord mundial es de aproximadamente 3 horas.",
          },
        },
      },
      editor: {
        title: {
          new_message: "Nuevo mensaje",
          reply: "Responder",
          reply_all: "Responder a todos",
          forward: "Reenviar",
        },
        sent_by: "Enviado por PlexiMail",
        full_screen: "Pantalla completa",
        exit_full_screen: "Salir de pantalla completa",
        content: {
          pwd: {
            passcode: "Código de acceso",
            title: "Por favor, ingrese un código de acceso para cifrar este mensaje",
            description:
              "Contraseña requerida para enviar correos electrónicos cifrados a destinatarios que no sean de PlexiMail.",
            allow_reply: "Permitir que el destinatario responda",
            allow_reply_explain:
              " (La respuesta está permitida solo si hay un solo destinatario)",
            assist_account_creation:
              "Asistir al destinatario con un script de registro simplificado de PlexiMail.",
            cancel: "Cancelar",
            next: "Siguiente",
            passcode_less_than_128: "La contraseña debe tener menos de 128 caracteres",
            copied: "Copiado"
          },
          tofu: {
            message:
              "Esta es la primera vez que envía PlexiMail al(los) destinatario(s) listados al final. Es posible que desee verificar su autenticidad (a través de un canal diferente).",
            verify: `PlexiMail adopta el mismo esquema de firma que{" "}
                ${BLOCKCHAIN_NAME_CAMEL} y se basa en su Contrato Inteligente para
                autenticar a los usuarios registrados y soportar la
                auditabilidad en línea.`,
            title: "Destinatario(s) no confiable(s)",
            idkey: "Clave de identidad",
            signature: "Firma",
            address: "Dirección",
            copied: "Copiado",
            correct: "Correcto",
            incorrect: "Incorrecto",
          },
          editor: {
            from: {
              title: "De: ",
            },
            to: {
              title: "Para: ",
              placeholder: `p. ej. 0x0...000${mailAddressSuffix()} o nombre de Contactos (Requerido)`,
              placeholder_more: "Ingrese más destinatarios aquí",
              show_contact: "Seleccionar destinatario(s)",
            },
            subject: {
              title: "Asunto: ",
              placeholder: "",
            },
            content: {
              initial_content: "Enviado por PlexiMail",
            },
            attachment: {
              title: "Adjuntos",
            },
          },
          contacts: {
            title: "Seleccionar destinatario(s)",
            content: {
              search: "Buscar...",
              empty: "Sin contactos",
            },
            button: {
              confirm: "Confirmar",
            },
          },
        },
        message: {
          upload: {
            paragraph1_1: "Subiendo... (",
            paragraph1_2: " subido)",
            paragraph1_3: "Subiendo...",
            paragraph1_4: "Subido ",
            paragraph1_5: " de ",
            encrypting: "Cifrando...",
          },
          address: {
            invalid_addr_1: "La dirección anterior",
            invalid_addr_2:
              "no fue reconocida. Asegúrese de que todas las direcciones estén en el formato correcto.",
            invalid_eth:
              "No se puede enviar correo electrónico a buzones tradicionales y buzones PlexiMail al mismo tiempo.",
            invalid_normal:
              "No se puede enviar correo electrónico a buzones tradicionales y buzones PlexiMail al mismo tiempo.",
            multi_recps:
              "No se puede enviar correo electrónico a múltiples buzones tradicionales a la vez.",
          },
          sent: "¡Mensaje enviado!",
          restriction:
            "La función de puente es unidireccional y no acepta respuestas. ",
        },
        button: {
          add_attachment: {
            title: "",
            tips: "Agregar adjunto(s)",
          },
          send: {
            send: "Enviar",
            trust_and_send: "Confiar y enviar",
          },
        },
        unverified: {
          title: "Advertencia",
          description_1:
            'Su dirección PlexiMail está actualmente en el estado "Verificado por ICP", lo que impone una carga adicional a sus socios para autenticarlo sin las ventajas proporcionadas por el registro con el Contrato Inteligente PlexiMail.',
          description_2:
            'Para actualizar este estado, simplemente haga clic en la visualización del estado "Verificado por ICP" ubicada en la parte superior izquierda de la pantalla principal y siga las instrucciones proporcionadas. Alternativamente, puede actualizar su estado desde "Configuración".',
          description_3: "",
          dont_show_again: "No mostrar este mensaje de nuevo",
          next: "Siguiente",
        },
        save_draft: {
          title: "Guardar borrador",
          description:
            "Hemos detectado un borrador no enviado en el buffer. ¿Le gustaría guardarlo?",
          discard: "Descartar",
          save: "Guardar",
        },
        load_draft: {
          title: "Cargar borrador",
          description: "Hay una copia de borrador guardada previamente.",
          discard: "Descartar",
          recover: "Recuperar",
        },
      },
      settings: {
        account_title: "Avanzado",
        title: "Configuración",
        message: {
          cache_cleard: "Los datos en caché fueron borrados",
        },
        list: {
          export: {
            title: "Exportar configuraciones de configuración",
            description:
              "Las configuraciones de configuración ayudarán a recuperar sus PlexiMails después de cualquier evento de pérdida.",
          },
          mnemonic: {
            title: "Mostrar frase mnemónica",
            description:
              "Mostrar frase semilla para recuperar todos los materiales de claves de cifrado.",
          },
          privateKeys: {
            title: "Mostrar cuentas Lighthouse",
            description:
              "Mostrar cuentas Lighthouse para completar en la billetera Metamask.",
          },
          clear: {
            title: "Borrar datos en caché",
            description:
              "Para el rendimiento, todos los PlexiMails recibidos se almacenan en caché localmente. Pueden crecer excesivamente grandes.",
          },
          close: {
            title: "Cerrar su PlexiMail",
            description:
              "Todos los datos producidos por esta cuenta serán eliminados permanentemente del canister",
          },
          backup_wallet: {
            title: "Respaldar billetera",
            description: "",
          },
          change_w3s_api_token: {
            title: "Migrar a un almacenamiento Web3Storage diferente",
            description: "El espacio de almacenamiento se puede expandir de esta manera",
          },
          change_pin: {
            title: "Cambiar código PIN",
            description: "",
          },
          verify_sender: {
            title: "Mostrar nivel de riesgo del remitente del correo",
            description:
              "Evaluar y mostrar el nivel de riesgo del remitente del correo - esto puede afectar el rendimiento.",
          },
          upgrade: {
            title: "Registrarse con la blockchain PlexiMail",
            description:
              "Verificar y registrarse con el Contrato Inteligente PlexiMail. Esto incurrirá en cargos de contrato inteligente en AVAX.",
          },
        },
        dialog: {
          export_confirm: {
            title: "Seleccionar dónde exportar la configuración",
            content:
              'Presione "Exportar como archivo" para empaquetar la configuración como un archivo para descarga manual, o presione "Sincronizar con su teléfono" para cifrar y subir a su teléfono. ',
            button: {
              download: "Exportar como archivo",
              sync: "Sincronizar con su teléfono",
            },
          },
          sync: {
            title: {
              export: "Respaldar configuraciones de configuración en su teléfono móvil",
              import: "Importar configuraciones de configuración desde su teléfono móvil",
            },
            content: {
              paragraph1: "Escanear para conectarse a su teléfono",
              paragraph2: "Descargar e instalar la aplicación móvil",
            },
            button: {
              cancel: "Cancelar",
              done: "Hecho",
            },
          },
          mnemonic: {
            title: "Mostrar mnemónico",
            message: {
              copied: "Copiado",
            },
            content: {
              paragraph1:
                "Haga clic en el contenido mnemónico anterior para copiarlo a su portapapeles.",
              paragraph2: "El mnemónico es muy importante",
            },
            button: {
              hide: "Ocultar mnemónico",
              display: "Mostrar mnemónico",
              copy: "Copiar al portapapeles",
              close: "Cerrar",
            },
          },
          privateKeys: {
            title: "Mostrar cuentas Lighthouse",
            message: {
              copied: "Copiado",
            },
            content: {
              paragraph1: "Haga clic en el contenido anterior para copiarlo a su portapapeles.",
              paragraph2: "La cuenta es muy importante",
            },
            button: {
              hide: "Ocultar cuentas Lighthouse",
              display: "Mostrar cuentas Lighthouse",
              copy: "Copiar al portapapeles",
              close: "Cerrar",
            },
          },
        },
      },
      profile: {
        title: "Dirección",
        content: {
          copy: "Esta imagen QR representa su dirección PlexiMail, que está protegida por el código de acceso generado automáticamente debajo de ella. Por favor, tome una captura de pantalla o guarde la imagen QR como un archivo para compartir su dirección PlexiMail. Haga clic en el icono del ojo para ver y copiar el código de acceso generado automáticamente. Envíe el código de acceso de forma segura a su socio a través de un canal separado. Utilice dos canales independientes para la imagen QR y el código de acceso para garantizar una entrega segura.",
          note: "Por favor, mantenga el código de acceso oculto, si comparte su dirección tomando una captura de pantalla.",
        },
        message: {
          copied: "Copiado",
        },
        save: {
          title: "Guardar como un token de dirección",
          message:
            "Codifique su dirección PlexiMail en un archivo de código QR para pasárselo a sus amigos y socios.",
          checkbox: "Codificar el contenido del archivo con un código de acceso opcional.",
          input: "Por favor, ingrese un código de acceso aquí",
          button: { next: "Guardar", cancel: "Cancelar" },
        },
        button: {
          refresh: "Regenerar el código QR",
          copy: "Copiar dirección",
          close: "Cerrar",
          save: "Guardar como un token de dirección",
          back: "Atrás",
        },
        delete_address: "Eliminar Dirección",
        delete_address_confirmation: "¿Está seguro de que desea eliminar la siguiente dirección:",
        deleting_address: "Eliminando Direcciones ...",
        cancel: "Cancelar",
        delete: "Eliminar",
        empty_address: "La dirección no puede estar vacía",
        "name_contains_special_characters": "El nombre no puede contener caracteres especiales",
        add_incognito_address: "Agregar Dirección Anónima",
        add_normal_address: "Agregar Dirección Normal",
        generate_address_message: 'Se generará una dirección de PlexiMail anónima después de hacer clic en el botón "Agregar".',
        human_readable_address: "Dirección legible para humanos",
        saving_address: "Guardando Direcciones ...",
        add: "Agregar",
        loading_addresses: "Cargando Direcciones ...",
        refresh: "Actualizar",
        close: "Cerrar",
        my_addresses: "Mis Direcciones",
        new_incognito_address: "Nueva Dirección Anónima",
        new_normal_address: "Nueva Dirección Normal",
        label: "Etiqueta"
      },
      qrcode: {
        alert: {
          title: "Introduzca la dirección de PlexiMail",
          trigger: "Escanear",
          scan_message:
            "Presione \"Abrir\" para un archivo de imagen de código QR; \"Escanear\" si el código QR es legible a través de la cámara.",
          decode_message: "Presione \"Decodificar\" para decodificar el archivo seleccionado.",
          cancel: "Cancelar",
          decode: "Decodificar",
          next: "Siguiente",
        },
        pwd: {
          title: "Se requiere un código de acceso",
          message:
            "El código pasado fue cifrado para protección de privacidad. Por favor, ingrese el código de acceso de descifrado. Contacte al remitente para obtener uno si no lo tiene.",
          input: "Por favor, ingrese el código de acceso aquí",
          button: {
            cancel: "Cancelar",
            next: "Descifrar",
          },
        },
        zip: {
          title: "Se requiere una contraseña",
          message:
            "La contraseña pasada fue cifrada para protección de privacidad. Por favor, ingrese la contraseña de descifrado.",
          input: "Por favor, ingrese la contraseña aquí",
          button: {
            cancel: "Cancelar",
            next: "Abrir",
          },
        },
        scanner: {
          title: "Escanear código QR",
          message: "Por favor, apunte su cámara al código QR.",
          button: { cancel: "Cancelar" },
        },
        button: { open: "Abrir", scan: "Escanear" },
      },
      contacts: {
        title: "Contactos",
        editTitle: "Editar contacto",
        addTitle: "Nuevo contacto",
        previewTitle: "Contacto",
        content: {
          list: {
            search: {
              placeholder: "Buscar...",
            },
            new_contact: "Nuevo",
            add: "Agregar",
            import: "Importar",
            empty: "Sin contactos",
          },
          editor: {
            name: "Nombre: ",
            email: "Dirección PlexiMail: ",
            save: "Guardar",
            back: "Atrás",
            delete: "Eliminar",
          },
          preview: {
            name: "Nombre: ",
            email: "Dirección PlexiMail: ",
            back: "Atrás",
          },
        },
        message: {
          empty_name: "El nombre no puede estar vacío",
          empty_email: "La dirección PlexiMail no puede estar vacía",
          name_too_long: "El nombre no puede tener más de 128 caracteres",
          email_too_long: "La dirección PlexiMail no puede tener más de 256 caracteres",
          invalid_name: "El nombre no es válido",
          invalid_email: "La dirección PlexiMail no es válida",
          repeated: "Su dirección PlexiMail ya existe",
        },
      },
      buy_eth: {
        title: `Canjear Plexi Tokens por ${COIN_SYMBOL}`,
        head: "Plexi Tokens",
        status: {
          unused: "Sin gastar",
          redeemed: "Gastado",
          refunded: "Reembolsado",
        },
        messages: {
          no_ecash: "Sin Plexi Tokens",
          getting_current_price: `Obteniendo el precio actual de ${COIN_SYMBOL}...`,
          current_price_1: `Precio actual de ${COIN_SYMBOL}: $`,
          current_price_2: ` / ${COIN_SYMBOL}`,
          test_note: `Este es un proceso simulado para comprar Plexi Tokens para una testnet. La cantidad devuelta es fija en 0.01 ${COIN_SYMBOL} independientemente del valor nominal de las compras simuladas debido a nuestro suministro limitado de monedas de prueba.`,
        },
        qrcode: {
          title: `Comprar ${COIN_SYMBOL} con Plexi Tokens`,
          description: "",
        },
        table: {
          head: {
            col0: "",
            col1: "Plexi Token",
            col2: "Valor nominal ($)",
            col3: "Estado",
            col4: "Eliminar",
          },
          body: {
            empty_title: "La lista de tokens para canjear está vacía",
            empty:
              'Presione el botón "Escanear" para agregar Plexi Tokens a la lista de canje aquí',
          },
          foot: {
            prefix: "Total: $",
            suffix: ` ${COIN_SYMBOL}`,
          },
        },
        foot: {
          buy_ecash: "Comprar Plexi Tokens",
          buy_eth: "Canjear",
        },
      },
    },
  });

  window.localizedStrings = localizedStrings;
}

const detectLanguage = () => {
  const lang = navigator.language;
  // console.log("detectLanguage:", lang);
  if (lang.startsWith("zh")) {
    return "zh";
  } else if (lang.startsWith("en")) {
    return "en";
  } else if (lang.startsWith("es")) {
    return "es";
  } else {
    return "en";
  }
};

let lang = localStorage.getItem("language");
if (!lang || lang === "") {
  lang = detectLanguage();
}

if (lang !== "en" && lang !== "zh" && lang !== "es") {
  lang = "en";
}

window.localizedStrings.setLanguage(lang);

// window.localizedStrings.setLanguage("es");
const Strings = window.localizedStrings;
export default Strings;
